/* =====================================================================
   mk-portal-home.js  (Shopify theme asset)  -  window.MKPortalHome
   MK Supplements customer portal (Skio Customer Portal v3, /a/account/*)

   The redesigned subscriptions home (/a/account/subscriptions), approved
   mockups home.html + home-transit.html:
     Hello, <first name> / Member since <Mon YYYY> . N orders in a row
     #mk-delivery-banner-slot   (empty; the delivery module renders into it)
     NEXT ORDER card            date, schedule pill, IN THIS ORDER (+ Edit
                                products), prices, shipping, You save, Total,
                                "This order earns N points", Get it now /
                                Skip this order / Change date
     Your subscriptions         (round 2 B, DECISION_SUBS_LIST) every active and
                                paused subscription, the NEXT ORDER one
                                included, in Skio's card order: thumbnails,
                                names, schedule, next order date, status,
                                Manage; header link "All upcoming orders";
                                last line "Get both in one order . Review and
                                combine ->" (wording by case) only when the
                                Combine card would appear (DECISION_COMBINE_PROMPT)
     Change date                (r8, DECISION_DATE_POPUP) on the NEXT ORDER card and on each
                                subscription's next order in Upcoming orders opens the pop-up
                                "Move your <Oct 30> order" and saves in place with the core's
                                SECOND guarded write (MKPortal.changeNextOrderDate), only when the
                                core says that write is on (MKPortal.writeEnabled('next-date'):
                                MKPortalConfig.writes.nextDate === true) and Skio's own rules
                                allow it (MKPortal.nextDateEligible); else the hand-off below
     Add to your <date> order   (decision 8a, Skio's own one-time upsells); "Add" opens
                                the Add pop-up (batch 3, DECISION_ADD_POPUP): the core's
                                dialog + its one guarded write (MKPortal.addSubscriptionLine),
                                else the hand-off below
     YOUR REWARDS card          points, $ value, tier art, progress, Redeem,
                                See rewards
     DELIVERY AND PAYMENT card  Ships / To / Card / Saved so far ("For your
                                <date> order" with several subscriptions),
                                View order history, Manage subscriptions
                                (Skio's list)
   Upcoming orders screen (round 2 C): /a/account/subscriptions#upcoming. A
   screen of ours over the page (<section id="mk-upcoming"> first in Skio's
   authed-layout, html.mk-upcoming-open hides the rest, html[data-mk-screen]
   = 'upcoming' through MKPortal.screen): every scheduled order of every
   subscription, soonest first, dates from MKPortal.schedule (the delivery
   timeline's rule); Skip / Change date on each subscription's next order
   only (hand-off as below). Browser Back / Forward close and reopen it.
   "Add products" screen (r10, 1.3.0; approved design catalog-design/DESIGN-NOTES.md sections 3-11):
   /a/account/subscriptions#add-products, <section id="mk-catalog"> first in Skio's authed-layout,
   html.mk-catalog-open hides the rest, html[data-mk-screen] = 'add-products'. One screen at a time
   (opening it closes Upcoming orders and the other way round). Every product Skio's own "Add product"
   picker lets this customer add (Skio's add-mode query, read only through MKPortal.skioPages, 24 a page,
   at most 5 pages, cached 5 minutes, read on intent), A to Z, sold-out ones last and muted; search,
   category chips only from Skio collections flagged "Display on edit product", one card per product
   with the just-this-order / every-order price for the soonest eligible order and the points it earns.
   Eligible orders: isOpen && !needsAttention && not prepaid (prepaid, gift, digital and held ones are
   left out and named in the notes). Add opens the Add pop-up (the core's one guarded add-line write) or
   hands off to Skio's own picker on that subscription's page (boxes, prices this file cannot work out,
   a tier DISCOUNT reward). The pop-up (part 2) takes any eligible order: "Which order" first when two or
   more orders can take the product (the soonest chosen; the left-out ones named), a size already in the
   chosen order shown disabled ("In this order"), sizes / how often / prices / points / the charge line /
   the button worked out again for the order chosen; the write goes to the CHOSEN order only (its token is
   bound to it); success only after a re-read finds the new line in that order (found by id), then that
   order's total and points; the card says "Added to your <date> order", a strip names what was added and
   links to that order, and the start page is redrawn for whichever order changed. Off with the loader's
   mk_portal_catalog (MKPortal.catalogEnabled()) or DECISION_CATALOG.enabled: no screen, the menu hides
   the item, "See all products" hands off as in r9.1.
   Also, on every portal page: the hand-off consumer. A home action stores a
   one-shot intent in sessionStorage and loads the subscription page; there
   this file presses Skio's OWN control once (it opens Skio's own dialog) and
   never confirms anything.

   Loaded by snippets/mk-portal.liquid (defer, after mk-portal-core.js).
   Spec: mks-portal-build/spec/DATA-AND-DOM.md sections 6-10.

   RULES THIS FILE FOLLOWS
   - Gate: does nothing unless window.MKPortal is present and <html> has the
     class mk-portal-on.
   - Fail closed: Skio's native page is only hidden (CSS, html.mk-home-ready)
     AFTER the panel rendered. Any error, missing data or unexpected DOM ->
     the panel is removed and Skio's own page is untouched.
   - Read-only: GraphQL goes through MKPortal.skio() (which refuses
     mutations). No money-moving or schedule-changing call is made here; every
     action hands off to Skio's own UI. The one exception (batch 3): the Add
     pop-up calls MKPortal.addSubscriptionLine() (the core's allowlisted add-line
     call, quantity 1, no price) with a token the core mints from the customer's
     own click in the dialog; the success view is shown only after the core saw
     the new line, and the NEXT ORDER card is redrawn from a fresh read. The second
     exception (r8): the date pop-up calls MKPortal.changeNextOrderDate() (the core's
     allowlisted date change: Skio's own updateNextBillingDateAction, the core builds
     the instant) with a token the core mints from the customer's own click on
     "Move to <day>"; it is offered only when MKPortal.writeEnabled('next-date') is
     true. The confirmation is shown only after the core's re-read showed the picked
     store day; the home (and Upcoming orders) are then redrawn from a fresh read.
     "Check again" uses MKPortal.nextOrderDate() (a read).
   - One day rule (r8, T19): every next-order day on screen (the card, "Your
     subscriptions", "Add to your <date> order", Upcoming orders, the pop-up) is the
     store's day of Skio's nextBillingDate, MKPortal.orderDay() (Skio's header rule);
     the browser's own time zone is never used for a day.
   - Text only: the DOM is built with MKPortal.el() (textContent, safe URLs).
   - The login token is never touched here (the core holds it).

   API (window.MKPortalHome, only when the gate is on)
     version                          '1.3.0'
     handoff(subscriptionId, action, {title}?) -> boolean
                                      open Skio's own control for `action` on
                                      that subscription's page (full page load
                                      + one-shot intent; acts at once when that
                                      page is already open). Actions: order-now,
                                      skip, change-date, frequency, edit-products,
                                      add-product, upsell (title = product title),
                                      address, card
     state() -> {status, subscriptionId, hasPanel, combinePrompt, upcoming, date, dateNote, catalog}   for tests / debugging
                                      upcoming: 'closed' | 'loading' | 'list' | 'empty' | 'error'
                                      catalog (r10): 'closed' | 'loading' | 'list' | 'empty' | 'none' | 'error'
                                      date (r8): the date pop-up, 'closed' | 'choose' | 'busy' | 'refused' |
                                      'unknown' | 'done'; dateNote: null | 'done' | 'already' | 'pending'
     openUpcoming() -> boolean        opens the screen on the subscriptions page: a new #upcoming
                                      history entry carrying Next's router state
                                      (MKPortal.screen.pushHash; location.hash if that fails)
     closeUpcoming() -> boolean       closes it: history.back() when this page added the
                                      #upcoming entry, else the hash is dropped (URL only)
     upcomingEnabled                  false when DECISION_UPCOMING.enabled is off (the menu
                                      hides its "Upcoming orders" item)
     openCatalog() -> boolean         (r10) opens "Add products" on the subscriptions page: a new
                                      #add-products entry (MKPortal.screen.pushHash; location.hash if that
                                      fails); Upcoming orders closes first (one screen at a time)
     closeCatalog() -> boolean        (r10) history.back() when this page added the entry, else the hash
                                      is dropped (URL only)
     catalogEnabled                   (r10) false when the loader's mk_portal_catalog is not exactly true
                                      (MKPortal.catalogEnabled()) or DECISION_CATALOG.enabled is off (the
                                      menu then hides "Add products")
     prefetchCatalog() -> boolean     (r10) reads the catalogue ahead (intent: the menu item or "See all
                                      products" focused or hovered); at most once a second; the core caches
                                      the pages 5 minutes (dropped after any add)
     models.catalog(raw, products, opts?) / models.catOffer(product, subscription, ctx)
                                      (r10, tests) the catalogue model and Skio's offer rules (pure)
     models.catPops(item, catalogModel) -> [{when, date, next, names, schedule, thumbs, freq, subId,
                                      variants, order, inOrder, ...}]   (r10 part 2, tests) the orders the
                                      Add pop-up offers for one card, soonest first (pure)
     models.subsList(raw, mainId, opts?) / models.upcoming(raw, opts?)
                                      pure builders (tests): the "Your subscriptions" rows and
                                      the Upcoming orders model from one mkHome answer
     models.dateGate(raw, subscriptionId, {now}?) -> {ok: true, day, min, max, lines} | {ok: false, why}
                                      (r8, tests) whether "Change date" opens the pop-up for that
                                      subscription of one mkHome answer (false = the hand-off)
     navigate(url)                    full page load (replaceable in tests)
     combineCheck(answer, subscriptionId, cfg?) -> {ids, optIn, key} | null
                                      the Combine card's own decision for one
                                      mkCombineSubscriptions answer (pure; tests):
                                      ids it would offer, the ones it would not
                                      tick (other schedule / address), "Not now" key
   Events
     'mk-portal:home'  (document) detail {state: 'ready' | 'gone'} when the panel
                       (and so #mk-delivery-banner-slot) appears or is removed.
     'mk-portal:screen' (window, sent by MKPortal.screen) {screen: 'upcoming' | 'add-products' | ''}
                       when the Upcoming orders or the "Add products" screen opens or closes.
   ===================================================================== */
(function () {
  'use strict';
  var M = window.MKPortal;
  if (!M || !M.__core || window.MKPortalHome) return;
  if (!M.on()) return;
  if (!M.schedule || !M.screen) return;          /* shared schedule + screen contract (core, round 2) */
  var CFG = M.config || {};
  if (CFG.modules && CFG.modules.home === false) return;

  /* ------------------------------------------------------------------ */
  /* Owner decisions (change here)                                        */
  /* ------------------------------------------------------------------ */
  /* Decision 8a - "Add to your <date> order": the products Skio itself
     offers as one-time upsells ("You might also like", query
     getUpsellProductsBySitePk, Skio's own eligibility rules), excluding
     anything already in the order, at most `max`. None -> no card.
     enabled: false hides the card entirely. */
  var DECISION_8A_SUGGESTIONS = { enabled: true, max: 3 };
  /* Batch 3, decision 1 (Jim, 2026-10-12) - "Add" in that card opens the pop-up "Add to your <date> order"
     and adds the product in place with Skio's own add-line call (MKPortal.addSubscriptionLine: quantity 1,
     no price sent, the customer's own click confirms it). How often: "Just this order" / "With every order",
     each only when Skio itself offers it for the chosen variant; defaultOnce: "Just this order" is chosen
     first. Anything the pop-up cannot price or check (no Skio uuid, other currency, prepaid, unknown selling
     plan pricing, core without the pop-up) falls back to the hand-off to Skio's own carousel.
     enabled: false = always the hand-off (batch 2 F-1). */
  var DECISION_ADD_POPUP = { enabled: true, defaultOnce: true };
  /* r8 (Jim, 2026-10-15, every default of change-date-design/DESIGN-NOTES.md) - "Change date" (the NEXT ORDER card
     and each subscription's next order in Upcoming orders) opens the pop-up "Move your <Oct 30> order" and saves in
     place with the core's SECOND guarded write (MKPortal.changeNextOrderDate: Skio's own updateNextBillingDateAction,
     the customer's own click confirms it), ONLY where the core says that write is on (MKPortal.writeEnabled
     ('next-date'): the loader's MKPortalConfig.writes.nextDate === true) and Skio's own rules allow it
     (MKPortal.nextDateEligible: active, not held, not digital / prepaid / gift, Skio's "Next order date" button on, no
     anchors, the order due tomorrow or later). Everything else keeps the hand-off to Skio's own date window.
     quickPicks: days from the current date ("1 week sooner", "1 week later", "2 weeks later"), each shown only when
     Skio allows that day. No latest day of our own (Skio's limit, when set in Skio). enabled: false = always the
     hand-off. */
  var DECISION_DATE_POPUP = { enabled: true, quickPicks: [-7, 7, 14] };
  /* r8 - the "orders in a row" note in that pop-up ("To keep your streak, this order needs to be charged by <day>"),
     information only, for a customer with exactly one open subscription. OFF until the live test shows that moving
     the date does not also move the streak deadline (DESIGN-NOTES question 6); then this one line turns it on. */
  var DECISION_STREAK_NOTE = { enabled: false };
  /* Decision 8b - several subscriptions: the soonest upcoming ACTIVE one is
     the NEXT ORDER card.
     "Your subscriptions" (round 2 B, replaces "Your other subscriptions"):
     every subscription in Skio's own active group (ACTIVE and PAUSED, the
     NEXT ORDER one included), Skio's card order, one row each (thumbnails,
     names, schedule, next order date, Active / Paused, Manage).
     enabled: false removes the card (and so the Combine prompt in it);
     showWhenSingle: false hides it for a single subscription; upcomingLink:
     the "All upcoming orders" link in its header. */
  var DECISION_SUBS_LIST = { enabled: true, showWhenSingle: true, maxThumbs: 2, maxNames: 2, upcomingLink: true };
  /* The side card's title (round 2 B; was "Your subscription"). Its rows are
     the NEXT ORDER subscription's; with several subscriptions a line "For
     your <date> order" says so. Alternatives: "Shipping and payment",
     "Next order details", "Order details". */
  var DECISION_DETAILS_TITLE = 'Delivery and payment';
  /* Upcoming orders screen (round 2 C, #upcoming). Every open subscription's
     next order is listed (even beyond the horizon); later orders up to
     today + horizonDays (store time zone), at most perSub per subscription
     and maxRows in all (next orders always kept). showPrices: the next
     order's total (same as the NEXT ORDER card); a later order's only when
     no discount on it is limited and no line is a box line.
     enabled: false = no screen and no "All upcoming orders" link (the
     loader switch modules.upcoming = false does the same). */
  var DECISION_UPCOMING = { enabled: true, horizonDays: 90, perSub: 13, maxRows: 30, showPrices: true };
  /* "arrives about <date>" under the next order date: only computed from the
     customer's own delivery history (>= 2 samples each for charge->ship and
     ship->delivery, from the delivery service). false = never shown. */
  var SHOW_ARRIVES_ABOUT = true;
  /* "Saved so far": Skio's own estimate (shown only when Skio's
     showSavedAmount setting is on). Worded "About $X by subscribing". */
  var SHOW_SAVED_SO_FAR = true;
  /* Combine prompt (owner, 2026-10-11): last line of "Your subscriptions", the
     line "Get both in one order . Review and combine ->" (wording by case:
     combineText(); "See if ... can go in one order" when every offered one is
     on another schedule or address, so the card would tick none), linking to
     /a/account/subscriptions/<NEXT ORDER id>#mk-combine (the core scrolls to the
     card there). Shown ONLY when the Combine card (Skio custom extension "MK
     Combine subscriptions", extensions/mk-ext-combine.html v3) would itself
     appear on that subscription's page for at least one subscription listed
     here: this file sends the card's own read-only query and applies the card's
     own rules (COMBINE_CARD = the card's CONFIG; tools/test_home.py checks they
     match). What it cannot see: whether the card is installed, placed in
     Skio's Layout, published, or limited to Skio's "Test emails". So
     enabled: false whenever the Combine card is not live for every customer.
     The link is only built for a Skio subscription id (a UUID). */
  var DECISION_COMBINE_PROMPT = { enabled: true };
  var COMBINE_CARD = { FOLLOW_SKIO_MERGE_SWITCH: true, OFFER_DIFFERENT_SCHEDULES: true, DISMISS_DAYS: 60 };
  /* r10 (Jim, 2026-10-18, "lets build this" = every default of catalog-design/DESIGN-NOTES.md section 14) - the
     "Add products" screen (#add-products). showOutOfStock: a product with every size sold out is listed last, muted,
     "Out of stock right now", no sizes / price / Add (question 6); sort 'az': A to Z (question 8); pageSize / maxPages:
     Skio's product list is read 24 a page, at most 5 pages (120 products; more: a notice, never a silent gap); cacheMs:
     the core keeps the pages this long (dropped after any add); idleMs: the start page reads the list ahead this long
     after it is ready (else only on intent: the menu item or "See all products" focused or hovered).
     enabled: false = no screen, no menu item, "See all products" hands off as in r9.1 (the loader's one line
     mk_portal_catalog = false does the same, for Cowork). */
  var DECISION_CATALOG = { enabled: true, showOutOfStock: true, sort: 'az', pageSize: 24, maxPages: 5, cacheMs: 300000, idleMs: 5000 };

  /* ------------------------------------------------------------------ */
  /* Fixed values                                                         */
  /* ------------------------------------------------------------------ */
  var VERSION = '1.3.1';          /* 1.0.1 (2026-10-11, batch 2): F-1 upsell landing, F-2 member since, F-4, F-5;
                                     1.1.0 (2026-10-12, batch 3): the Add pop-up (DECISION_ADD_POPUP, core 1.1.0 dialog + write);
                                     1.2.0 (2026-10-16, r8): the "Change date" pop-up (DECISION_DATE_POPUP, core 1.3.0
                                     changeNextOrderDate, only where MKPortal.writeEnabled('next-date')), the confirmation
                                     after a move, Upcoming's "Moved from" tag, the streak note (DECISION_STREAK_NOTE, off);
                                     one day rule for every next-order day on screen (MKPortal.orderDay, T19);
                                     arrivesAbout() keeps the number of days;
                                     r8 review (2026-10-16): the calendar says "tomorrow" / "today" only when the customer's
                                     own day is the store's day (else "from <day>"; Chicago wording unchanged); focus stays in
                                     the pop-up in the unclear, sign-in and subscription-page views; a 'busy' answer (an earlier
                                     change still running) opens the read-only Check again view instead of "Nothing was
                                     changed"; dates print the year by the store's year (store zone + the core's clock);
                                     mk-portal-home.css: the month arrows' circle, the tapped day's ring and the gold
                                     current-date ring stay while focused (the core dialog's focus reset no longer wins);
                                     1.3.0 (2026-10-18, r10): the "Add products" screen (#add-products, DECISION_CATALOG, the
                                     loader's mk_portal_catalog via MKPortal.catalogEnabled(), core 1.5.0 skioPages), one
                                     screen at a time with Upcoming orders, "See all products" opens it, the start page's
                                     suggestion price says "just this order", prefetch on intent; addOffer() hands prepaid
                                     subscriptions off (as this header always said); the Add pop-up's size chips 44 px below
                                     1024 px and on touch screens (mk-portal-home.css); r10 part 2 (2026-10-19): the Add
                                     pop-up for any eligible order (openAddDialog: "Which order", disabled in-order sizes,
                                     everything recomputed per order, the write for the chosen order only), addRefresh /
                                     addApply / addDone for any order (found by id; its own total and points), the list
                                     reads Skio again after a send without success; the start page's pop-up unchanged;
                                     1.3.1 (2026-10-19, r10 review): right before the send, the chosen order is read fresh
                                     (addRecheck): the order can still take adds (catEligible), no line of that size in it in
                                     any form (Jim's decision 4), Skio's one-add-per-product rule, and the offer and the price
                                     shown still hold (else nothing is sent: "Already in your order", or the order / prices
                                     changed); the radios checked when Add is pressed must be the ones the pop-up shows (else
                                     nothing is sent and the pop-up follows the checked radios); after an unclear outcome
                                     the same product's Add offers only that order for the hold; "Next order" and "See your
                                     next order" mean the start page's NEXT ORDER subscription (the soonest open one); a card
                                     priced for a later order says so; a size that is on the subscription but not in its next
                                     order says "On this subscription"; gift / digital-only customers get their own wording;
                                     the Change date pop-up's redraws while choosing keep the pop-up's arm time (core 1.5.1);
                                     the tier-DISCOUNT rule fails closed on the start page too (no suggestions, Add hands
                                     off); the notes line keeps the approved meaning ("The points shown are for your <tier>
                                     tier") */
  var SITE_ID = '55c10ac1-455d-48a6-a41e-161371d88114';     /* MK on Skio */
  var INTENT_KEY = 'mk-portal-intent';
  var INTENT_MAX_AGE_MS = 60000;
  var PAGE_WAIT_MS = 20000;
  var BALANCE_FIRST_WAIT_MS = 2500;   /* wait this long for Skio's points before the first paint */
  var BALANCE_WAIT_MS = 12000;        /* keep looking this long after that */
  /* Late takeover guard: the panel replaces Skio's list only while the customer has not started
     using it. If Skio's list has been on screen (and our token valid) for longer than this, or the
     customer clicked / typed / tabbed inside it, or a Skio dialog is open, the panel stays out of
     the way for this page view and a small "See your overview" link is shown instead. */
  var SWAP_DEADLINE_MS = 5000;
  var DELIVERY_LIMIT = 3;             /* same as the delivery module's home banner: one request serves both */
  var WRAP_SEL = '#skio-root [data-skio-name="subscriptions-page"] > div';
  var LOADED_SEL = [
    'subscriptions-active-header', 'subscriptions-active-grid', 'subscriptions-inactive-header',
    'subscriptions-no-subscriptions-container'
  ].map(function (n) { return '#skio-root [data-skio-name="' + n + '"]'; }).join(', ');
  var LAYOUT_SEL = '#skio-root [data-skio-name="authed-layout"]';
  var UPCOMING_HASH = '#upcoming';
  var UPCOMING_WAIT_MS = 15000;       /* wait this long for Skio's layout before the screen gives up */
  var S = M.schedule;
  var WAVE = '\uD83D\uDC4B';
  var DOT = ' \u00B7 ';

  /* ------------------------------------------------------------------ */
  /* GraphQL documents (read-only). Spec section 3 (verbatim, Skio's own   */
  /* customer documents) and section 4 (composites built from them).      */
  /* ------------------------------------------------------------------ */
  var Q_HOME = 'query mkHome($storefrontUserId: uuid!, $siteId: uuid!) {\n' +
    '  StorefrontUserByPk(id: $storefrontUserId) {\n' +
    '    id firstName createdAt\n' +
    '    StorefrontUserTiers(where: {removedAt: {_is_null: true}}, order_by: {createdAt: desc_nulls_last}) { joinDate TierLevel { id name iconUrl } }\n' +
    '  }\n' +
    '  Subscriptions(\n' +
    '    where: {_or: [{storefrontUserId: {_eq: $storefrontUserId}}, {prepaidGiftRecipientId: {_eq: $storefrontUserId}}], _and: {_or: [{statusContext: {_is_null: true}}, {statusContext: {_neq: "PERMANENTLY_CANCELLED"}}]}}\n' +
    '    order_by: [{status: asc}, {nextBillingDate: asc}]\n' +
    '  ) {\n' +
    '    id status statusContext createdAt nextBillingDate cyclesCompleted\n' +
    '    streakCount maxStreakCount streakExpiresAt skipCycleBillingDate\n' +
    '    currencyCode deliveryPrice deliveryPriceOverride isDigital\n' +
    '    prepaidGiftRecipientId prepaidDeliveryPolicyId customAttributes\n' +
    '    BillingPolicy { interval intervalCount maxCycles isMaxCycleV2 Anchors { day type } }\n' +
    '    DeliveryPolicy { interval intervalCount }\n' +
    '    ShippingAddress { firstName lastName company address1 city province zip country }\n' +
    '    PaymentMethod { brand lastDigits expiryMonth expiryYear revokedAt skioRevoke paypalAccountEmail }\n' +
    '    SubscriptionLines(where: {removedAt: {_is_null: true}}) {\n' +
    '      id quantity priceWithoutDiscount productVariantId customAttributes ordersRemaining isPrepaid titleOverride\n' +
    '      ProductVariant { id title image price compareAtPrice marketPrices Product { id title imageSrc } }\n' +
    '      Discounts { id platformId type title fixedValue percentage appliesOnEachItem timesUsed maxTimesUsed updatedAt }\n' +
    '    }\n' +
    '  }\n' +
    '  SiteByPk(id: $siteId) {\n' +
    '    id currencyCode ianaTimezone settings cpv3Settings\n' +
    '    TierGroups(where: {removedAt: {_is_null: true}}) {\n' +
    '      TierLevels(where: {removedAt: {_is_null: true}, enabled: {_eq: true}}, order_by: {orderIndex: desc}) {\n' +
    '        name eligibility eligibilityDescription iconUrl\n' +
    '        TierRewards(where: {removedAt: {_is_null: true}}, order_by: {createdAt: asc}) { name description rewardData }\n' +
    '      }\n' +
    '    }\n' +
    '  }\n' +
    '}';

  var Q_FIRST_ORDER = 'query mkFirstOrder($storefrontUserId: uuid!) {\n' +
    '  Orders(where: {storefrontUserId: {_eq: $storefrontUserId}}, order_by: [{createdAt: asc}], limit: 1) { createdAt }\n' +
    '}';

  /* --- verbatim fallbacks (spec 3.x) --- */
  var Q_SUBS_LIST = 'query getSubscriptionsList($storefrontUserId: uuid!) {\n' +
    '  Subscriptions(\n' +
    '    where: {_or: [{storefrontUserId: {_eq: $storefrontUserId}}, {prepaidGiftRecipientId: {_eq: $storefrontUserId}}], _and: {_or: [{statusContext: {_is_null: true}}, {statusContext: {_neq: "PERMANENTLY_CANCELLED"}}]}}\n' +
    '    order_by: [{status: asc}, {nextBillingDate: asc}]\n' +
    '  ) {\n' +
    '    id status statusContext nextBillingDate currencyCode deliveryPrice deliveryPriceOverride isDigital cyclesCompleted\n' +
    '    prepaidGiftRecipientId customAttributes\n' +
    '    BillingPolicy { interval intervalCount }\n' +
    '    SubscriptionLines(where: {removedAt: {_is_null: true}}) {\n' +
    '      id quantity platformId priceWithoutDiscount customAttributes updatedAt sellingPlanId\n' +
    '      ProductVariant { platformId title image Product { title imageSrc } }\n' +
    '      Discounts { id fixedValue percentage appliesOnEachItem }\n' +
    '    }\n' +
    '  }\n' +
    '}';

  var F_POLICY = 'fragment shopifyCustomerPortalSubscriptionPolicyFields on Policy {\n' +
    '  id interval intervalCount minCycles maxCycles isMaxCycleV2\n' +
    '  Anchors { id day month type cutoffDay strictness missedAnchorAllowance }\n' +
    '}';
  var F_LINE = 'fragment shopifyCustomerPortalSubscriptionLineFields on SubscriptionLine {\n' +
    '  id platformId quantity priceWithoutDiscount productVariantId sellingPlanId ordersRemaining customAttributes titleOverride\n' +
    '  isPrepaid taxable updatedAt createdAt prepaidSubscriptionId\n' +
    '  OriginalSellingPlan { id platformId name prepaidDeliveryPolicyId PricingPolicies(limit: 1) { id sellingPlanPricingPolicyAdjustmentType fixedPrice percentageOff afterCycle } }\n' +
    '  ProductVariant {\n' +
    '    id productId title image price marketPrices platformId outOfStockAt compareAtPrice enableOneTimeUpsell\n' +
    '    Product {\n' +
    '      id platformId title imageSrc images slug title description deletedAt limitOneTimeUpsellQuantity oneTimeUpsellPercentageOff\n' +
    '      Collection_Products { collectionId Collection { id title } }\n' +
    '    }\n' +
    '    SellingPlanGroupResources { SellingPlanGroup { name SellingPlans(where: {availableInCustomerPortal: {_eq: true}}) {\n' +
    '      BillingPolicy { interval intervalCount Anchors { day type cutoffDay strictness missedAnchorAllowance } }\n' +
    '      PrepaidDeliveryPolicy { interval intervalCount Anchors { id day type cutoffDay strictness missedAnchorAllowance } }\n' +
    '    } } }\n' +
    '    ClassicBoxV2 { id selectionMode }\n' +
    '  }\n' +
    '  Discounts { id platformId title type timesUsed maxTimesUsed fixedValue percentage redeemCode appliesOnEachItem updatedAt createdAt }\n' +
    '}';
  var Q_SUB_BY_ID = 'query getSubscriptionById($subscriptionId: uuid!) {\n' +
    '  SubscriptionByPk(id: $subscriptionId) {\n' +
    '    id platformId siteId status statusContext cancelledAt createdAt updatedAt migrationIndex prepaidGiftRecipientId\n' +
    '    prepaidDeliveryPolicyId nextBillingDate cyclesCompleted maxStreakCount streakCount streakExpiresAt currencyCode\n' +
    '    deliveryPrice deliveryPriceOverride customAttributes isPickup isDigital note skipCycleBillingDate\n' +
    '    StorefrontUser {\n' +
    '      id platformId firstName lastName email phoneNumber cognitoUsername backupPaymentMethodId\n' +
    '      Tags { id Tag { id name } }\n' +
    '      Site { id inventoryPolicy domain currencyCode settings name }\n' +
    '    }\n' +
    '    PrepaidGiftRecipient { id firstName lastName }\n' +
    '    PrepaidDeliveryPolicy { ...shopifyCustomerPortalSubscriptionPolicyFields }\n' +
    '    DeliveryPolicy { ...shopifyCustomerPortalSubscriptionPolicyFields }\n' +
    '    BillingPolicy { ...shopifyCustomerPortalSubscriptionPolicyFields }\n' +
    '    SubscriptionLines(where: {removedAt: {_is_null: true}}) { ...shopifyCustomerPortalSubscriptionLineFields }\n' +
    '    PrepaidSubscriptionLines(where: {removedAt: {_is_null: true}}) { ...shopifyCustomerPortalSubscriptionLineFields }\n' +
    '    ShippingAddress { id platformId firstName lastName address1 address2 city province zip country phoneNumber company }\n' +
    '    PaymentMethod {\n' +
    '      id platformId lastDigits revokedAt brand expiryMonth expiryYear skioRevoke paypalAccountEmail\n' +
    '      BillingAddress { firstName lastName }\n' +
    '      StorefrontUser { id firstName lastName }\n' +
    '    }\n' +
    '    SurpriseDelightSessions { ruleId group }\n' +
    '    BannerSessions(where: {isActive: {_eq: true}}) {\n' +
    '      id startTime startCycle bannerId\n' +
    '      Banner { imageUrl redirectUrl maxCycle maxTime copy actions disabled realTimeConditions JourneyVersion { journeyId versionNumber Journey { status } } }\n' +
    '    }\n' +
    '    CancelFlowV2Sessions { status rebuttal }\n' +
    '    CancelFlowV3Sessions { id cancelFlowId versionNumber pathTaken status createdAt }\n' +
    '    AllSubscriptionLines: SubscriptionLines { id quantity customAttributes createdAt removedAt ProductVariant { platformId } OrderLineItems { orderId createdAt } }\n' +
    '    SubscriptionsSegments { segmentId }\n' +
    '    TriggeredSubscriptionStateChanges { oldStatus status createdAt }\n' +
    '  }\n' +
    '  OrdersWithSupriseAndDelightDiscounts: Orders(\n' +
    '    where: {OrderLineItems: {SubscriptionLine: {subscriptionId: {_eq: $subscriptionId}}}, OrderDiscountApplications: {title: {_like: "Surprise and delight%"}}}\n' +
    '  ) { createdAt OrderDiscountApplications { index title fixedValue percentage currencyCode } }\n' +
    '}\n' + F_POLICY + '\n' + F_LINE;

  var Q_LOYALTY_INFO = 'query storefrontUserLoyaltyInfo($storefrontUserId: uuid!) {\n' +
    '  StorefrontUserByPk(id: $storefrontUserId) {\n' +
    '    birthday email phoneNumber firstName lastName createdAt\n' +
    '    Tags { id Tag { id name } }\n' +
    '    StorefrontUserTiers(where: {removedAt: {_is_null: true}}, order_by: {createdAt: desc_nulls_last}) { joinDate tierExpiresAt TierLevel { id name iconUrl } }\n' +
    '    CreditDiscounts(where: {removedAt: {_is_null: true}, orderId: {_is_null: true}}) { code amount orderId removedAt }\n' +
    '  }\n' +
    '}';
  var Q_TIER_GROUPS = 'query siteTierGroups($siteId: uuid!) {\n' +
    '  SiteByPk(id: $siteId) {\n' +
    '    TierGroups(where: {removedAt: {_is_null: true}}) {\n' +
    '      TierLevels(where: {removedAt: {_is_null: true}, enabled: {_eq: true}}, order_by: {orderIndex: desc}) {\n' +
    '        name description eligibilityDescription eligibility iconUrl detailsUrl\n' +
    '        TierRewards(where: {removedAt: {_is_null: true}}, order_by: {createdAt: asc}) { name description rewardData }\n' +
    '      }\n' +
    '    }\n' +
    '  }\n' +
    '}';
  var Q_ORDERS_FOR_USER = 'query GetOrdersForUser($storefrontUserId: uuid!, $limit: Int, $offset: Int, $orderBy: [Order_order_by!]) {\n' +
    '  Orders(where: {storefrontUserId: {_eq: $storefrontUserId}}, order_by: $orderBy, limit: $limit, offset: $offset) {\n' +
    '    id createdAt totalPrice totalPricePresentmentAmount currencyCode processedAt taxesIncluded taxExempt platformId platformNumber name\n' +
    '    OrderLineItems {\n' +
    '      id currencyCode quantity priceWithoutDiscount pricePresentmentAmount pricePresentmentCurrencyCode customAttributes\n' +
    '      ProductVariant { id title platformId image Product { id title imageSrc description } }\n' +
    '      SubscriptionLine { id customAttributes Subscription { id BillingPolicy { interval intervalCount } } }\n' +
    '      TaxLines { id price rate pricePresentmentAmount pricePresentmentCurrencyCode }\n' +
    '      Discounts { id fixedValue allocationPresentmentAmount }\n' +
    '    }\n' +
    '    ShippingLines {\n' +
    '      id priceWithoutDiscount pricePresentmentAmount pricePresentmentCurrencyCode\n' +
    '      Discounts { id fixedValue allocationPresentmentAmount }\n' +
    '      TaxLines { id price rate pricePresentmentAmount pricePresentmentCurrencyCode }\n' +
    '    }\n' +
    '    ShippingAddress { id firstName lastName address1 address2 city province zip country }\n' +
    '  }\n' +
    '}';

  var F_PRICING = 'fragment pricingPolicyFields on PricingPolicy { id fixedPrice percentageOff sellingPlanPricingPolicyAdjustmentType afterCycle }';
  var F_UPSELL_VARIANT = 'fragment UpsellProductVariantFields on ProductVariant {\n' +
    '  id platformId productId position price compareAtPrice title image sku outOfStockAt marketPrices enableOneTimeUpsell hideOnEditProduct deletedAt\n' +
    '  SellingPlanGroupResources { id SellingPlanGroup { id name SellingPlans(where: {availableInCustomerPortal: {_eq: true}}) {\n' +
    '    id platformId name availableInCustomerPortal\n' +
    '    DeliveryPolicy { interval intervalCount }\n' +
    '    PrepaidDeliveryPolicy { interval intervalCount }\n' +
    '    PricingPolicies(order_by: {afterCycle: asc_nulls_first}) { ...pricingPolicyFields }\n' +
    '    BillingPolicy { interval intervalCount Anchors { id day type cutoffDay strictness missedAnchorAllowance } }\n' +
    '  } } }\n' +
    '  Product { id platformId slug imageSrc title description oneTimeUpsellPercentageOff limitOneTimeUpsellQuantity }\n' +
    '  ClassicBoxV2 { id size ClassicBoxV2_SelectableProductVariant { deletedAt SelectableProductVariant { id title image platformId outOfStockAt Product { platformId title imageSrc } } } }\n' +
    '}';
  var F_UPSELL_PRODUCT = 'fragment UpsellProductFields on Product {\n' +
    '  id platformId imageSrc images title status description canUpsell hideOnEditProductsPage hideOn1TimeUpsells\n' +
    '  oneTimeUpsellPercentageOff limitOneTimeUpsellQuantity showProductForCustomerTags slug\n' +
    '  Tags { id Tag { id name } }\n' +
    '  Site { currencyCode }\n' +
    '  DynamicBox {\n' +
    '    id sizeRange sizeInterval fixedDiscount priceRange percentDiscount settings theme\n' +
    '    DynamicBox_SelectableProductVariants { deletedAt SelectableProductVariant {\n' +
    '      id platformId title image price outOfStockAt marketPrices\n' +
    '      Product { id platformId title imageSrc description }\n' +
    '      SellingPlanGroupResources { SellingPlanGroup { id name SellingPlans(where: {availableInCustomerPortal: {_eq: true}}) {\n' +
    '        id platformId name PricingPolicies(order_by: {afterCycle: asc_nulls_first}) { ...pricingPolicyFields } BillingPolicy { interval intervalCount }\n' +
    '      } } }\n' +
    '    } }\n' +
    '  }\n' +
    '  Collection_Products { collectionId Collection { id title platformId displayOnEditProduct } }\n' +
    '  ProductVariants(where: {deletedAt: {_is_null: true}, enableOneTimeUpsell: {_eq: true}}, order_by: {position: asc_nulls_last}) { ...UpsellProductVariantFields }\n' +
    '}';
  var Q_UPSELLS = 'query getUpsellProductsBySitePk($siteId: uuid!, $where: Product_bool_exp = {}, $limit: Int = 24, $offset: Int = 0) {\n' +
    '  SiteByPk(id: $siteId) {\n' +
    '    id currencyCode\n' +
    '    UpsellProducts: Products(\n' +
    '      where: {deletedAt: {_is_null: true}, canUpsell: {_eq: true}, hideOn1TimeUpsells: {_eq: false}, status: {_in: ["ACTIVE", "UNLISTED"]}, _and: [$where]}\n' +
    '      limit: $limit\n' +
    '      offset: $offset\n' +
    '    ) { ...UpsellProductFields }\n' +
    '  }\n' +
    '}\n' + F_UPSELL_PRODUCT + '\n' + F_UPSELL_VARIANT + '\n' + F_PRICING;

  /* r10, "Add products": Skio's own "Add product" picker reads getProductsForSite with the fragment ProductPickerFields
     (chunk 3109, verbatim; spec section 15). mkCatalog is that read with, from Skio's getSiteSettings (3109), the
     site's smartCarouselSettings (hideOOSProducts), collectionSettings (cpEditProductCollectionOrder) and the collections
     flagged "Display on edit product" (the category chips), each product's collection ids (for the chips), and the
     customer's tags (storefrontUserLoyaltyInfo's selection: Skio 23403.l, applied in the page). Never the
     storefrontAccessToken. $limit / $offset are set by MKPortal.skioPages (24 a page). */
  var F_PICKER = 'fragment ProductPickerFields on Product {\n' +
    '  id platformId imageSrc images title status description canUpsell hideOnEditProductsPage hideOn1TimeUpsells\n' +
    '  oneTimeUpsellPercentageOff limitOneTimeUpsellQuantity showProductForCustomerTags slug\n' +
    '  Tags { id Tag { id name } }\n' +
    '  Site { currencyCode }\n' +
    '  DynamicBox {\n' +
    '    id sizeRange sizeInterval fixedDiscount priceRange percentDiscount settings theme\n' +
    '    DynamicBox_SelectableProductVariants { deletedAt SelectableProductVariant {\n' +
    '      id platformId title image price outOfStockAt marketPrices\n' +
    '      Product { id platformId title imageSrc description }\n' +
    '      SellingPlanGroupResources { SellingPlanGroup { id name SellingPlans(where: {availableInCustomerPortal: {_eq: true}}) {\n' +
    '        id platformId name PricingPolicies(order_by: {afterCycle: asc_nulls_first}) { ...pricingPolicyFields } BillingPolicy { interval intervalCount }\n' +
    '      } } }\n' +
    '    } }\n' +
    '  }\n' +
    '  ProductVariants(where: {deletedAt: {_is_null: true}, hideOnEditProduct: {_eq: false}}, order_by: {position: asc_nulls_last}) { ...UpsellProductVariantFields }\n' +
    '}';
  var Q_CATALOG = 'query mkCatalog($siteId: uuid!, $storefrontUserId: uuid!, $where: Product_bool_exp!, $limit: Int = 24, $offset: Int = 0) {\n' +
    '  SiteByPk(id: $siteId) {\n' +
    '    id currencyCode smartCarouselSettings collectionSettings\n' +
    '    Collections(where: {displayOnEditProduct: {_eq: true}, removedAt: {_is_null: true}}) { id title }\n' +
    '    Products(limit: $limit, offset: $offset, where: $where, order_by: {createdAt: desc}) {\n' +
    '      ...ProductPickerFields\n' +
    '      Collection_Products { collectionId }\n' +
    '    }\n' +
    '  }\n' +
    '  StorefrontUserByPk(id: $storefrontUserId) { id Tags { id Tag { id name } } }\n' +
    '}\n' + F_PICKER + '\n' + F_UPSELL_VARIANT + '\n' + F_PRICING;
  /* Skio's add-mode filter (8461, ProductSelectionModal mode "add", one subscription, no search, no category; restrict by
     interval off for MKS): listed when ACTIVE or UNLISTED, not deleted, not hidden from the edit-products page, and either a
     variant with a "Subscription" selling plan offered in the customer portal or one-time add-ons on. Skio's customer-tag
     clause (8461 C()) needs the customer's tags before the read; the same rule is applied in the page instead (Skio 23403.l,
     which Skio's picker also applies), so one cacheable request serves every customer of the site. */
  var CAT_WHERE = {
    hideOnEditProductsPage: { _eq: false }, deletedAt: { _is_null: true }, status: { _in: ['ACTIVE', 'UNLISTED'] },
    _and: [{ _or: [
      { ProductVariants: { deletedAt: { _is_null: true }, SellingPlanGroupResources: { SellingPlanGroup: { name: { _in: ['Subscription'] },
        SellingPlans: { id: { _is_null: false }, availableInCustomerPortal: { _eq: true } } } } } },
      { canUpsell: { _eq: true }, ProductVariants: { deletedAt: { _is_null: true }, enableOneTimeUpsell: { _eq: true } } }
    ] }]
  };

  /* The Combine card's own query, character for character (extensions/mk-ext-combine.html v3,
     QUERY_SUBS / QUERY_SITE / QUERY; spec 4.5). Same answer as the card gets = same decision. */
  var CX_QUERY_SUBS =
    'Subscriptions(' +
    '  where: {_or: [{storefrontUserId: {_eq: $storefrontUserId}}, {prepaidGiftRecipientId: {_eq: $storefrontUserId}}], ' +
    '          _and: {_or: [{statusContext: {_is_null: true}}, {statusContext: {_neq: "PERMANENTLY_CANCELLED"}}]}}' +
    '  order_by: [{status: asc}, {nextBillingDate: asc}]' +
    ') {' +
    '  id status statusContext nextBillingDate currencyCode deliveryPrice deliveryPriceOverride isDigital cyclesCompleted' +
    '  prepaidGiftRecipientId prepaidDeliveryPolicyId streakCount' +
    '  PrepaidDeliveryPolicy { interval intervalCount }' +
    '  BillingPolicy { interval intervalCount }' +
    '  ShippingAddress { address1 address2 city province zip country }' +
    '  SubscriptionLines(where: {removedAt: {_is_null: true}}) {' +
    '    id quantity priceWithoutDiscount ordersRemaining isPrepaid customAttributes' +
    '    Discounts { id type fixedValue percentage appliesOnEachItem timesUsed maxTimesUsed }' +
    '    ProductVariant { title image Product { title imageSrc } }' +
    '  }' +
    '}';
  var CX_QUERY_SITE = ' StorefrontUserByPk(id: $storefrontUserId) { Site { ianaTimezone' +
    (COMBINE_CARD.FOLLOW_SKIO_MERGE_SWITCH ? ' cpv3Settings FeatureFlags { name enabled }' : '') + ' } }';
  var Q_COMBINE = 'query mkCombineSubscriptions($storefrontUserId: uuid!) { ' + CX_QUERY_SUBS + CX_QUERY_SITE + ' }';

  /* ------------------------------------------------------------------ */
  /* small helpers                                                        */
  /* ------------------------------------------------------------------ */
  var el = M.el;
  function obj(v) { return v && typeof v === 'object' && !Array.isArray(v) ? v : null; }
  function arr(v) { return Array.isArray(v) ? v : []; }
  function str(v) { return typeof v === 'string' ? v : (v == null ? '' : String(v)); }
  function n(v) { return M.num(v); }
  function ppdText(p) { return (Math.floor(p) === p ? M.points(p) : String(Math.round(p * 100) / 100)) + (p === 1 ? ' point' : ' points'); }
  function round2(x) { return Math.round(x * 100) / 100; }
  function round3(x) { return Math.round(x * 1000) / 1000; }
  function okResult(r) { return !!(r && !r.errors && r.data && typeof r.data === 'object'); }
  function validId(id) { return typeof id === 'string' && /^[A-Za-z0-9-]{1,80}$/.test(id); }
  function base() {
    var p = location.pathname, i = p.indexOf('/a/account');
    return i >= 0 ? p.slice(0, i) + '/a/account' : '/a/account';
  }
  function subUrl(id) { return base() + '/subscriptions/' + encodeURIComponent(id); }
  function validTz(tz) {
    if (typeof tz !== 'string' || !tz || tz.length > 64) return undefined;
    try { new Intl.DateTimeFormat('en-US', { timeZone: tz }); return tz; } catch (e) { return undefined; }
  }
  /* r8 (T19, 02 sec. 4.5 rule 5): THE day of a next-order date, the store's day (MKPortal.orderDay = Skio's header rule),
     for the card, "Your subscriptions", "Add to your <date> order", Upcoming orders, the pop-up and its success check.
     Only without a store time zone (Skio's own fallback documents) the r6 rule stays. */
  function orderYmd(v, tz) { try { return tz && typeof M.orderDay === 'function' ? M.orderDay(v, tz) : null; } catch (e) { return null; } }
  /* r8 review: the year ('auto') follows the store's year (its zone, the core's clock), as Upcoming's month titles do */
  function dayText(v, tz, style) {
    var d = orderYmd(v, tz);
    if (tz) lastTz = tz;
    return d ? M.formatDate(d, style, { timeZone: tz, now: Date.now() }) : M.formatDate(v, style, { timeZone: tz, now: Date.now() });
  }
  var lastTz = undefined;    /* the store's zone, once a model carried it (fmtDay outside an open pop-up) */
  function attr(line, key) {
    var a = arr(line && line.customAttributes);
    for (var i = 0; i < a.length; i++) if (a[i] && a[i].key === key) return a[i].value;
    return undefined;
  }
  function hasAttr(line, keys, needValue) {
    return arr(line && line.customAttributes).some(function (a) {
      return a && keys.indexOf(a.key) >= 0 && (!needValue || !!a.value);
    });
  }
  function dispatch(state) {
    try { document.dispatchEvent(new CustomEvent('mk-portal:home', { detail: { state: state } })); } catch (e) { /* ignore */ }
  }
  /* Shopify CDN images: ask for a small rendition */
  function img(url, width) {
    var u = M.safeUrl(url, { httpsOnly: true });
    if (!u) return null;
    try {
      var x = new URL(u);
      if (/(^|\.)cdn\.shopify\.com$/i.test(x.hostname) || /\/cdn\/shop\//.test(x.pathname)) x.searchParams.set('width', String(width));
      return x.toString();
    } catch (e) { return u; }
  }

  /* ------------------------------------------------------------------ */
  /* subscription rules (spec 5, 6.4, 8)                                  */
  /* ------------------------------------------------------------------ */
  var ONE_TIME_KEYS = ['_isOneTimeUpsell', 'isOneTimeUpsell', '_cancelFlowUpsell', 'cancelFlowUpsell'];
  var BOX_KEYS = ['_dynamicBoxId', '_dynamicBoxSectionId', '_staticBoxId', '_presetBoxVersion'];
  var BOX_KEYS_ANY = ['_dynamicBoxIndex', '_staticBoxIndex', '_staticBoxParent', '_isClassicBoxV2', 'boxInstanceId'];
  var HOLD_CONTEXTS = ['TEMPORARILY_PAUSED', '3DS_PENDING', 'DUNNING', 'UNDER_FRAUD_REVIEW'];

  function isOneTime(line) { return hasAttr(line, ONE_TIME_KEYS, false); }
  function isBoxLine(line) {
    return hasAttr(line, BOX_KEYS, true) || hasAttr(line, BOX_KEYS_ANY, false) ||
      !!(line && line.ProductVariant && line.ProductVariant.ClassicBoxV2 && line.ProductVariant.ClassicBoxV2.id);
  }
  function skippedIn(line, cycle) {
    var raw = attr(line, '_skipProduct');
    if (!raw) return false;
    try { var list = JSON.parse(raw); return Array.isArray(list) && list.indexOf(cycle) >= 0; } catch (e) { return false; }
  }
  function isPrepaidSub(s) {
    return !!(s.prepaidDeliveryPolicyId || s.PrepaidDeliveryPolicy) ||
      arr(s.SubscriptionLines).some(function (l) { return l && (l.isPrepaid || l.prepaidSubscriptionId); });
  }
  function needsAttention(s) {
    return s.status === 'FAILED' || s.statusContext === 'DUNNING' || s.statusContext === '3DS_PENDING';
  }
  function isOpen(s) {
    return s.status === 'ACTIVE' && HOLD_CONTEXTS.indexOf(s.statusContext) < 0 && !!s.nextBillingDate &&
      !!M.toDate(s.nextBillingDate) && !s.isDigital && !s.prepaidGiftRecipientId;
  }
  /* Skio's own card order (subs-page sort): ACTIVE first, PAUSED before FAILED,
     no date last, then by date */
  function statusRank(s) { return s.status === 'ACTIVE' ? 0 : s.status === 'PAUSED' ? 1 : s.status === 'FAILED' ? 2 : 3; }
  function cardOrder(a, b) {
    var r = statusRank(a) - statusRank(b);
    if (r) return r;
    var da = M.toDate(a.nextBillingDate), db = M.toDate(b.nextBillingDate);
    if (!da || !db) return da ? -1 : db ? 1 : 0;
    return da - db;
  }
  function soonest(a, b) {
    var d = M.toDate(a.nextBillingDate) - M.toDate(b.nextBillingDate);
    return d || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
  }
  /* Skio's per-site action switches (cpv3Settings.actionButtonToggleSettings): actionOn(name) -> false
     only when Skio hides that action; unknown / missing settings -> shown (the subscription page's
     own fallback applies) */
  function actionsFrom(cpv3) {
    var actions = obj(cpv3) && obj(cpv3.actionButtonToggleSettings);
    return function (name) {
      var v = actions ? actions[name] : undefined;
      if (v === false) return false;
      if (obj(v) && (v.enabled === false || v.show === false || v.visible === false || v.hidden === true)) return false;
      return true;
    };
  }
  /* Skio's own "active" group (ACTIVE and PAUSED), prepaid-gift source duplicates dropped (never
     `keepId`, the NEXT ORDER one), in Skio's own card order */
  function listedSubs(raw, keepId) {
    var subs = arr(raw && raw.subs).filter(function (s) { return obj(s) && validId(s.id); });
    var listed = subs.filter(function (s) { return s.status === 'ACTIVE' || s.status === 'PAUSED'; });
    return listed.filter(function (s) {
      if (s.id === keepId) return true;
      var src = arr(s.customAttributes).filter(function (a) { return a && a.key === 'prepaidGiftSourceSubscriptionId'; })[0];
      return !(src && listed.some(function (o) { return o.id === src.value; }));
    }).sort(cardOrder);
  }
  /* "Every month" / "Every 4 weeks" (Skio's own label logic) */
  function schedule(policy) {
    var p = obj(policy);
    if (!p) return '';
    var unit = str(p.interval).toUpperCase().replace(/S$/, '');
    var c = parseInt(p.intervalCount, 10);
    var word = { DAY: 'day', WEEK: 'week', MONTH: 'month', YEAR: 'year' }[unit];
    if (!word || !(c >= 1)) return '';
    return c === 1 ? 'Every ' + word : 'Every ' + c + ' ' + word + 's';
  }
  /* lines that ship in the next order (k = 1): not skipped for that cycle,
     not finished (ordersRemaining) */
  function nextLines(s) {
    var cycle = (parseInt(s.cyclesCompleted, 10) || 0) + 1;
    return arr(s.SubscriptionLines).filter(function (l) {
      if (!obj(l) || !obj(l.ProductVariant)) return false;
      if (skippedIn(l, cycle)) return false;
      if (l.ordersRemaining != null && !(n(l.ordersRemaining) >= 1)) return false;
      return true;
    });
  }

  /* ------------------------------------------------------------------ */
  /* money (spec 6.5, 6.6, 6.7; Skio code 41127 S()/h(), 60597, 67210)    */
  /* ------------------------------------------------------------------ */
  var COUNTRY_CODES = { 'united states': 'US', 'united states of america': 'US', usa: 'US', canada: 'CA' };
  function countryCode(name) {
    var s = str(name).trim();
    if (/^[A-Z]{2}$/.test(s)) return s;
    return COUNTRY_CODES[s.toLowerCase()] || null;
  }
  /* Skio y8() without a pricing policy: market price for the subscription's
     country when its currency matches, else the variant price */
  function basePrice(variant, sub, siteCurrency) {
    var mp = obj(variant.marketPrices), cc = countryCode(sub.ShippingAddress && sub.ShippingAddress.country);
    if (mp && cc && obj(mp[cc]) && mp[cc].currencyCode === sub.currencyCode) {
      var m = n(mp[cc].amount);
      if (m !== null) return m;
    }
    if (siteCurrency && sub.currencyCode && siteCurrency !== sub.currencyCode) return null;   /* Skio converts; we do not */
    return n(variant.price);
  }
  /* Skio r_(): the struck "regular" price also honours compareAtPrice */
  function regularPrice(variant, sub, siteCurrency) {
    var b = basePrice(variant, sub, siteCurrency);
    if (b === null) return null;
    if (siteCurrency && siteCurrency === sub.currencyCode && variant.compareAtPrice != null) {
      var c = Number(variant.compareAtPrice);
      if (isFinite(c) && c > b) return c;
    }
    return b;
  }
  function discountActive(d) { return !d.maxTimesUsed || (d.timesUsed || 0) < d.maxTimesUsed; }
  /* Skio's stacking (60597 u() + p()): returns {amount, freeShipping} */
  function discounts(lines) {
    var byKey = {}, keys = [], byId = {}, amt = {};
    lines.forEach(function (l) {
      byId[l.id] = l;
      amt[l.id] = (n(l.priceWithoutDiscount) || 0) * (parseInt(l.quantity, 10) || 0);
      arr(l.Discounts).forEach(function (d) {
        if (!obj(d) || d.type === 'PREPAID_DISCOUNT') return;
        var k = String(d.platformId);
        if (byKey[k]) { byKey[k].lines.push(l.id); return; }
        byKey[k] = { d: d, lines: [l.id], all: false };
        keys.push(k);
      });
    });
    var list = keys.map(function (k) { var x = byKey[k]; if (x.lines.length === lines.length) x.all = true; return x; });
    var active = list.filter(function (x) { return discountActive(x.d); });
    var freeShipping = active.some(function (x) { return x.d.type === 'FREE_SHIPPING'; });
    var stack = active.slice().sort(function (a, b) { return str(a.d.updatedAt).localeCompare(str(b.d.updatedAt)); })
      .map(function (x) { return x.d.platformId; }).filter(function (v) { return v != null; });
    var isBab = function (x) { return x.d.type === 'DYNAMIC_BUILD_A_BOX_DISCOUNT'; };
    var apply = active.filter(function (x) { return x.d.type !== 'FREE_SHIPPING'; }).sort(function (a, b) {
      if (isBab(a) !== isBab(b)) return isBab(a) ? -1 : 1;
      var fa = typeof a.d.fixedValue === 'number', fb = typeof b.d.fixedValue === 'number';
      if (fa !== fb) return fa ? 1 : -1;
      var ia = stack.indexOf(a.d.platformId), ib = stack.indexOf(b.d.platformId);
      return ia < 0 ? 1 : ib < 0 ? -1 : ia - ib;
    });
    var total = 0;
    apply.forEach(function (x) {
      var targets = x.all ? lines : x.lines.map(function (id) { return byId[id]; });
      if (targets.some(function (t) { return !t; })) return;
      var fixed = x.d.fixedValue ? n(x.d.fixedValue) : null, pct = n(x.d.percentage), off = 0;
      if (fixed) {
        var sum = targets.reduce(function (s, t) { return s + amt[t.id]; }, 0);
        targets.forEach(function (t) {
          var q = parseInt(t.quantity, 10) || 0;
          var cut = x.d.appliesOnEachItem ? fixed * q : (amt[t.id] === 0 || !sum ? 0 : fixed / sum * amt[t.id]);
          off += Math.min(amt[t.id], cut);
          amt[t.id] = Math.max(0, amt[t.id] - cut);
        });
      } else if (pct) {
        if (pct > 1) return;
        targets.forEach(function (t) { var cut = amt[t.id] * pct; amt[t.id] = Math.max(0, amt[t.id] - cut); off += cut; });
      }
      total += round3(off);
    });
    return { amount: total, freeShipping: freeShipping };
  }
  /* the NEXT ORDER money rows; null = do not show prices (fail closed) */
  function orderMoney(sub, lines, siteCurrency) {
    var cur = /^[A-Z]{3}$/.test(str(sub.currencyCode)) ? sub.currencyCode : null;
    if (!cur || isPrepaidSub(sub) || lines.some(isBoxLine)) return null;
    var rows = [], subtotal = 0, saveLines = 0;
    for (var i = 0; i < lines.length; i++) {
      var l = lines[i], q = parseInt(l.quantity, 10), price = n(l.priceWithoutDiscount);
      if (!(q >= 1) || price === null || price < 0) return null;
      /* batch 3 review fix: a one-time add-on also shows its regular price struck and counts in "You save", as the
         approved add-popup-success render and the Add pop-up's "Subscriber price" do (Skio's own card leaves it out) */
      var reg = regularPrice(l.ProductVariant, sub, siteCurrency);
      var struck = reg !== null && price > 0 && reg - price > 0.01 ? reg * q : null;
      if (struck !== null) saveLines += (reg - price) * q;
      rows.push({ id: l.id, total: price * q, struck: struck });
      subtotal += price * q;
    }
    var d = discounts(lines);
    var ship = n(sub.deliveryPrice);
    if (ship === null) ship = 0;
    if (d.freeShipping) ship = 0;
    var discount = round2(d.amount);
    return {
      currency: cur, rows: rows, subtotal: round2(subtotal), shipping: round2(ship), discount: discount,
      save: round2(saveLines + discount), total: round2(subtotal + ship - d.amount)
    };
  }
  /* "Saved so far" (Skio 1381 Xv for simple lines): sum over the lines that are not boxes and not one-time of
     (regular - subscriber price) x qty x completed orders (batch 3 review fix: a one-time add-on has never shipped,
     so it adds nothing; Skio's own algorithm leaves it out too, spec 6.7) */
  function savedSoFar(sub, siteCurrency, cpv3) {
    if (!SHOW_SAVED_SO_FAR) return null;
    var f = obj(cpv3) && obj(cpv3.features);
    if (!f || f.showSavedAmount !== true) return null;
    if (isPrepaidSub(sub)) return null;
    var lines = arr(sub.SubscriptionLines);
    if (lines.some(isBoxLine)) return null;
    var cycles = parseInt(sub.cyclesCompleted, 10) || 0, sum = 0;
    for (var i = 0; i < lines.length; i++) {
      var l = lines[i];
      if (!obj(l) || !obj(l.ProductVariant)) return null;
      if (isOneTime(l)) continue;
      var b = basePrice(l.ProductVariant, sub, siteCurrency), p = n(l.priceWithoutDiscount);
      if (b === null || p === null) return null;
      sum += (b - p) * (parseInt(l.quantity, 10) || 0);
    }
    var v = round2(sum * cycles);
    return v > 0.004 ? v : null;
  }

  /* ------------------------------------------------------------------ */
  /* loyalty (spec 7)                                                     */
  /* ------------------------------------------------------------------ */
  var PPD_RE = /(\d+(?:\.\d+)?)\s*points?\s+per\s+\$\s*1\b/i;
  function firstNumber(o, depth) {
    if (depth > 3 || o == null) return null;
    if (typeof o === 'number') return isFinite(o) && o > 0 ? o : null;
    if (typeof o !== 'object') return null;
    var ks = Object.keys(o);
    for (var i = 0; i < ks.length; i++) { var v = firstNumber(o[ks[i]], depth + 1); if (v !== null) return v; }
    return null;
  }
  function parseLadder(groups) {
    var levels = [];
    arr(groups).forEach(function (g) { arr(g && g.TierLevels).forEach(function (t) { if (obj(t) && t.name) levels.push(t); }); });
    if (!levels.length) return null;
    var out = levels.map(function (t) {
      var short = M.tierName(t.name), core = M.tierFor(short);
      var threshold = null, conds = obj(t.eligibility) ? arr(t.eligibility.conditions) : [];
      if (conds.length === 1 && conds[0] && conds[0].name === 'STREAK' && obj(conds[0].value)) {
        var sc = n(conds[0].value.streakCount);
        if (sc !== null && sc >= 0) threshold = sc;
      } else if (conds.length) {
        threshold = NaN;    /* another rule (or several): progress cannot be computed */
      }
      var ppd = null;
      arr(t.TierRewards).forEach(function (r) {
        if (ppd !== null || !obj(r)) return;
        var m = PPD_RE.exec(str(r.name)) || PPD_RE.exec(str(r.description));
        if (m) ppd = parseFloat(m[1]);
      });
      if (ppd === null) arr(t.TierRewards).forEach(function (r) {
        if (ppd === null && obj(r) && obj(r.rewardData) && r.rewardData.type === 'CREDIT') ppd = firstNumber(r.rewardData.rewardConfig, 0);
      });
      if (ppd === null && core && core.name === short) ppd = core.pointsPerDollar;
      return { name: short, key: core ? core.key : null, threshold: threshold, ppd: ppd, iconUrl: t.iconUrl || null, core: core };
    });
    /* MK's table (handoff 2.2) fills a missing STREAK threshold only when every tier name matches it */
    var allCore = out.length === M.TIERS.length && out.every(function (t) { return t.core && t.core.name === t.name; });
    out.forEach(function (t) { if (t.threshold === null && allCore) t.threshold = t.core.minStreak; });
    var parsed = out.every(function (t) { return typeof t.threshold === 'number' && isFinite(t.threshold); });
    if (parsed) out.sort(function (a, b) { return a.threshold - b.threshold; });
    return { tiers: out, parsed: parsed };
  }
  function currentTier(ladder, tierRecs) {
    var rec = arr(tierRecs)[0];
    var name = rec && rec.TierLevel && rec.TierLevel.name ? M.tierName(rec.TierLevel.name) : '';
    if (!name) return null;
    var found = null;
    if (ladder) ladder.tiers.forEach(function (t) { if (!found && t.name.toLowerCase() === name.toLowerCase()) found = t; });
    if (!found) {
      var core = M.tierFor(name);
      found = { name: name, key: core ? core.key : null, threshold: null, ppd: core && core.name === name ? core.pointsPerDollar : null, iconUrl: rec.TierLevel.iconUrl || null };
    }
    return found;
  }
  function tierProgress(ladder, tier, streak, singleSub) {
    if (!ladder || !ladder.parsed || !tier || !singleSub || typeof streak !== 'number') return null;
    var i = ladder.tiers.indexOf(tier);
    if (i < 0 || i === ladder.tiers.length - 1) return null;
    var next = ladder.tiers[i + 1];
    if (!(tier.threshold <= streak && streak < next.threshold)) return null;   /* consistency check (spec 7.6c) */
    return { next: next, remaining: next.threshold - streak, done: streak - tier.threshold, span: next.threshold - tier.threshold };
  }

  /* points balance: only Skio's own page shows it (spec 7.1) */
  function readBalance() {
    var b = M.byName('loyalty-link-banner');
    if (!b) return null;
    var ps = M.qa('p', b);
    ps.sort(function (a, c) { return (/\bfont-bold\b/.test(c.className) ? 1 : 0) - (/\bfont-bold\b/.test(a.className) ? 1 : 0); });
    for (var i = 0; i < ps.length; i++) {
      var t = str(ps[i].textContent).trim();
      var m = /^([\d,]{1,12})(\s*(points?|pts))?$/i.exec(t);
      if (m) { var v = parseInt(m[1].replace(/,/g, ''), 10); if (isFinite(v) && v >= 0) return v; }
    }
    return null;
  }

  /* ------------------------------------------------------------------ */
  /* data loading                                                          */
  /* ------------------------------------------------------------------ */
  function loadFirstOrder(uid) {
    return M.skio(Q_FIRST_ORDER, { storefrontUserId: uid }, { ttl: 300000 }).then(function (r) {
      if (okResult(r) && Array.isArray(r.data.Orders)) return r;
      return M.skio(Q_ORDERS_FOR_USER, { storefrontUserId: uid, limit: 1, offset: 0, orderBy: [{ createdAt: 'asc' }] }, { ttl: 300000 });
    }).then(function (r) {
      var o = okResult(r) ? arr(r.data.Orders)[0] : null;
      return o && o.createdAt ? o.createdAt : null;
    }, function () { return null; });
  }
  function fromHome(d) {
    if (!Array.isArray(d.Subscriptions)) return null;
    return { user: obj(d.StorefrontUserByPk) || {}, subs: d.Subscriptions, site: obj(d.SiteByPk) || {}, source: 'mkHome' };
  }
  /* spec 4: if the composite fails, Skio's own documents (still read-only) */
  function loadFallback(uid) {
    return Promise.all([
      M.skio(Q_SUBS_LIST, { storefrontUserId: uid }),
      M.skio(Q_LOYALTY_INFO, { storefrontUserId: uid }),
      M.skio(Q_TIER_GROUPS, { siteId: SITE_ID }, { ttl: 300000 })
    ]).then(function (rs) {
      if (!okResult(rs[0]) || !Array.isArray(rs[0].data.Subscriptions)) return null;
      var subs = rs[0].data.Subscriptions.filter(obj);
      var open = subs.filter(isOpen).sort(soonest);
      if (!open.length) return { user: {}, subs: subs, site: {}, source: 'fallback' };
      return M.skio(Q_SUB_BY_ID, { subscriptionId: open[0].id }).then(function (r) {
        var full = okResult(r) && obj(r.data.SubscriptionByPk);
        if (!full) return null;
        var info = okResult(rs[1]) ? obj(rs[1].data.StorefrontUserByPk) : null;
        var tg = okResult(rs[2]) && obj(rs[2].data.SiteByPk) ? rs[2].data.SiteByPk.TierGroups : null;
        var su = obj(full.StorefrontUser) || {}, site = obj(su.Site) || {};
        return {
          user: { firstName: (info && info.firstName) || su.firstName || null, createdAt: info ? info.createdAt : null, StorefrontUserTiers: info ? info.StorefrontUserTiers : null },
          subs: subs.map(function (s) { return s.id === full.id ? full : s; }),
          site: { currencyCode: site.currencyCode || null, ianaTimezone: null, settings: site.settings || null, cpv3Settings: null, TierGroups: tg },
          source: 'fallback'
        };
      });
    });
  }
  /* the one mkHome answer (or Skio's own documents) as {user, subs, site, source}; the panel and
     the Upcoming orders screen both read it. MKPortal.skio() shares the request while it is in
     flight and caches the answer for 60 s (same query text, same customer), so asking twice sends
     one request. */
  function rawFor(uid, fresh) {
    return M.skio(Q_HOME, { storefrontUserId: uid, siteId: SITE_ID }, fresh ? { fresh: true } : {}).then(function (r) {
      var raw = okResult(r) ? fromHome(r.data) : null;
      return raw || loadFallback(uid);
    });
  }
  function loadRaw() {
    return M.storefrontUserId().then(function (uid) { return uid ? rawFor(uid) : null; })
      .then(null, function (e) { M.log('home: load failed', e && e.message); return null; });
  }
  function loadModel(onToken) {
    return M.storefrontUserId().then(function (uid) {
      if (!uid) return null;
      if (onToken) onToken();
      var first = loadFirstOrder(uid);
      return rawFor(uid).then(function (raw) {
        if (!raw) return null;
        return first.then(function (fo) {
          var m = buildModel(raw, fo);
          if (m) loadCombine(m);     /* starts now; usually answered before the first paint */
          return m;
        });
      });
    }).then(null, function (e) { M.log('home: load failed', e && e.message); return null; });
  }

  /* ------------------------------------------------------------------ */
  /* model                                                                 */
  /* ------------------------------------------------------------------ */
  function buildModel(raw, firstOrderAt) {
    var subs = arr(raw.subs).filter(function (s) { return obj(s) && validId(s.id); });
    if (!subs.length || subs.some(needsAttention)) return null;   /* Skio's own prompts must stay visible */
    var open = subs.filter(isOpen).sort(soonest);
    if (!open.length) return null;
    var main = open[0];
    var site = raw.site || {}, user = raw.user || {};
    var tz = validTz(site.ianaTimezone);
    var siteCurrency = /^[A-Z]{3}$/.test(str(site.currencyCode)) ? site.currencyCode : null;
    var lines = nextLines(main);
    if (!lines.length) return null;
    var cpv3 = obj(site.cpv3Settings);
    var settings = obj(site.settings);
    var credit = settings && obj(settings.creditSettings);
    var rate = credit ? n(credit.siteCurrencyToCreditRate) : null;
    if (!(rate > 0)) rate = M.POINTS_PER_DOLLAR;

    var money = orderMoney(main, lines, siteCurrency);
    var ladder = parseLadder(site.TierGroups);
    var tier = currentTier(ladder, user.StorefrontUserTiers);
    var streak = n(main.streakCount);
    var live = subs.filter(function (s) { return s.status !== 'CANCELLED'; });
    var singleSub = live.length === 1 && open.length === 1;
    var progress = tierProgress(ladder, tier, streak, singleSub);
    var earn = money && tier && tier.ppd ? M.earnPoints(money.subtotal - money.discount, tier.ppd) : null;

    /* "Your subscriptions": every listed subscription; the Combine prompt is computed against the
       others (the ones the Combine card on the NEXT ORDER page would offer) */
    var listedAll = listedSubs(raw, main.id);
    var rows = subsList(raw, main.id);
    var others = rows.length ? listedAll.filter(function (s) { return s !== main; }) : [];

    /* member since (F-2, batch 2): shown for every customer, from the same source as the Rewards page's
       "Member since" (Skio's tier card "Joined <date>" = StorefrontUserTiers[0].joinDate, the record Skio
       itself reads), in the customer's own calendar like Skio's; without that record, the earliest of first
       order, first subscription and customer record (spec 6.1, no 30-day rule any more) */
    var sinceZone = null;
    var tierRecs = arr(user.StorefrontUserTiers);
    var joined = obj(tierRecs[0]) && tierRecs[0].joinDate ? M.toDate(tierRecs[0].joinDate) : null;
    var since = joined && Number(joined) <= Date.now() + 86400000 ? joined : null;
    if (!since) {
      var dates = [firstOrderAt, user.createdAt].concat(subs.map(function (s) { return s.createdAt; }))
        .map(function (v) { return v ? M.toDate(v) : null; }).filter(Boolean);
      since = dates.length ? new Date(Math.min.apply(null, dates.map(Number))) : null;
      sinceZone = tz;
    }

    var actionOn = actionsFrom(cpv3);
    var prepaid = isPrepaidSub(main);

    return {
      source: raw.source, tz: tz, siteCurrency: siteCurrency, cpv3: cpv3, rate: rate,
      firstName: str(user.firstName).trim().slice(0, 60),
      since: since, sinceZone: sinceZone, streak: streak, singleSub: singleSub,
      main: main, lines: lines, money: money, earn: earn,
      activeSubs: subs.filter(function (s) { return s.status === 'ACTIVE' || s.status === 'PAUSED'; }),
      tier: tier, progress: progress, ladder: ladder,
      /* r10 review (1.3.1): a tier DISCOUNT reward changes prices: the suggestions and the Add pop-up fail closed */
      tierDiscount: catTierDiscount(site.TierGroups, tier),
      raw: raw, subs: rows, listedCount: listedAll.length, others: others,
      saved: savedSoFar(main, siteCurrency, cpv3),
      can: {
        orderNow: actionOn('Order now'), skip: actionOn('Skip'), date: actionOn('Next order date'),
        frequency: actionOn('Edit frequency') && !prepaid && !main.isDigital
      }
    };
  }

  /* ------------------------------------------------------------------ */
  /* "Your subscriptions" rows (round 2 spec BC 2.3, 2.4); pure           */
  /* ------------------------------------------------------------------ */
  function lineName(l) { var q = parseInt(l.quantity, 10) || 1; return lineTitle(l) + (q > 1 ? ' \u00D7 ' + q : ''); }
  function namesText(lines, max) {
    var names = lines.slice(0, max).map(lineName);
    if (lines.length > max) names.push('+' + (lines.length - max) + ' more');
    return names.join(', ');
  }
  function thumbUrls(lines, max) {
    var out = [];
    lines.forEach(function (l) { if (out.length < max) { var u = img(lineImage(l), 96); if (u) out.push(u); } });
    return out;
  }
  function productLines(s) { return arr(s.SubscriptionLines).filter(function (l) { return obj(l) && obj(l.ProductVariant); }); }
  /* -> [{id, url, main, names, meta, schedule, when, status: 'Active'|'Paused', paused, prepaid, thumbs[]}]
     meta = schedule + when as one string (accessible name); the view shows them as two pieces so the date
     starts its own line on phones without a hanging dot */
  function subsList(raw, mainId, opts) {
    var o = opts || DECISION_SUBS_LIST;
    if (!o.enabled) return [];
    var list = listedSubs(raw, mainId);
    if (list.length === 1 && !o.showWhenSingle) return [];
    var site = obj(raw && raw.site) || {};
    var tz = validTz(site.ianaTimezone);
    var maxNames = o.maxNames || 2, maxThumbs = o.maxThumbs || 3;
    return list.map(function (s) {
      var lines = productLines(s);
      var held = s.status === 'ACTIVE' && s.statusContext === 'TEMPORARILY_PAUSED';
      var date = s.nextBillingDate ? dayText(s.nextBillingDate, tz, 'short') : '';
      var when = s.status === 'PAUSED' || !date ? '' : held ? 'Resumes ' + date : 'Next order ' + date;
      return {
        id: s.id, url: subUrl(s.id), main: s.id === mainId,
        names: namesText(lines, maxNames) || 'Subscription',
        /* "Next order Oct 30" wraps as one piece on narrow screens */
        meta: [schedule(s.BillingPolicy), when.replace(/ /g, '\u00A0')].filter(Boolean).join(DOT),
        schedule: schedule(s.BillingPolicy), when: when.replace(/ /g, '\u00A0'),
        status: s.status === 'PAUSED' || held ? 'Paused' : 'Active', paused: s.status === 'PAUSED' || held,
        prepaid: isPrepaidSub(s), thumbs: thumbUrls(lines, maxThumbs)
      };
    });
  }

  /* ------------------------------------------------------------------ */
  /* Upcoming orders model (round 2 spec BC 4); pure                       */
  /* ------------------------------------------------------------------ */
  /* a later order's price only when nothing on it can change before then: no limited discount, no box */
  function laterPriceOk(lines) {
    return lines.length > 0 && !lines.some(isBoxLine) && lines.every(function (l) {
      return arr(l.Discounts).every(function (d) { return !obj(d) || d.maxTimesUsed == null; });
    });
  }
  var MONTH_FMT = {};
  function monthTitle(ymd, thisYear) {
    var y = +ymd.slice(0, 4), m = +ymd.slice(5, 7);
    var k = y === thisYear ? 'm' : 'my';
    if (!MONTH_FMT[k]) MONTH_FMT[k] = new Intl.DateTimeFormat('en-US', k === 'm' ? { month: 'long', timeZone: 'UTC' } : { month: 'long', year: 'numeric', timeZone: 'UTC' });
    return MONTH_FMT[k].format(new Date(Date.UTC(y, m - 1, 15, 12)));
  }
  var DOW_FMT = new Intl.DateTimeFormat('en-US', { weekday: 'short', timeZone: 'UTC' });
  /* raw -> {rows, months, notListed, foot, attention, full, tz, today, until}
     opts: {now, timeZone (default: the store's), horizonDays, perSub, maxRows, showPrices} */
  function upcomingModel(raw, opts) {
    opts = opts || {};
    var D = DECISION_UPCOMING;
    var horizon = typeof opts.horizonDays === 'number' ? opts.horizonDays : D.horizonDays;
    var perSub = opts.perSub || D.perSub, maxRows = opts.maxRows || D.maxRows;
    var showPrices = typeof opts.showPrices === 'boolean' ? opts.showPrices : D.showPrices;
    var now = typeof opts.now === 'number' ? opts.now : Date.now();
    var site = obj(raw && raw.site) || {};
    var full = !!raw && raw.source === 'mkHome';
    var tz = validTz(opts.timeZone !== undefined ? opts.timeZone : site.ianaTimezone) || null;
    var dopt = { timeZone: tz || undefined, now: now };
    var siteCurrency = /^[A-Z]{3}$/.test(str(site.currencyCode)) ? site.currencyCode : null;
    var actionOn = actionsFrom(obj(site.cpv3Settings));
    var subs = arr(raw && raw.subs).filter(function (s) { return obj(s) && validId(s.id); });
    var today = S.siteYmd(new Date(now).toISOString(), tz);
    var until = today ? S.ymd(M.addDays(today, horizon)) : null;
    var thisYear = today ? +today.slice(0, 4) : new Date(now).getFullYear();
    var rows = [], notListed = [], cut = [], later = [];
    listedSubs(raw, null).forEach(function (s, idx) {
      var n = S.normalize(s, full);
      if (!n) return;
      var label = schedule(s.BillingPolicy);
      var names = namesText(productLines(s), 3) || 'Subscription';
      var base0 = { id: s.id, url: subUrl(s.id), names: names, schedule: label };
      var held = s.status === 'ACTIVE' && s.statusContext === 'TEMPORARILY_PAUSED';
      if (s.status === 'PAUSED' || held) {
        var rd = held && s.nextBillingDate ? M.formatDate(S.siteYmd(s.nextBillingDate, tz) || s.nextBillingDate, 'short', dopt) : '';
        notListed.push(Object.assign({ text: rd ? 'Resumes ' + rd : 'Paused' }, base0));
        return;
      }
      if (!S.open(n)) return;                                      /* gift, digital, on hold: not listed */
      if (full && n.prepaid) { notListed.push(Object.assign({ text: 'Prepaid: see its page for delivery dates' }, base0)); return; }
      var dates = S.upcoming(n, tz, { max: perSub, until: until });
      if (!dates.length) return;
      var rawLines = arr(s.SubscriptionLines).filter(function (l) { return !!S.normLine(l); });   /* index-aligned with n.lines */
      dates.forEach(function (d) {
        /* the next order: exactly the NEXT ORDER card's lines and money; later ones from the schedule rules */
        var lines = d.k === 1 ? nextLines(s) : d.lines.map(function (l) { return rawLines[n.lines.indexOf(l)]; }).filter(Boolean);
        var money = null;
        if (showPrices && full && lines.length && (d.k === 1 || laterPriceOk(lines))) money = orderMoney(s, lines, siteCurrency);
        var rel = M.daysFromToday(d.ymd, dopt);
        rows.push({
          id: s.id, url: subUrl(s.id), k: d.k, ymd: d.ymd, next: d.k === 1, order: idx, schedule: label,
          dow: rel === 0 ? 'Today' : rel === 1 ? 'Tomorrow' : DOW_FMT.format(new Date(Date.UTC(+d.ymd.slice(0, 4), +d.ymd.slice(5, 7) - 1, +d.ymd.slice(8, 10), 12))),
          day: String(+d.ymd.slice(8, 10)), date: M.formatDate(d.ymd, 'weekday', dopt), dateShort: M.formatDate(d.ymd, 'short', dopt),
          names: lines.length ? namesText(lines.map(function (l) {
            return isOneTime(l) ? Object.assign({}, l, { titleOverride: lineTitle(l) + ' (this order only)' }) : l;
          }), 3) : '',
          thumbs: thumbUrls(lines, 2),
          price: money ? { total: money.total, currency: money.currency } : null, later: d.k > 1 && !!money,
          skip: d.k === 1 && actionOn('Skip'), changeDate: d.k === 1 && actionOn('Next order date')
        });
      });
      /* cut short before the horizon for another reason (month-end rule, anchors, skip-cycle, max
         per subscription, unreadable schedule): say where the later dates are. Not after the last
         order of a limited subscription (maxCycles). */
      if (!full) return;
      var last = dates[dates.length - 1];
      var ended = n.maxCycles !== null && dates.length >= n.maxCycles - n.cycles;
      var after = label ? S.ymd(M.addInterval(last.ymd, n.interval, n.count)) : null;
      if (!ended && (!after || !until || after <= until)) cut.push(base0);
      else if (!ended && after && until && after > until) later.push(base0);   /* more orders after the horizon */
    });
    rows.sort(function (a, b) { return a.ymd < b.ymd ? -1 : a.ymd > b.ymd ? 1 : a.order - b.order || (a.id < b.id ? -1 : a.id > b.id ? 1 : a.k - b.k); });
    /* at most maxRows: every next order stays, later ones are dropped from the end */
    var nexts = rows.filter(function (r) { return r.next; }).length, room = Math.max(0, maxRows - nexts), dropped = 0;
    rows = rows.filter(function (r) { if (r.next) return true; if (room > 0) { room--; return true; } dropped++; return false; });
    /* every subscription's first row says "Next order": each row names its own products, and the list
       is sorted by date, so the soonest one is simply at the top (Jim, 2026-10-11) */
    rows.forEach(function (r) { r.tag = r.next ? 'Next order' : ''; });
    var months = [];
    rows.forEach(function (r) {
      var key = r.ymd.slice(0, 7), mo = months[months.length - 1];
      if (!mo || mo.key !== key) months.push(mo = { key: key, title: monthTitle(r.ymd, thisYear), rows: [] });
      mo.rows.push(r);
    });
    var foot = [];
    if (rows.length) foot.push({ text: 'Dates follow each subscription\'s schedule. Skipping an order or changing a date updates this list.' });
    if (rows.some(function (r) { return r.skip || r.changeDate; })) foot.push({ text: 'Skip or change the next order of a subscription here; later orders move with it.' });
    if (rows.some(function (r) { return r.later; })) foot.push({ text: 'Later orders use today\'s prices and discounts, before tax.', mark: true });
    cut.forEach(function (c) {
      foot.push({ text: 'Later orders for ' + c.names + (c.schedule ? ' (' + c.schedule.toLowerCase() + ')' : '') + ' are on ', link: 'its page', url: c.url, after: '.' });
    });
    if (dropped) foot.push({ text: 'More orders are on each subscription\'s page.' });
    else if (full && later.length) {
      /* the list stops at the horizon: say where the later dates are (round 2 review) */
      if (later.length === 1 && listedSubs(raw, null).length === 1) foot.push({ text: 'Later dates are on ', link: 'its page', url: later[0].url, after: '.' });
      else foot.push({ text: 'Later dates are on each subscription\'s page.' });
    }
    if (!full && rows.length) foot.push({ text: 'Later dates are on each subscription\'s page.' });
    var span = horizon % 30 === 0 ? (horizon / 30 === 1 ? 'month' : (horizon / 30) + ' months') : horizon + ' days';
    var beyond = !!until && rows.some(function (r) { return r.ymd > until; });
    var intro = beyond ? 'Each subscription\'s next order and every order in the next ' + span + ', soonest first.'
      : 'Your scheduled orders for the next ' + span + ', soonest first.';
    return {
      rows: rows, months: months, notListed: notListed, foot: foot, full: full, tz: tz, today: today, until: until, intro: intro,
      attention: subs.some(needsAttention)
    };
  }

  /* one-time upsells (spec 10) */
  function loadPicks(model) {
    if (!DECISION_8A_SUGGESTIONS.enabled) return Promise.resolve([]);
    return M.skio(Q_UPSELLS, { siteId: SITE_ID, where: {}, limit: 24, offset: 0 }, { ttl: 300000 }).then(function (r) {
      var products = okResult(r) && obj(r.data.SiteByPk) ? arr(r.data.SiteByPk.UpsellProducts) : null;
      if (!products) return [];
      return pickSuggestions(products, model);
    });
  }
  function pickSuggestions(products, model) {
    var main = model.main, excluded = {}, inOrder = {};
    if (model.tierDiscount) return [];     /* r10 review: prices would be wrong (the catalogue fails closed the same way) */
    model.activeSubs.forEach(function (s) {
      arr(s.SubscriptionLines).forEach(function (l) {
        var pid = l && l.ProductVariant && l.ProductVariant.Product && l.ProductVariant.Product.id;
        if (!pid) return;
        if (s === main) inOrder[pid] = true;
        if (!isOneTime(l)) excluded[pid] = true;
      });
    });
    var out = [];
    products.forEach(function (p) {
      if (out.length >= DECISION_8A_SUGGESTIONS.max || !obj(p) || !p.id) return;
      if (p.hideOn1TimeUpsells || p.canUpsell === false || excluded[p.id] || inOrder[p.id]) return;
      if (p.DynamicBox || arr(p.showProductForCustomerTags).length) return;
      if (p.status && p.status !== 'ACTIVE' && p.status !== 'UNLISTED') return;
      var v = arr(p.ProductVariants).filter(function (x) {
        return obj(x) && x.enableOneTimeUpsell && !x.outOfStockAt && !x.deletedAt && !(x.ClassicBoxV2 && x.ClassicBoxV2.id);
      })[0];
      if (!v) return;
      var reg = regularPrice(v, main, model.siteCurrency), bp = basePrice(v, main, model.siteCurrency);
      var off = n(p.oneTimeUpsellPercentageOff);
      if (bp === null || reg === null) return;
      var pct = off !== null && off > 0 && off < 1 ? off : 0;
      var price = round2(bp * (100 - pct * 100) / 100);
      out.push({
        title: str(p.title).trim(), variant: v.title && v.title !== 'Default Title' ? str(v.title) : '',
        image: v.image || p.imageSrc, price: price, struck: reg - price > 0.01 ? reg : null,
        points: model.tier && model.tier.ppd ? M.earnPoints(price, model.tier.ppd) : null,
        /* for the Add pop-up (batch 3): Skio's own product record and the variant the row shows */
        pid: str(p.id), vid: str(v.id), product: p
      });
    });
    return out.filter(function (x) { return x.title; });
  }

  /* "arrives about": the customer's own delivery history only (spec 11.5) */
  function median(a) {
    var s = a.slice().sort(function (x, y) { return x - y; }), m = Math.floor(s.length / 2);
    return s.length % 2 ? s[m] : Math.round((s[m - 1] + s[m]) / 2);
  }
  /* the delivery service's timestamps as real instants (a string ending in T00:00:00Z would otherwise count as a
     date-only value in the core and land on the wrong day in the Americas) */
  function instant(v) { var t = typeof v === 'string' ? Date.parse(v) : NaN; return isFinite(t) ? new Date(t) : null; }
  function arrivesAbout(body, model) {
    var ship = [], transit = [], tz = { timeZone: model.tz };
    arr(body && body.orders).forEach(function (o) {
      if (!obj(o) || o.status === 'canceled' || o.partiallyShipped) return;
      var f = obj(arr(o.fulfillments)[0]);
      if (!f) return;
      if (o.processedAt && f.shippedAt) { var a = M.daysBetween(instant(o.processedAt), instant(f.shippedAt), tz); if (a !== null && a >= 0 && a <= 21) ship.push(a); }
      if (f.shippedAt && f.deliveredAt) { var b = M.daysBetween(instant(f.shippedAt), instant(f.deliveredAt), tz); if (b !== null && b >= 0 && b <= 21) transit.push(b); }
    });
    if (ship.length < 2 || transit.length < 2) return null;
    return arrivesFor(median(ship) + median(transit), model);
  }
  /* -> {days, date}: days = the customer's median processing + transit (r8: kept, so the date pop-up can add it to the
     picked day), date = the NEXT ORDER day + days ('Nov 3') */
  function arrivesFor(days, model) {
    var day = orderYmd(model.main.nextBillingDate, model.tz) || M.formatDate(model.main.nextBillingDate, 'iso', { timeZone: model.tz });
    var d = day ? M.addDays(day, days) : null;
    return d ? { days: days, date: M.formatDate(d, 'short') } : null;
  }

  /* ------------------------------------------------------------------ */
  /* Combine prompt: the Combine card's own decision, repeated here        */
  /* (extensions/mk-ext-combine.html v3: build(), readSub(), every(),      */
  /*  addrKey(), prepaid(), isDismissed()). Read-only: nothing is written. */
  /* ------------------------------------------------------------------ */
  var CX_MERGE_SWITCH = 'Merge subscription';          /* the card's MERGE_SWITCH */
  var CX_STORE_PREFIX = 'mk-x-combine:dismissed:';     /* the card's STORE_PREFIX ("Not now") */
  var CX_UNITS = { DAY: 'day', WEEK: 'week', MONTH: 'month', YEAR: 'year' };
  function cxJson(v) {
    if (typeof v === 'string') { try { return JSON.parse(v); } catch (e) { return null; } }
    return v;
  }
  function cxEvery(p) {
    if (!obj(p)) return null;
    var unit = CX_UNITS[String(p.interval || '').toUpperCase()];
    var c = Number(p.intervalCount);
    if (!unit || !(c >= 1) || Math.floor(c) !== c) return null;
    return c === 1 ? 'every ' + unit : 'every ' + c + ' ' + unit + 's';
  }
  function cxAddrKey(a) {
    if (!obj(a)) return null;
    var key = ['address1', 'address2', 'city', 'province', 'zip', 'country'].map(function (k) {
      return String(a[k] == null ? '' : a[k]).trim().toLowerCase().replace(/\s+/g, ' ');
    }).join('|');
    return key.replace(/\|/g, '') ? key : null;
  }
  /* the card's readSub(): null in exactly the same cases; only what the decision uses */
  function cxSub(s) {
    if (!obj(s) || typeof s.id !== 'string' || !Array.isArray(s.SubscriptionLines)) return null;
    if (typeof s.currencyCode !== 'string' || !s.currencyCode) return null;
    var next = s.nextBillingDate ? new Date(s.nextBillingDate) : null;
    var freq = cxEvery(s.BillingPolicy);
    if (!next || isNaN(next.getTime()) || !freq) return null;
    return { id: s.id, freq: freq, lines: s.SubscriptionLines.filter(obj).length, addr: obj(s.ShippingAddress) };
  }
  function cxPrepaid(s) { return !!s.PrepaidDeliveryPolicy || (s.prepaidDeliveryPolicyId !== null && s.prepaidDeliveryPolicyId !== undefined); }
  /* -> {ids: [subscriptions the card would offer], key: its "Not now" storage key} or null (no card) */
  function combineCheck(res, mainId, cfg) {
    cfg = cfg || COMBINE_CARD;
    if (!obj(res) || res.errors || !obj(res.data) || !Array.isArray(res.data.Subscriptions)) return null;
    var u = res.data.StorefrontUserByPk;
    var site = obj(u) && obj(u.Site) ? u.Site : null;
    var flags = null;
    if (cfg.FOLLOW_SKIO_MERGE_SWITCH) {
      var cpv3 = site ? cxJson(site.cpv3Settings) : null;
      var toggles = obj(cpv3) ? cxJson(cpv3.actionButtonToggleSettings) : null;
      if (!obj(toggles) || !toggles[CX_MERGE_SWITCH]) return null;
      flags = {};
      arr(site.FeatureFlags).forEach(function (f) { if (obj(f) && f.name) flags[f.name] = f.enabled === true; });
    }
    /* Skio: digital counts only while the memberships feature is on; flags not read = digital */
    function digital(s) { return s.isDigital === true && (flags ? flags.enableMemberships === true : true); }
    var all = res.data.Subscriptions, curRaw = null;
    for (var i = 0; i < all.length; i++) if (obj(all[i]) && all[i].id === mainId) curRaw = all[i];
    if (!curRaw || curRaw.status !== 'ACTIVE' || cxPrepaid(curRaw) || digital(curRaw)) return null;
    if (curRaw.prepaidGiftRecipientId != null || curRaw.statusContext === 'TEMPORARILY_PAUSED') return null;
    var cur = cxSub(curRaw);
    if (!cur || !cur.lines) return null;
    var curKey = cxAddrKey(cur.addr), ids = [], opt = [];
    all.forEach(function (e) {
      if (!obj(e) || e.id === curRaw.id) return;
      var ok = e.status === 'ACTIVE' && !cxPrepaid(e) && !digital(e) &&
        e.currencyCode === curRaw.currencyCode &&
        ((e.deliveryPriceOverride == null && curRaw.deliveryPriceOverride == null) ||
          [curRaw, e].every(function (x) { return x.deliveryPriceOverride === 1 && x.deliveryPrice === 0; })) &&
        e.prepaidGiftRecipientId == null && e.statusContext !== 'TEMPORARILY_PAUSED';
      if (!ok) return;
      var c = cxSub(e);
      if (!c || !c.lines) return;
      var k = cxAddrKey(c.addr);
      var optIn = c.freq !== cur.freq || !!(curKey && k && k !== curKey);
      if (optIn && !cfg.OFFER_DIFFERENT_SCHEDULES) return;
      ids.push(c.id);
      if (optIn) opt.push(c.id);       /* the card offers it but never ticks it */
    });
    if (!ids.length) return null;
    return { ids: ids, optIn: opt, key: CX_STORE_PREFIX + [cur.id].concat(ids).sort().join(',') };
  }
  /* the card's isDismissed(): its "Not now" memory lives in this origin's storage (read only) */
  function combineDismissed(key, cfg) {
    cfg = cfg || COMBINE_CARD;
    try {
      var v = window.localStorage.getItem(key);
      if (!v) return false;
      if (cfg.DISMISS_DAYS == null) return true;
      var t = parseInt(v, 10);
      return isFinite(t) && Date.now() - t < cfg.DISMISS_DAYS * 864e5;
    } catch (e) { return false; }
  }
  /* Skio subscription ids are UUIDs (getSubscriptionById($subscriptionId: uuid!)); anything else: no prompt */
  var CX_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  function combineWanted(model) {
    return !!(DECISION_COMBINE_PROMPT.enabled && model && model.main && model.others.length && CX_UUID.test(String(model.main.id)));
  }
  /* -> {text} or null (no prompt). The wording follows what the card will show:
     "Get ..." when it would tick at least one (same schedule and address),
     "See if ... can go in one order" when it would tick none (each offered one
     changes schedule or address, so the customer decides on the card). */
  function combinePrompt(res, model) {
    if (!combineWanted(model)) return null;
    var c = combineCheck(res, model.main.id);
    if (!c || combineDismissed(c.key)) return null;
    var listed = model.others.map(function (s) { return s.id; });
    var offered = c.ids.filter(function (id) { return listed.indexOf(id) >= 0; });
    if (!offered.length) return null;
    var ticked = offered.filter(function (id) { return c.optIn.indexOf(id) < 0; }).length > 0;
    return { text: combineText(listed.length, offered.length === listed.length, ticked) };
  }
  function combineText(listed, all, ticked) {
    var who = listed === 1 ? 'both' : all ? 'these' : 'some of these';
    return ticked ? 'Get ' + who + ' in one order' : 'See if ' + who + ' can go in one order';
  }
  /* the prompt fails closed on its own: a problem in it hides only the prompt, never the panel */
  function safePrompt(res, model) {
    try { return combinePrompt(res, model); } catch (e) { return null; }
  }
  /* debug log only (live check H5): how Skio stores the Merge switch (true/false or an object such as
     {enabled: false}); the card and this module treat any truthy value as "on" */
  function mergeShape(r) {
    try {
      var c = cxJson(r.data.StorefrontUserByPk.Site.cpv3Settings);
      var t = obj(c) ? cxJson(c.actionButtonToggleSettings) : null;
      var v = obj(t) ? t[CX_MERGE_SWITCH] : undefined;
      return obj(v) ? 'an object with keys ' + Object.keys(v).join(',') : typeof v === 'boolean' ? String(v) : typeof v;
    } catch (e) { return 'unreadable'; }
  }
  function loadCombine(model) {
    if (!combineWanted(model)) return;
    model.combineReq = M.storefrontUserId().then(function (uid) {
      return uid ? M.skio(Q_COMBINE, { storefrontUserId: uid }) : null;
    }).then(function (r) {
      M.log('home: combine: Merge subscription switch stored as ' + mergeShape(r));
      model.combineRes = r; model.combineDone = true; return r;
    },
      function () { model.combineRes = null; model.combineDone = true; return null; });
  }

  /* ------------------------------------------------------------------ */
  /* view                                                                  */
  /* ------------------------------------------------------------------ */
  function icon(name) {
    var P = {
      star: ['M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3 6.4 20.2l1.1-6.2L3 9.6l6.2-.9z'],
      chevron: ['M9 6l6 6-6 6'],
      back: ['M15 6l-6 6 6 6'],
      calendar: ['M8 2v4', 'M16 2v4', 'M3 9h18', 'M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z'],
      alert: ['M12 9v4', 'M12 17h.01', 'M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z'],
      arrow: ['M5 12h14', 'M13 6l6 6-6 6'],
      check: ['M20 6 9 17l-5-5'],
      /* r10, "Add products" */
      search: ['M11 4a7 7 0 1 0 0 14a7 7 0 1 0 0-14z', 'M20 20l-4.2-4.2'],
      x: ['M6 6l12 12', 'M18 6 6 18'],
      bag: ['M5.5 8h13l-1 12.2a2 2 0 0 1-2 1.8h-7a2 2 0 0 1-2-1.8z', 'M9 8V6.5a3 3 0 0 1 6 0V8', 'M12 11.5v6', 'M9 14.5h6'],
      pause: ['M12 2a10 10 0 1 0 0 20a10 10 0 1 0 0-20z', 'M10 9v6', 'M14 9v6']
    };
    return M.svg('0 0 24 24', P[name] || [], { 'class': 'mkh-ico mkh-ico--' + name });
  }
  function action(kind, label, href, key, extra) {
    var a = el('a', { 'class': 'mkh-btn mkh-btn--' + kind, href: href, 'data-mk-key': key }, label);
    Object.keys(extra || {}).forEach(function (k) { a.setAttribute(k, extra[k]); });
    return a;
  }
  function link(label, href, key, extra) {
    var a = el('a', { 'class': 'mkh-link', href: href, 'data-mk-key': key }, label);
    Object.keys(extra || {}).forEach(function (k) { a.setAttribute(k, extra[k]); });
    return a;
  }
  function lineTitle(l) {
    var t = str(l.titleOverride).trim() || str(l.ProductVariant.Product && l.ProductVariant.Product.title).trim();
    return t || 'Product';
  }
  function lineImage(l) { return l.ProductVariant.image || (l.ProductVariant.Product && l.ProductVariant.Product.imageSrc) || ''; }
  function brandName(b) {
    var k = str(b).toLowerCase().replace(/[\s-]+/g, '_');
    var map = { visa: 'Visa', mastercard: 'Mastercard', master: 'Mastercard', american_express: 'American Express', amex: 'American Express',
      discover: 'Discover', jcb: 'JCB', diners_club: 'Diners Club', shop_pay: 'Shop Pay', paypal: 'PayPal', unionpay: 'UnionPay' };
    if (map[k]) return map[k];
    var w = str(b).replace(/[_-]+/g, ' ').trim().slice(0, 30);
    return w ? w.replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }) : 'Card';
  }
  function cardText(pm) {
    if (!obj(pm)) return null;
    if (pm.revokedAt || pm.skioRevoke) return 'Card needs updating';
    if (pm.paypalAccountEmail) return 'PayPal';
    var last = str(pm.lastDigits).trim();
    var t = /^\d{2,4}$/.test(last) ? brandName(pm.brand) + ' ending ' + last : brandName(pm.brand);
    var y = parseInt(pm.expiryYear, 10), mo = parseInt(pm.expiryMonth, 10);
    if (y > 0 && mo >= 1 && mo <= 12) {
      var now = new Date();
      if (y < 100) y += 2000;
      if (y < now.getFullYear() || (y === now.getFullYear() && mo < now.getMonth() + 1)) t += DOT + 'expired';
    }
    return t;
  }
  function placeText(a) {
    if (!obj(a)) return '';
    return [str(a.city).trim(), str(a.province).trim()].filter(Boolean).join(', ').slice(0, 80);
  }

  function buildHeader(m) {
    var meta = [];
    if (m.since) meta.push('Member since ' + M.formatDate(m.since, 'monthYear', m.sinceZone ? { timeZone: m.sinceZone } : {}));
    /* streaks are per subscription: with several, "N orders in a row" in the header would not
       say which one it belongs to, so it is shown only for a single subscription */
    if (m.singleSub && m.streak >= 2) meta.push(Math.floor(m.streak) + ' orders in a row');
    return el('header', { 'class': 'mkh-head' },
      el('h2', { 'class': 'mkh-hello' }, m.firstName ? 'Hello, ' + m.firstName + ' ' : 'Hello ', el('span', { 'aria-hidden': 'true', 'class': 'mkh-wave' }, WAVE)),
      meta.length ? el('p', { 'class': 'mkh-meta' }, meta.join(DOT)) : null);
  }

  function buildNext(m, st) {
    var s = m.main, url = subUrl(s.id);
    var when = ['Charged that day'];
    if (st.arrives && st.arrives.date) when.push('arrives about ' + st.arrives.date);
    var chip = schedule(s.BillingPolicy);
    var money = m.money;
    var items = el('ul', { 'class': 'mkh-items' }, m.lines.map(function (l, i) {
      var row = money ? money.rows[i] : null;
      var bits = [];
      if (l.ProductVariant.title && l.ProductVariant.title !== 'Default Title') bits.push(str(l.ProductVariant.title));
      bits.push('Qty ' + (parseInt(l.quantity, 10) || 1));
      var src = img(lineImage(l), 160);
      return el('li', { 'class': 'mkh-item' },
        src ? el('img', { src: src, alt: '', loading: 'lazy', decoding: 'async', width: '64', height: '64' }) : el('span', { 'class': 'mkh-img-ph', 'aria-hidden': 'true' }),
        el('div', { 'class': 'mkh-item-main' },
          el('b', null, lineTitle(l)),
          el('span', null, bits.join(DOT)),
          isOneTime(l) ? el('span', { 'class': 'mkh-tag' }, 'This order only') : null),
        row ? el('div', { 'class': 'mkh-item-price' },
          row.struck !== null ? el('s', null, el('span', { 'class': 'mkh-sr' }, 'Regular price '), M.money(row.struck, money.currency)) : null,
          el('b', null, M.money(row.total, money.currency))) : null);
    }));
    var totals = null;
    if (money) {
      totals = el('div', { 'class': 'mkh-totals' },
        el('div', null, el('span', null, 'Shipping'), el('b', null, money.shipping > 0 ? M.money(money.shipping, money.currency) : 'Free')),
        money.save > 0.004 ? el('div', null, el('span', null, 'You save'), el('b', { 'class': 'mkh-save' }, M.money(money.save, money.currency))) : null,
        el('div', { 'class': 'mkh-total' }, el('span', null, 'Total'), el('b', null, M.money(money.total, money.currency))),
        m.earn > 0 ? el('div', { 'class': 'mkh-earn' }, icon('star'), el('span', null, 'This order earns '), el('b', null, M.pointsText(m.earn))) : null);
    } else {
      totals = el('p', { 'class': 'mkh-note' }, 'Prices and totals for this order are on ', link('your subscription page', url, 'nx-prices'), '.');
    }
    var acts = [];
    if (m.can.orderNow) acts.push(action('gold', 'Get it now', url, 'nx-now', { 'data-mk-action': 'order-now', 'data-mk-sub': s.id }));
    if (m.can.skip) acts.push(action('brown', 'Skip this order', url, 'nx-skip', { 'data-mk-action': 'skip', 'data-mk-sub': s.id }));
    /* r8: "Change date" opens the date pop-up when it is offered (aria-haspopup), else the hand-off; a real link either way */
    if (m.can.date) acts.push(action('ghost', 'Change date', url, 'nx-date', dateOffered(s, m.raw && m.raw.source === 'mkHome' ? m.raw.site : null)
      ? { 'data-mk-action': 'change-date', 'data-mk-sub': s.id, 'aria-haspopup': 'dialog' } : { 'data-mk-action': 'change-date', 'data-mk-sub': s.id }));
    return el('article', { 'class': 'mkh-card mkh-next', 'aria-labelledby': 'mkh-next-date' },
      el('div', { 'class': 'mkh-next-head' },
        el('div', null,
          el('p', { 'class': 'mkh-eyebrow' }, 'Next order'),
          el('h2', { 'class': 'mkh-date', id: 'mkh-next-date' }, dayText(s.nextBillingDate, m.tz, 'long')),
          el('p', { 'class': 'mkh-muted' }, when.join(DOT) + DOT, el('b', null, 'change anything before then'))),
        chip ? el('span', { 'class': 'mkh-chip' }, chip) : null),
      /* r8: after a move of THIS order, the confirmation (or, after an unclear outcome, the "checking" line) */
      dateNote && dateNote.subId === s.id ? dateNoteFor(m, 'home') : null,
      el('div', { 'class': 'mkh-items-head' }, el('span', null, 'In this order'),
        link('Edit products', url, 'nx-edit', { 'data-mk-action': 'edit-products', 'data-mk-sub': s.id })),
      items, totals,
      acts.length ? el('div', { 'class': 'mkh-actions' }, acts) : null);
  }

  function thumbs(urls, cls) {
    return el('span', { 'class': 'mkh-thumbs' + (cls ? ' ' + cls : ''), 'aria-hidden': 'true' }, urls.length ? urls.map(function (u) {
      return el('img', { src: u, alt: '', loading: 'lazy', decoding: 'async', width: '40', height: '40' });
    }) : el('span', { 'class': 'mkh-thumb-ph' }));
  }
  /* "Your subscriptions" (round 2 B): every listed subscription, the Combine prompt as its last line */
  function buildSubs(m, st) {
    if (!m.subs.length) return null;
    var cx = st && st.combine;
    return el('section', { 'class': 'mkh-card mkh-subs', 'aria-labelledby': 'mkh-subs-title' },
      el('div', { 'class': 'mkh-subs-head' },
        el('h3', { 'class': 'mkh-card-title', id: 'mkh-subs-title' }, 'Your subscriptions'),
        upcomingOn() && DECISION_SUBS_LIST.upcomingLink ? link('All upcoming orders', UPCOMING_HASH, 'sb-upcoming', { 'data-mk-nav': 'upcoming' }) : null),
      /* F-4 (batch 2): when no row has a second thumbnail, the thumbnail column is one thumbnail wide (no gap
         before the names); with any two-thumbnail row it stays two wide so the names line up */
      el('ul', { 'class': 'mkh-sub-list' + (m.subs.every(function (r) { return r.thumbs.length <= 1; }) ? ' mkh-sub-list--one' : '') }, m.subs.map(function (r, i) {
        var label = 'Manage subscription: ' + r.names + (r.meta ? ', ' + r.meta.split(DOT).join(', ').replace(/\u00A0/g, ' ') : '') + ', ' + r.status + (r.prepaid ? ', prepaid' : '');
        return el('li', null, el('a', { 'class': 'mkh-sub', href: r.url, 'data-mk-key': 'sb-' + i, 'aria-label': label },
          thumbs(r.thumbs),
          el('span', { 'class': 'mkh-sub-main' }, el('b', null, r.names), r.meta ? el('span', { 'class': 'mkh-sub-meta' },
            r.schedule ? el('span', { 'class': 'mkh-sub-sched' }, r.schedule) : null,
            r.when ? el('span', { 'class': 'mkh-sub-when' }, r.when) : null) : null),
          el('span', { 'class': 'mkh-sub-tags' },
            el('span', { 'class': 'mkh-status' + (r.paused ? ' mkh-status--paused' : '') }, r.status),
            r.prepaid ? el('span', { 'class': 'mkh-status mkh-status--paused' }, 'Prepaid') : null),
          el('span', { 'class': 'mkh-sub-go' }, 'Manage', icon('chevron'))));
      })),
      cx ? el('p', { 'class': 'mkh-combine' },
        el('span', { 'class': 'mkh-combine-text' }, cx.text),
        el('a', { 'class': 'mkh-link mkh-combine-link', href: subUrl(m.main.id) + '#mk-combine', 'data-mk-key': 'ot-combine', 'data-mk-nav': 'combine' },
          'Review and combine', icon('arrow'))) : null);
  }

  function buildPicks(m, picks, added) {
    if (!picks || !picks.length) return null;
    var url = subUrl(m.main.id), cur = m.money ? m.money.currency : (m.main.currencyCode || 'USD');
    return el('section', { 'class': 'mkh-card mkh-picks', 'aria-labelledby': 'mkh-picks-title' },
      el('div', { 'class': 'mkh-picks-head' },
        el('h3', { 'class': 'mkh-card-title', id: 'mkh-picks-title' }, 'Add to your ' + dayText(m.main.nextBillingDate, m.tz, 'short') + ' order'),
        /* r10 (question 13): "See all products" opens the "Add products" screen (r9.1's hand-off while it is off) */
        catalogOn() ? link('See all products', base() + '/subscriptions' + CAT_HASH, 'pk-all', { 'data-mk-nav': 'catalog' })
          : link('See all products', url, 'pk-all', { 'data-mk-action': 'add-product', 'data-mk-sub': m.main.id })),
      el('ul', { 'class': 'mkh-pick-list' }, picks.map(function (p, i) {
        var src = img(p.image, 160);
        return el('li', { 'class': 'mkh-pick' },
          src ? el('img', { src: src, alt: '', loading: 'lazy', decoding: 'async', width: '56', height: '56' }) : el('span', { 'class': 'mkh-img-ph', 'aria-hidden': 'true' }),
          el('div', { 'class': 'mkh-pick-main' }, el('b', null, p.title), p.variant ? el('span', null, p.variant) : null),
          el('div', { 'class': 'mkh-pick-buy' },
            el('span', { 'class': 'mkh-pick-price' },
              p.struck !== null ? el('s', null, el('span', { 'class': 'mkh-sr' }, 'Regular price '), M.money(p.struck, cur)) : null,
              p.struck !== null ? ' ' : null,
              el('b', null, M.money(p.price, cur))),
            /* r10 (question 19): the price is Skio's just-this-order price; it says so, as the catalogue's cards do */
            el('span', { 'class': 'mkh-pick-when' }, 'just this order'),
            p.points > 0 ? el('span', { 'class': 'mkh-pick-pts' }, 'Earns ' + M.pointsText(p.points)) : null),
          /* batch 3: once the pop-up added it, the row says so (focus lands here when the pop-up closes) */
          added && p.pid && added[p.pid] ? el('span', { 'class': 'mkh-added', tabindex: '-1', 'data-mk-added': p.pid }, icon('check'), 'Added')
            : action('small', 'Add', url, 'pk-' + i, addOffered(p, m) ? { 'data-mk-action': 'upsell', 'data-mk-sub': m.main.id, 'data-mk-title': p.title.slice(0, 200),
              'data-mk-pick': String(i), 'aria-haspopup': 'dialog', 'aria-label': 'Add ' + p.title.slice(0, 120) }
              : { 'data-mk-action': 'upsell', 'data-mk-sub': m.main.id, 'data-mk-title': p.title.slice(0, 200), 'aria-label': 'Add ' + p.title.slice(0, 120) }));
      })));
  }

  function buildRewards(m, st) {
    var t = m.tier, bal = st.balance;
    if (bal === null && !t) return null;
    var loyalty = base() + '/loyalty';
    var parts = [el('p', { 'class': 'mkh-eyebrow mkh-eyebrow--gold' }, 'Your rewards')];
    if (bal !== null) {
      parts.push(el('p', { 'class': 'mkh-points' }, el('b', null, M.points(bal)), bal === 1 ? ' point' : ' points'));
      var value = Math.floor(bal) / m.rate;
      if (value >= 0.01) parts.push(el('p', { 'class': 'mkh-points-sub' }, M.money(value, m.siteCurrency || 'USD') + ' to spend on your next order'));
    }
    if (t) {
      var art = t.key ? M.tierArt(t.key) : (t.iconUrl ? M.safeUrl(t.iconUrl, { httpsOnly: true }) : '');
      var pr = m.progress;
      var rate = t.ppd ? DOT + ppdText(t.ppd) + ' per $1' : ' tier';
      parts.push(el('div', { 'class': 'mkh-tier' },
        art ? el('img', { src: art, alt: '', width: '26', height: '58', decoding: 'async' }) : null,
        el('div', { 'class': 'mkh-tier-main' },
          el('p', null, el('b', null, t.name), rate),
          pr ? el('div', { 'class': 'mkh-bar', role: 'img', 'aria-label': pr.done + ' of ' + pr.span + ' orders in a row toward ' + pr.next.name },
            el('span', { style: { width: Math.max(4, Math.min(100, Math.round(100 * pr.done / pr.span))) + '%' } })) : null,
          pr ? el('p', { 'class': 'mkh-tier-next' },
            el('b', null, pr.remaining + (pr.remaining === 1 ? ' more order in a row' : ' more orders in a row')),
            ' to reach ' + pr.next.name + (pr.next.ppd ? ': ' + ppdText(pr.next.ppd) + ' per $1' : '')) : null)));
    }
    parts.push(el('div', { 'class': 'mkh-actions mkh-actions--tight' },
      bal > 0 ? action('gold', 'Redeem', loyalty, 'rw-redeem', { 'data-mk-nav': 'redeem' }) : null,
      link('See rewards', loyalty, 'rw-see', { 'data-mk-nav': 'loyalty' })));
    return el('article', { 'class': 'mkh-card mkh-rewards', 'aria-label': 'Your rewards' }, parts);
  }

  function buildDetails(m) {
    var s = m.main, url = subUrl(s.id), rows = [];
    function row(dt, dd, a) { rows.push(el('div', null, el('dt', null, dt), el('dd', null, dd), a || el('span', { 'aria-hidden': 'true' }))); }
    var sched = schedule(s.BillingPolicy);
    if (sched) row('Ships', sched, m.can.frequency ? link('Change', url, 'dt-freq', { 'data-mk-action': 'frequency', 'data-mk-sub': s.id, 'aria-label': 'Change how often it ships' }) : null);
    var place = placeText(s.ShippingAddress);
    if (place) row('To', place, link('Edit', url, 'dt-addr', { 'data-mk-action': 'address', 'data-mk-sub': s.id, 'aria-label': 'Edit shipping address' }));
    var card = cardText(s.PaymentMethod);
    if (card) row('Card', card, link('Update', url, 'dt-card', { 'data-mk-action': 'card', 'data-mk-sub': s.id, 'aria-label': 'Update payment method' }));
    if (m.saved) row('Saved so far', 'About ' + M.money(m.saved, s.currencyCode) + ' by subscribing');
    return el('article', { 'class': 'mkh-card mkh-details', 'aria-labelledby': 'mkh-details-title' },
      el('p', { 'class': 'mkh-eyebrow', id: 'mkh-details-title' }, DECISION_DETAILS_TITLE),
      /* its rows belong to the NEXT ORDER subscription: say so when there are several */
      m.listedCount >= 2 ? el('p', { 'class': 'mkh-details-for' }, 'For your ' + dayText(s.nextBillingDate, m.tz, 'short') + ' order') : null,
      rows.length ? el('dl', { 'class': 'mkh-dl' }, rows) : null,
      action('ghost', 'View order history', base() + '/orders', 'dt-orders', { 'data-mk-nav': 'orders', 'class': 'mkh-btn mkh-btn--ghost mkh-history' }),
      el('p', { 'class': 'mkh-manage' }, link('Manage subscriptions', base() + '/subscriptions?mk_native=1', 'dt-native', { 'data-mk-nav': 'native' })));
  }

  function buildPanel(st, slot) {
    var m = st.model;
    var next = buildNext(m, st), others = buildSubs(m, st), picks = buildPicks(m, st.picks, st.added);
    var rewards = buildRewards(m, st), details = buildDetails(m);
    var section = el('section', { 'class': 'mkh', 'aria-label': 'Your subscription at a glance', 'data-mk-source': m.source },
      buildHeader(m),
      slot,
      el('div', { 'class': 'mkh-grid' },
        /* r8: the moved order is no longer the soonest: the confirmation sits above the card and names what moved */
        el('div', { 'class': 'mkh-main' }, dateNote && dateNote.subId !== m.main.id ? dateNoteFor(m, 'home') : null, next, others, picks),
        el('div', { 'class': 'mkh-side' }, rewards, details)));
    section.addEventListener('click', onPanelClick);
    /* r10: "See all products" focused or hovered = intent: read the catalogue ahead */
    section.addEventListener('focusin', onCatIntent);
    section.addEventListener('mouseover', onCatIntent);
    return section;
  }

  /* ------------------------------------------------------------------ */
  /* Upcoming orders screen: view (round 2 spec BC 5.3, 5.5)               */
  /* ------------------------------------------------------------------ */
  function upShell() {
    return el('section', { 'class': 'mku', 'aria-labelledby': 'mku-title' },
      el('a', { 'class': 'mku-back', href: base() + '/subscriptions', 'data-mk-key': 'up-back', 'data-mk-up': 'close', 'aria-label': 'Back to your subscriptions' },
        icon('back'), 'Subscriptions'),
      el('div', { 'class': 'mku-head' }, el('h1', { 'class': 'mku-title', id: 'mku-title', tabindex: '-1' }, 'Upcoming orders')),
      el('p', { 'class': 'mku-intro' }, 'Your scheduled orders, soonest first.'),
      el('div', { 'class': 'mku-body' }));
  }
  function upClose(label, key, kind) {
    return el('a', { 'class': 'mkh-btn mkh-btn--' + (kind || 'ghost'), href: base() + '/subscriptions', 'data-mk-up': 'close', 'data-mk-key': key }, label);
  }
  function upNotListed(list) {
    if (!list.length) return null;
    return el('div', { 'class': 'mku-off' },
      el('h2', { 'class': 'mku-sub-title' }, 'Not on this list'),
      el('ul', { 'class': 'mku-off-list' }, list.map(function (r, i) {
        return el('li', { 'class': 'mku-off-row' },
          el('span', { 'class': 'mku-off-main' }, el('b', null, r.names), el('span', null, [r.schedule, r.text].filter(Boolean).join(DOT))),
          el('a', { 'class': 'mkh-link mku-manage', href: r.url, 'data-mk-key': 'up-off-' + i, 'aria-label': 'Manage subscription: ' + r.names }, 'Manage', icon('chevron')));
      })));
  }
  function upRow(r, i) {
    var acts = [];
    var what = r.names ? ' (' + r.names + ')' : '';
    if (r.skip) acts.push(action('brown', 'Skip', r.url, 'up-skip-' + i, { 'data-mk-action': 'skip', 'data-mk-sub': r.id, 'aria-label': 'Skip the ' + r.date + ' order' + what }));
    if (r.changeDate) {
      var dx = { 'data-mk-action': 'change-date', 'data-mk-sub': r.id, 'aria-label': 'Change the date of the ' + r.date + ' order' + what };
      if (up.raw && up.raw.source === 'mkHome' && dateOffered(subById(up.raw, r.id), up.raw.site)) dx['aria-haspopup'] = 'dialog';   /* r8 */
      acts.push(action('ghost', 'Change date', r.url, 'up-date-' + i, dx));
    }
    /* r8: this page view moved this order: "Moved from <day>" beside r6's "Next order" tag (gone after a reload) */
    var mv = r.next && dateMoved[r.id] && dateMoved[r.id].to === r.ymd ? dateMoved[r.id] : null;
    var tag = r.tag ? el('span', { 'class': 'mku-tag' }, r.tag) : null;
    if (mv) tag = el('span', { 'class': 'mkc-tags' }, tag, el('span', { 'class': 'mku-tag mkc-tag-moved' }, 'Moved from ' + nbsp(fmtDay(mv.from, 'short'))));
    if (!acts.length) acts.push(el('a', { 'class': 'mkh-link mku-manage', href: r.url, 'data-mk-key': 'up-man-' + i, 'aria-label': 'Manage subscription' + what }, 'Manage', icon('chevron')));
    return el('li', { 'class': 'mku-row' + (r.next ? ' mku-row--next' : '') },
      el('div', { 'class': 'mku-date', 'aria-hidden': 'true' }, el('span', { 'class': 'mku-dow' }, r.dow), el('span', { 'class': 'mku-day' }, r.day)),
      el('span', { 'class': 'mkh-sr' }, (r.dow === 'Today' || r.dow === 'Tomorrow' ? r.dow + ', ' : '') + r.date + '. '),
      thumbs(r.thumbs, 'mku-thumbs'),
      el('div', { 'class': 'mku-main' },
        r.names ? el('b', { 'class': 'mku-names' }, r.names) : el('span', { 'class': 'mku-names mku-names--none' }, 'No products scheduled'),
        el('span', { 'class': 'mku-meta' }, r.schedule || 'Subscription'),
        tag),
      r.price ? el('div', { 'class': 'mku-price' }, el('b', null, M.money(r.price.total, r.price.currency)),
        r.later ? el('span', { 'class': 'mku-mark', 'aria-hidden': 'true' }, '*') : null,
        r.later ? el('span', { 'class': 'mkh-sr' }, ' (today\'s prices, see the note below)') : null) : null,
      el('div', { 'class': 'mku-acts' }, acts));
  }
  function upFoot(foot) {
    if (!foot.length) return null;
    return el('ul', { 'class': 'mku-foot' }, foot.map(function (f, i) {
      return el('li', null, f.mark ? el('span', { 'aria-hidden': 'true' }, '* ') : null, f.text,
        f.link ? el('a', { 'class': 'mkh-link', href: f.url, 'data-mk-key': 'up-foot-' + i }, f.link) : null, f.after || null);
    }));
  }
  function upBody() {
    var m = up.model;
    if (up.state === 'loading') {
      return el('div', { 'class': 'mkh-card mku-card mku-skel', 'aria-busy': 'true' },
        el('p', { 'class': 'mkh-sr', role: 'status' }, 'Loading your upcoming orders'),
        [0, 1, 2].map(function () { return el('div', { 'class': 'mku-skel-row', 'aria-hidden': 'true' }, el('span'), el('span'), el('span')); }));
    }
    if (up.state === 'error') {
      return el('div', { 'class': 'mkh-card mku-card mku-state', role: 'alert' },
        el('span', { 'class': 'mku-state-ico' }, icon('alert')),
        el('h2', { 'class': 'mku-state-title' }, 'We couldn\'t load your upcoming orders.'),
        el('div', { 'class': 'mkh-actions mku-state-acts' },
          el('button', { 'class': 'mkh-btn mkh-btn--brown', type: 'button', 'data-mk-up': 'retry', 'data-mk-key': 'up-retry' }, 'Try again'),
          upClose('See your subscriptions', 'up-see')));
    }
    var attention = m.attention ? el('div', { 'class': 'mku-alert', role: 'alert' },
      icon('alert'), el('p', null, el('b', null, 'A subscription needs your attention.')),
      upClose('Go to your subscriptions', 'up-attn', 'brown')) : null;
    if (up.state === 'empty') {
      return el('div', { 'class': 'mku-stack' }, attention,
        el('div', { 'class': 'mkh-card mku-card mku-state' },
          el('span', { 'class': 'mku-state-ico' }, icon('calendar')),
          el('h2', { 'class': 'mku-state-title' }, 'No upcoming orders'),
          el('p', { 'class': 'mku-state-text' }, 'You have no active subscription with an order scheduled.'),
          upNotListed(m.notListed),
          el('div', { 'class': 'mkh-actions mku-state-acts' }, upClose('See your subscriptions', 'up-see'))));
    }
    var n = 0;
    return el('div', { 'class': 'mku-stack' }, attention,
      dateNote && dateNote.kind !== 'pending' && up.raw ? dateNoteFor(up.raw, 'upcoming') : null,
      m.months.map(function (mo, j) {
        return el('section', { 'class': 'mkh-card mku-card mku-month', 'aria-labelledby': 'mku-m-' + j },
          el('h2', { 'class': 'mku-month-title', id: 'mku-m-' + j }, mo.title),
          el('ol', { 'class': 'mku-list' }, mo.rows.map(function (r) { return upRow(r, n++); })));
      }),
      (m.notListed.length || m.foot.length) ? el('div', { 'class': 'mkh-card mku-card mku-notes' }, upNotListed(m.notListed), upFoot(m.foot)) : null);
  }
  function upFill(node) {
    var body = node.querySelector('.mku-body');
    if (!body) throw new Error('no body');
    body.setAttribute('data-state', up.state);
    var intro = node.querySelector('.mku-intro');
    if (intro && up.model && up.model.intro) M.text(intro, up.model.intro);
    body.textContent = '';
    body.appendChild(upBody());
  }

  /* ------------------------------------------------------------------ */
  /* lifecycle                                                             */
  /* ------------------------------------------------------------------ */
  var st = null;          /* {model, balance, picks, arrives, combine, v} */
  var runId = 0;
  var status = 'idle';    /* idle | loading | ready | native | failed */
  var observer = null, checkTimer = null, balanceTimer = null, announced = false, nativeMode = false;
  var swap = null;        /* late-takeover guard for the current run: {loadedAt, tokenAt, used} */
  var lastInputAt = 0;

  function setReady(on) { try { document.documentElement.classList.toggle('mk-home-ready', !!on); } catch (e) { /* ignore */ } }
  function stopHome(newStatus) {
    runId++;
    if (graceTimer) { clearTimeout(graceTimer); graceTimer = null; }
    if (observer) { try { observer.disconnect(); } catch (e) { /* ignore */ } observer = null; }
    if (balanceTimer) { clearInterval(balanceTimer); balanceTimer = null; }
    setReady(false);
    M.unmount('mk-home');
    M.unmount('mk-home-native');
    st = null;
    status = newStatus || 'idle';
    if (announced) { announced = false; dispatch('gone'); }
  }
  function fail(why) {
    M.log('home: showing Skio\'s own page (' + why + ')');
    stopHome('failed');
  }

  /* soft: the first paint of a run reports why it could not paint (the caller may retry once) instead of
     failing at once. A later redraw (new points, suggestions, delivery history, the Combine prompt, or
     React re-rendering the page) that finds Skio's page wrapper missing waits for it (F-5, batch 2):
     Skio re-renders its list page while it refetches after a client-side return, and the wrapper is gone
     for a moment. The panel goes back as soon as the wrapper is there again (the observer below, or the
     check after REDRAW_GRACE_MS); still missing then: fail closed as before. */
  var REDRAW_GRACE_MS = 1500;
  var graceTimer = null;
  function render(soft) {
    var stop = soft ? function (why) { return why; } : fail;
    try {
      if (!st || !M.on()) return stop('gate or state');
      var wrap = M.q(WRAP_SEL);
      if (!wrap && !soft && status === 'ready') {
        if (!graceTimer) {
          M.log('home: Skio\'s page is re-rendering; the panel goes back when it is there again');
          var mineSt = st;
          graceTimer = setTimeout(function () {
            graceTimer = null;
            if (st !== mineSt || status !== 'ready') return;
            if (!M.q(WRAP_SEL)) return fail('no page wrapper');
            var cur = document.getElementById('mk-home'), w = M.q(WRAP_SEL);
            if (!cur || cur.parentNode !== w || w.firstElementChild !== cur) render();
          }, REDRAW_GRACE_MS);
        }
        return null;
      }
      if (!wrap) return stop('no page wrapper');
      var active = document.activeElement, key = null;
      var current = document.getElementById('mk-home');
      if (current && active && current.contains(active)) key = active.getAttribute('data-mk-key');
      var slot = current && current.querySelector('#mk-delivery-banner-slot');
      var freshSlot = !slot;
      if (!slot) slot = el('div', { id: 'mk-delivery-banner-slot', 'class': 'mkh-slot' });
      var node = M.mount({
        id: 'mk-home', anchor: wrap, where: 'prepend', module: 'home', sig: st.model.main.id + ':' + st.v,
        build: function () { return buildPanel(st, slot); }
      });
      if (!node) return stop('render');
      setReady(true);
      status = 'ready';
      if (key && node !== current) { var f = node.querySelector('[data-mk-key="' + key + '"]'); if (f) f.focus(); }
      /* tell the delivery module whenever a new (empty) banner slot exists */
      if (!announced || (freshSlot && node !== current)) { announced = true; dispatch('ready'); }
      watch(wrap);
      return null;
    } catch (e) {
      return stop('render error: ' + (e && e.message));
    }
  }
  function bump() { if (st) { st.v++; render(); } }

  /* React may re-render the page: put the panel back where it belongs */
  function watch() {
    if (observer) return;
    var root = document.getElementById('skio-root');
    if (!root || typeof MutationObserver !== 'function') return;
    observer = new MutationObserver(function () {
      if (checkTimer) return;
      checkTimer = setTimeout(function () {
        checkTimer = null;
        if (status !== 'ready' || !st) return;
        var wrap = M.q(WRAP_SEL), node = document.getElementById('mk-home');
        if (!wrap) return;     /* page is changing; the route watcher decides */
        if (!node || node.parentNode !== wrap || wrap.firstElementChild !== node) render();
      }, 60);
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function watchBalance(id) {
    var started = Date.now();
    if (balanceTimer) clearInterval(balanceTimer);
    balanceTimer = setInterval(function () {
      if (id !== runId || !st) { clearInterval(balanceTimer); balanceTimer = null; return; }
      var b = readBalance();
      if (b !== null && b !== st.balance) { st.balance = b; bump(); }
      if (Date.now() - started > BALANCE_WAIT_MS) { clearInterval(balanceTimer); balanceTimer = null; }
    }, 400);
  }
  function waitBalance(ms) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function poll() {
        var b = readBalance();
        if (b !== null || Date.now() - t0 >= ms) return resolve(b);
        setTimeout(poll, 150);
      })();
    });
  }

  function waitForPage(id) {
    return M.waitFor(WRAP_SEL, { timeout: PAGE_WAIT_MS }).then(function (wrap) {
      if (!wrap || id !== runId) return null;
      return M.waitFor(LOADED_SEL, { timeout: PAGE_WAIT_MS }).then(function (x) {
        if (x && id === runId && swap && !swap.loadedAt) swap.loadedAt = Date.now();
        return x && id === runId ? M.q(WRAP_SEL) : null;
      });
    });
  }

  /* ---- late-takeover guard (see SWAP_DEADLINE_MS) ---- */
  function inSkioList(t) {
    if (!t || !t.closest) return false;
    if (t.closest('#mk-home, #mk-home-native, #mk-upcoming, #mk-nav, [data-skio-name^="navbar"]')) return false;
    return !!t.closest('[data-skio-name="subscriptions-page"], [data-skio-name="skio-modal-dialog"]');
  }
  function onInput(ev) {
    try {
      if (ev.type !== 'focusin') lastInputAt = Date.now();
      if (status !== 'loading' || !swap) return;
      /* focus moved by a script (no click or key just before it) is not the customer */
      if (ev.type === 'focusin' && Date.now() - lastInputAt > 1000) return;
      if (inSkioList(ev.target)) swap.used = true;
    } catch (e) { /* ignore */ }
  }
  ['pointerdown', 'keydown', 'focusin'].forEach(function (t) { document.addEventListener(t, onInput, true); });
  /* why the panel must not replace Skio's list now (null = it may) */
  function lateWhy() {
    if (!swap) return null;
    if (swap.used) return 'the customer is using Skio\'s list';
    if (modalOpen()) return 'a Skio dialog is open';
    /* the clock starts when Skio's list is on screen AND our login token is valid: Skio's own
       list needs the same token, so a slow token refresh delays both */
    var since = Math.max(swap.loadedAt || 0, swap.tokenAt || 0);
    if (swap.loadedAt && Date.now() - since > SWAP_DEADLINE_MS) return 'data arrived too late';
    return null;
  }

  function wantsNative() {
    try { return new URLSearchParams(location.search).get('mk_native') === '1'; } catch (e) { return false; }
  }
  function showNativeNote(id, late) {
    status = 'native';
    M.waitFor(WRAP_SEL, { timeout: PAGE_WAIT_MS }).then(function (wrap) {
      if (!wrap || id !== runId) return;
      M.mount({
        id: 'mk-home-native', anchor: wrap, where: 'prepend', module: 'home', sig: late ? 'late' : 'native',
        build: function () {
          var a = el('a', { 'class': 'mkh-link', href: base() + '/subscriptions', 'data-mk-nav': 'overview' }, late ? 'See your overview' : 'Back to your overview');
          var n2 = el('p', { 'class': 'mkh-native-note' + (late ? ' mkh-native-note--late' : '') }, late ? null : 'You are viewing the full list of your subscriptions. ', a);
          n2.addEventListener('click', onPanelClick);
          return n2;
        }
      });
    });
  }

  /* F-5 (batch 2): the rare fall-back to Skio's list after a hand-off and a menu return. Coming back
     through the menu is a client-side route change: Skio re-renders its list page while it refetches
     (skeleton, then list, sometimes twice), so the page wrapper this run waited for can be replaced, or
     be missing for a moment, exactly when the first paint happens ("no page wrapper" / "page not ready"),
     and a single refused or timed-out Skio request gave "no data". Each of these ended the panel for the
     page view. Now the first paint of a run gets ONE retry: wait for Skio's page to be there again (or
     load the data once more), then paint. The late-takeover guard carries over (the customer using Skio's
     list, an open dialog, or Skio's list shown too long still keep the panel out), and a second failure
     fails closed exactly as before. */
  var RETRY_DELAY_MS = 350;
  function startHome(retry) {
    var prev = retry ? swap : null;
    stopHome('loading');
    var id = runId;
    swap = null;
    if (nativeMode || wantsNative()) { showNativeNote(id); return; }
    var mine = swap = { loadedAt: prev ? prev.loadedAt : 0, tokenAt: prev ? prev.tokenAt : 0, used: !!(prev && prev.used), retried: !!retry };
    function again(why) {
      if (id !== runId) return;
      if (retry) return fail(why);
      M.log('home: first paint did not happen (' + why + '), one more try');
      setTimeout(function () { if (id === runId) startHome(true); }, RETRY_DELAY_MS);
    }
    Promise.all([loadModel(function () { if (mine === swap && !mine.tokenAt) mine.tokenAt = Date.now(); }), waitForPage(id)]).then(function (res) {
      if (id !== runId) return null;
      var model = res[0], wrap = res[1];
      if (!model) return again('no data');
      if (!wrap) return again('page not ready');
      var b = readBalance();
      return (b !== null ? Promise.resolve(b) : waitBalance(BALANCE_FIRST_WAIT_MS)).then(function (bal) {
        if (id !== runId) return;
        var late = lateWhy();
        swap = null;
        if (late) { M.log('home: staying on Skio\'s list (' + late + ')'); showNativeNote(id, true); return; }
        st = { model: model, balance: bal, picks: null, arrives: null, v: 1,
          combine: model.combineDone ? safePrompt(model.combineRes, model) : null };
        var why = render(true);
        if (why) {
          /* nothing of ours is on the page yet: put the state back for the retry's guard */
          st = null;
          swap = mine;
          return again(why);
        }
        if (status !== 'ready') return;
        watchBalance(id);
        if (model.combineReq && !model.combineDone) {
          model.combineReq.then(function (r) {
            if (id !== runId || !st) return;
            var cx = safePrompt(r, model);
            if (cx) { st.combine = cx; bump(); }
          }, function () { /* no prompt */ });
        }
        loadPicks(model).then(function (picks) {
          if (id !== runId || !st || !picks || !picks.length) return;
          st.picks = picks; bump();
        }, function () { /* no card */ });
        catIdle(id);         /* r10: read the catalogue ahead a few seconds after the start page is ready */
        if (SHOW_ARRIVES_ABOUT && !(CFG.modules && CFG.modules.delivery === false)) {
          M.delivery(DELIVERY_LIMIT).then(function (body) {
            if (id !== runId || !st) return;
            var a = body ? arrivesAbout(body, st.model) : null;
            if (a) { st.arrives = a; bump(); dateArrives(); }
          });
        }
      });
    }).then(null, function (e) { if (id === runId) again('error: ' + (e && e.message)); });
  }

  /* ------------------------------------------------------------------ */
  /* "Add" pop-up (batch 3, decision 1; approved design batch3-design      */
  /* add-popup-*): "Add" in "Add to your <date> order" opens the shared    */
  /* dialog of the core (MKPortal.dialog) and adds the product in place    */
  /* with the core's one guarded write (MKPortal.addSubscriptionLine:      */
  /* Skio's own add-line call, quantity 1, no price, a fresh single-use    */
  /* token from the customer's own click in the dialog). How often: "Just  */
  /* this order" / "With every order", each only when Skio itself offers  */
  /* it for the chosen variant (Skio 8461 72586.N), with Skio's own prices */
  /* (40740.$X: one-time = regular x (1 - oneTimeUpsellPercentageOff);     */
  /* every order = the closest "Subscription" selling plan's price,        */
  /* 52970.b8 + LG + 67210.y8). Success is shown only when the core saw    */
  /* the new line in Skio's data; the NEXT ORDER card is then redrawn from */
  /* a fresh read (never from our estimate). Fail closed: anything this    */
  /* file cannot price or check means the old hand-off to Skio's carousel. */
  /* ------------------------------------------------------------------ */
  var UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  var PLAN_DAYS = { YEAR: 365, MONTH: 30.5, WEEK: 7, DAY: 1 };      /* Skio 47064.H */
  var SUBSCRIBE_GROUP = 'Subscription';                               /* Skio 51029.my.SubscribeAndSave */
  var ADD_REFRESH_TRIES = 3;          /* fresh reads after a success until our data has the new line */
  var ADD_REFRESH_GAP_MS = 1500;
  var ADD_LATE_CHECKS_MS = [4000, 12000];   /* after an unknown outcome: look again for the line (no new send) */
  var ADD_WAIT_MS = 8000;             /* the success view waits this long at most for the fresh read */

  function planDays(policy) {
    var p = obj(policy), c = p ? n(p.intervalCount) : null;
    if (!p || !p.interval || c === null || !(c > 0)) return null;
    return (PLAN_DAYS[p.interval] || 1) * c;
  }
  /* Skio 52970.b8 for a non-prepaid, non-box subscription: in the "Subscription" group, the plan whose
     billing interval is closest to the subscription's (a tie goes to the longer plan); plans that are not
     offered in the customer portal or are prepaid are skipped */
  function closestPlan(v, sub) {
    var want = planDays(sub.BillingPolicy);
    if (want === null) return null;
    var best = null, bestDays = Infinity;
    arr(v.SellingPlanGroupResources).forEach(function (r) {
      var g = obj(r) && obj(r.SellingPlanGroup);
      if (!g || g.name !== SUBSCRIBE_GROUP) return;
      arr(g.SellingPlans).forEach(function (p) {
        if (!obj(p) || p.availableInCustomerPortal === false || p.PrepaidDeliveryPolicy) return;
        var d = planDays(p.BillingPolicy);
        if (d === null) return;
        var a = Math.abs(d - want), b = Math.abs(bestDays - want);
        if (a < b || (a === b && d > want)) { best = p; bestDays = d; }
      });
    });
    return best;
  }
  /* the "With every order" price (Skio 40740.$X recurringPrice); null = not known here (not offered) */
  function recurringPrice(v, sub, siteCurrency) {
    var plan = closestPlan(v, sub);
    if (!plan || !siteCurrency || sub.currencyCode !== siteCurrency) return null;
    var pols = arr(plan.PricingPolicies).filter(obj);
    /* a later-cycle price: which one Skio applies depends on settings this file cannot see */
    if (pols.some(function (p) { var a = n(p.afterCycle); return a !== null && a > 0; })) return null;
    var pol = pols[0] || null;
    var base = basePrice(v, sub, siteCurrency), plain = n(v.price);
    if (base === null || plain === null) return null;
    if (!pol) return round2(base);
    var t = pol.sellingPlanPricingPolicyAdjustmentType;
    if (t === 'PERCENTAGE') {
      var pct = pol.percentageOff == null ? 0 : n(pol.percentageOff);
      if (pct === null || pct < 0 || pct > 100) return null;
      return round2(base * (100 - pct) / 100);
    }
    /* Skio prices these two from the variant's own price, not the market price: only when they agree */
    if (Math.abs(base - plain) > 0.004) return null;
    var f = n(pol.fixedPrice);
    if (f === null || f < 0) return null;
    if (t === 'FIXED_AMOUNT') return round2(Math.max(plain - f, 0));
    if (t === 'PRICE') return round2(f);
    return null;
  }
  function sameId(a, b) { return str(a).toLowerCase() === str(b).toLowerCase(); }
  /* everything the pop-up shows, from Skio's own records only: {when, freq, variants:[{id, title, image,
     regular, once, every}], first} or {why} (then the hand-off) */
  function addOffer(pick, m) {
    if (!DECISION_ADD_POPUP.enabled) return { why: 'switched off (DECISION_ADD_POPUP)' };
    if (!M.dialog || typeof M.dialog.open !== 'function' || typeof M.addSubscriptionLine !== 'function') return { why: 'core without the pop-up' };
    var p = pick && obj(pick.product), sub = m && m.main;
    if (!p || !sub) return { why: 'no product record' };
    if (!UUID_RE.test(str(sub.id))) return { why: 'not a Skio subscription id' };
    if (sub.status !== 'ACTIVE' || needsAttention(sub)) return { why: 'subscription not active' };
    /* r10 (Jim's decision 6): prepaid hands off to its own page, as this file's header says, so the start page and the
       catalogue agree (prepaid is left out of the catalogue until tested) */
    if (isPrepaidSub(sub) || sub.PrepaidDeliveryPolicy) return { why: 'prepaid' };
    if (m.tierDiscount) return { why: 'tier discount' };
    if (!m.siteCurrency || sub.currencyCode !== m.siteCurrency) return { why: 'currency' };
    if (p.DynamicBox || arr(p.showProductForCustomerTags).length) return { why: 'box or tagged product' };
    var when = dayText(sub.nextBillingDate, m.tz, 'short');
    if (!when) return { why: 'no next order date' };
    var freq = schedule(sub.BillingPolicy);
    var lines = arr(sub.SubscriptionLines).filter(obj);
    var lineOf = function (vid, oneTime) {
      return lines.some(function (l) { return sameId(l.productVariantId || (l.ProductVariant && l.ProductVariant.id), vid) && (oneTime === undefined || isOneTime(l) === oneTime); });
    };
    var variants = arr(p.ProductVariants).filter(function (x) {
      return obj(x) && x.enableOneTimeUpsell && !x.outOfStockAt && !x.deletedAt && !(x.ClassicBoxV2 && x.ClassicBoxV2.id);
    });
    /* Skio 72586.N */
    var onceOff = p.canUpsell === false || !!p.hideOn1TimeUpsells ||
      (!!p.limitOneTimeUpsellQuantity && arr(p.ProductVariants).some(function (x) { return obj(x) && lineOf(x.id, true); }));
    var settings = obj(m.raw && m.raw.site && m.raw.site.settings);
    var byInterval = !!(settings && settings.restrictProductsByInterval === true && !settings.autoSplitOnIntervalMismatch);
    var everyOff = isPrepaidSub(sub) || !!sub.PrepaidDeliveryPolicy || !freq || byInterval;
    var off = n(p.oneTimeUpsellPercentageOff), pct = off !== null && off > 0 && off < 1 ? off : 0;
    var out = [];
    variants.forEach(function (v) {
      if (!UUID_RE.test(str(v.id))) return;
      var reg = regularPrice(v, sub, m.siteCurrency), bp = basePrice(v, sub, m.siteCurrency);
      if (reg === null || bp === null) return;
      var once = onceOff || lineOf(v.id, true) ? null : round2(bp * (100 - pct * 100) / 100);
      var every = everyOff || lineOf(v.id) ? null : recurringPrice(v, sub, m.siteCurrency);
      if (once === null && every === null) return;
      out.push({ id: str(v.id), title: v.title && v.title !== 'Default Title' ? str(v.title).trim().slice(0, 80) : '',
        image: v.image || p.imageSrc, regular: reg, once: once, every: every });
    });
    if (!out.length) return { why: 'no option Skio offers for this product' };
    if (out.length > 1 && out.some(function (v) { return !v.title; })) return { why: 'variants without a name' };
    var first = 0;
    out.forEach(function (v, i) { if (sameId(v.id, pick.vid)) first = i; });
    return { when: when, freq: freq.toLowerCase(), variants: out, first: first, title: str(p.title).trim().slice(0, 200) || pick.title,
      currency: m.money ? m.money.currency : sub.currencyCode, ppd: m.tier && m.tier.ppd ? m.tier.ppd : null, subId: str(sub.id) };
  }
  function addOffered(pick, m) { try { var o = addOffer(pick, m); return !!(o && !o.why); } catch (e) { return false; } }

  var add = null;   /* the open pop-up: {h, offer, pick, vi, once, phase, baseline, ...} */

  function addIcon(name) {
    var P = { alert: ['M12 2a10 10 0 1 0 0 20a10 10 0 1 0 0-20z', 'M12 7v6', 'M12 16.5v.5'], check: ['M20 6 9 17l-5-5'],
      star: ['M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3 6.4 20.2l1.1-6.2L3 9.6l6.2-.9z'] };
    return M.svg('0 0 24 24', P[name] || [], { 'class': 'mka-ico mka-ico--' + name });
  }
  function addMoney(x, A) { return M.money(x, A.offer.currency); }
  function addPts(x) { return M.pointsText(x); }
  function radio(name, value, checked) {
    var i = el('input', { type: 'radio', name: name, value: value });
    i.checked = !!checked;
    return i;
  }
  function addVariant(A) { return A.offer.variants[A.vi]; }
  function addUnit(A) { var v = addVariant(A); return A.once ? v.once : v.every; }

  function addProdRow(A, meta, price) {
    var v = addVariant(A), src = img(v.image, 160);
    var row = el('div', { 'class': 'mka-prod' },
      src ? el('img', { src: src, alt: '', width: '64', height: '64', decoding: 'async' }) : el('span', { 'class': 'mka-img-ph', 'aria-hidden': 'true' }),
      el('div', { 'class': 'mka-prod-main' }, el('b', null, A.offer.title), el('span', null, meta)),
      price ? el('span', { 'class': 'mka-prod-price' }, price) : null);
    return row;
  }
  /* How often: both choices as radios, or one plain line when Skio offers only one for this variant */
  function addOften(A) {
    var v = addVariant(A), o = A.offer;
    var onceSub = 'One time, in your ' + o.when + ' order', everySub = 'Every order (' + o.freq + '), starting ' + o.when;
    var box = A.els.often;
    while (box.firstChild) box.removeChild(box.firstChild);
    if (v.once !== null && v.every !== null) {
      var differ = Math.abs(v.once - v.every) > 0.004;
      var opt = function (val, title, sub, price) {
        return el('label', { 'class': 'mka-opt mk-dlg-choice' }, radio('mk-add-often', val, (val === 'once') === A.once),
          el('span', { 'class': 'mka-radio', 'aria-hidden': 'true' }),
          el('span', { 'class': 'mka-opt-main' }, el('b', null, title), el('small', null, sub)),
          differ ? el('span', { 'class': 'mka-opt-price' }, addMoney(price, A)) : null);
      };
      box.appendChild(el('fieldset', null, el('legend', null, 'How often'),
        el('div', { 'class': 'mka-opts' }, opt('once', 'Just this order', onceSub, v.once), opt('every', 'With every order', everySub, v.every))));
    } else {
      box.appendChild(el('div', { 'class': 'mka-often-one' }, el('p', { 'class': 'mk-dlg-label' }, 'How often'),
        el('p', { 'class': 'mka-often-line' }, A.once ? onceSub : everySub)));
    }
  }
  /* price, points, the charge line and the button follow the choices */
  function addSummary(A) {
    var v = addVariant(A), o = A.offer, unit = addUnit(A);
    var lower = unit < v.regular - 0.004;
    var sum = A.els.sum;
    while (sum.firstChild) sum.removeChild(sum.firstChild);
    sum.appendChild(el('div', { 'class': 'mka-sum-row' }, el('span', { 'class': 'mka-k' }, lower ? 'Subscriber price' : 'Price'),
      el('span', { 'class': 'mka-v' },
        lower ? el('s', null, el('span', { 'class': 'mk-dlg-sr' }, 'Regular price '), addMoney(v.regular, A)) : null,
        el('b', { 'class': 'mka-big' }, addMoney(unit, A)))));
    var pts = o.ppd ? M.earnPoints(unit, o.ppd) : null;
    if (pts > 0) {
      sum.appendChild(el('div', { 'class': 'mka-pts' }, addIcon('star'),
        el('span', null, 'Earns ', el('b', null, addPts(pts)), A.once ? ' when it\'s charged' : ' each time it\'s charged')));
    }
    var fine = A.els.fine;
    while (fine.firstChild) fine.removeChild(fine.firstChild);
    if (A.once) fine.appendChild(document.createTextNode('Charged once, on ' + o.when + ', with the rest of your order.'));
    else {
      fine.appendChild(el('b', null, addMoney(unit, A) + ' will be charged with every order (' + o.freq + '), starting ' + o.when + ', until you remove it.'));
      fine.appendChild(document.createTextNode(' You can remove it any time in Subscriptions.'));
    }
    if (A.phase !== 'busy') M.text(A.els.go, A.phase === 'error' ? 'Try again' : (A.once ? 'Add to my ' + o.when + ' order' : 'Add to every order'));
    var src = img(v.image, 160), im = A.els.prod && A.els.prod.querySelector('img');
    if (im && src && im.getAttribute('src') !== src) im.setAttribute('src', src);
  }
  /* the sizes the Size group shows, in Skio's order: {title, k} (k = index in offer.variants, -1 = already in that order).
     r9.1's offer (the start page) has no order list: its offered sizes only. */
  function addSizes(o) {
    return o.order || o.variants.map(function (x, i) { return { title: x.title, k: i }; });
  }
  /* r10 (catalogue part 2): a size already in the chosen order is shown, disabled, "In this order", with the note under
     the chips (DESIGN-NOTES 7, h-already); one size in all: no Size group (r9.1) */
  function addSizeBox(A) {
    var list = addSizes(A.offer);
    if (list.length < 2) return null;
    var off = list.filter(function (x) { return x.k < 0; });
    /* r10 review: a size on the subscription but not in its next order (skipped, no orders left) says so */
    var said = function (xs, where) { return xs.length ? xs.map(function (x) { return x.title; }).join(' and ') + (xs.length > 1 ? ' are' : ' is') + ' already ' + where + '. ' : ''; };
    var inNext = off.filter(function (x) { return !x.later; }), onSub = off.filter(function (x) { return x.later; });
    return el('fieldset', null, el('legend', null, 'Size'), el('div', { 'class': 'mka-chips' }, list.map(function (x) {
      if (x.k >= 0) return el('label', { 'class': 'mka-chip mk-dlg-choice' }, radio('mk-add-size', String(x.k), x.k === A.vi), el('span', null, x.title));
      var r = radio('mk-add-size', 'in-order', false);
      r.disabled = true;
      r.setAttribute('data-mk-off', '1');
      r.setAttribute('aria-describedby', 'mkq-size-note');
      return el('label', { 'class': 'mka-chip mk-dlg-choice mkq-chip-off' }, r, el('span', null, x.title, el('small', null, x.later ? 'On this subscription' : 'In this order')));
    })), off.length ? el('p', { 'class': 'mkq-note mkq-size-note', id: 'mkq-size-note' },
      said(inNext, 'in this order') + said(onSub, 'on this subscription') + 'To get more, change the quantity on your subscription\'s page.') : null);
  }
  /* r10: "Which order", first, when two or more orders can take the product (soonest chosen); each option: the date,
     "Next order" on the soonest order the customer has, its products, its schedule, up to 3 pictures; the left-out note */
  function addWhichBox(A) {
    if (A.pops.length < 2) return null;
    return el('fieldset', { 'class': 'mkq-which' }, el('legend', null, 'Which order'),
      el('div', { 'class': 'mkq-opts' }, A.pops.map(function (p, i) {
        var r = radio('mk-add-sub', String(i), i === A.si);
        return el('label', { 'class': 'mka-opt mkq-opt mk-dlg-choice' }, r,
          el('span', { 'class': 'mka-radio', 'aria-hidden': 'true' }),
          el('span', { 'class': 'mka-opt-main' },
            el('b', null, nbsp(p.date), p.next ? el('span', { 'class': 'mkq-next' }, 'Next order') : null),
            p.names ? el('small', null, p.names) : null,
            p.schedule ? el('small', null, p.schedule) : null),
          p.thumbs && p.thumbs.length ? el('span', { 'class': 'mkq-thumbs', 'aria-hidden': 'true' }, p.thumbs.map(function (u) {
            return el('img', { src: u, alt: '', width: '36', height: '36', decoding: 'async' });
          })) : null);
      })),
      A.hidden ? el('p', { 'class': 'mkq-note' }, A.hidden) : null);
  }
  function addProdMeta(A) {
    var o = A.offer, v = addVariant(A);
    if (A.pops.length > 1) return 'Choose the order it ships with';
    return (addSizes(o).length === 1 && v.title ? v.title + DOT : '') + 'Ships with your ' + o.when + ' order';
  }
  function addChooseBody(A) {
    A.els.prod = addProdRow(A, addProdMeta(A), null);
    A.els.which = addWhichBox(A);
    A.els.size = addSizeBox(A);
    A.els.often = el('div', { 'class': 'mka-often' });
    A.els.sum = el('div', { 'class': 'mka-sum' });
    addOften(A);
    return [A.els.prod, A.els.which, A.els.size, A.els.often, A.els.sum];
  }
  /* another order was chosen: its sizes (the same size stays chosen when that order takes it), How often, prices, points,
     the charge line and the button are worked out again for it (the Which order group itself stays, with its focus) */
  function addSetPop(A, si) {
    var vid = addVariant(A).id;
    A.si = si;
    A.offer = A.pops[si];
    A.vi = 0;
    A.offer.variants.forEach(function (x, i) { if (sameId(x.id, vid)) A.vi = i; });
    var v = addVariant(A);
    if (A.once && v.once === null) A.once = false;
    else if (!A.once && v.every === null) A.once = true;
    A.baseline = addBaseline(A.offer);
    var old = A.els.size, nw = addSizeBox(A);
    if (old && nw) old.parentNode.replaceChild(nw, old);
    else if (old) old.parentNode.removeChild(old);
    else if (nw) A.els.often.parentNode.insertBefore(nw, A.els.often);
    A.els.size = nw;
    var meta = A.els.prod && A.els.prod.querySelector('.mka-prod-main span');
    if (meta) M.text(meta, addProdMeta(A));
    addOften(A);
  }
  /* the chosen order's lines before the write (a late look for the line ignores these) */
  function addBaseline(o) {
    return arr(o && o.sub && o.sub.SubscriptionLines).map(function (l) { return obj(l) ? str(l.id) : ''; }).filter(Boolean);
  }
  function addChooseActions(A) {
    A.els.fine = el('p', { 'class': 'mk-dlg-fine', id: 'mk-add-fine' });
    A.els.go = el('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--primary', id: 'mk-add-go', 'aria-describedby': 'mk-add-fine' });
    A.els.cancel = el('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--ghost' }, 'Cancel');
    A.els.go.addEventListener('click', function (ev) { addGo(A, ev); });
    A.els.cancel.addEventListener('click', function () { if (A.phase !== 'busy') A.h.close('cancel'); });
    return [A.els.fine, A.els.go, A.els.cancel];
  }
  function addOnChange(A, ev) {
    var t = ev.target;
    if (!t || A.phase === 'busy' || A.phase === 'done') return;
    if (t.name === 'mk-add-sub') {
      var si = parseInt(t.value, 10);
      if (A.lockSub || !(si >= 0 && si < A.pops.length) || si === A.si) return;
      addSetPop(A, si);
    } else if (t.name === 'mk-add-size') {
      if (t.disabled || t.hasAttribute('data-mk-off')) return;
      var i = parseInt(t.value, 10);
      if (!(i >= 0 && i < A.offer.variants.length)) return;
      A.vi = i;
      var v = addVariant(A);
      if (A.once && v.once === null) A.once = false;
      else if (!A.once && v.every === null) A.once = true;
      addOften(A);
    } else if (t.name === 'mk-add-often') {
      A.once = t.value === 'once';
    } else return;
    addClearError(A);
    addSummary(A);
  }
  function addClearError(A) {
    if (A.phase !== 'error') return;
    A.phase = 'choose';
    if (A.els.alert) { A.els.alert.remove(); A.els.alert = null; }
    A.els.go.setAttribute('aria-describedby', 'mk-add-fine');
  }
  function addBusy(A, on) {
    A.phase = on ? 'busy' : 'choose';
    if (on) {
      A.els.go.setAttribute('aria-disabled', 'true');
      A.els.cancel.setAttribute('aria-disabled', 'true');
      M.text(A.els.go, 'Adding\u2026');
    } else {
      A.els.go.removeAttribute('aria-disabled');
      A.els.cancel.removeAttribute('aria-disabled');
    }
    /* r10: a size already in the order stays disabled; after an unclear outcome the order can no longer change (no add to
       a second order while the first may still land) */
    M.qa('input', A.h.body).forEach(function (i) {
      i.disabled = !!on || i.hasAttribute('data-mk-off') || (!!A.lockSub && i.name === 'mk-add-sub' && !i.checked);
    });
  }

  /* opens the pop-up for one row of "Add to your <date> order"; false = not offered (the caller hands off) */
  function openAdd(opener) {
    var idx = parseInt(opener.getAttribute('data-mk-pick'), 10);
    var m = st && st.model, pick = st && st.picks ? st.picks[idx] : null;
    if (!m || !pick || opener.getAttribute('data-mk-sub') !== m.main.id) return false;
    var key = 'pk-' + idx, pid = pick.pid;
    return openAddPick(opener, pick, m, {
      /* the row was redrawn (or now says Added): focus goes back to the same row */
      returnFocus: function () {
        var p = document.getElementById('mk-home');
        return p && (p.querySelector('[data-mk-added="' + (window.CSS && CSS.escape ? CSS.escape(pid) : pid) + '"]') || p.querySelector('[data-mk-key="' + key + '"]'));
      }
    });
  }
  /* the start page's pop-up for one product record and the NEXT ORDER subscription (r9.1, unchanged); o = {returnFocus} */
  function openAddPick(opener, pick, m, o) {
    o = o || {};
    var offer = addOffer(pick, m);
    if (!offer || offer.why) { M.log('home: Add pop-up not offered (' + (offer && offer.why) + '); hand-off to Skio\'s carousel'); return false; }
    offer.sub = m.main;
    return openAddDialog(opener, [offer], { pick: pick, si: 0, src: 'home', returnFocus: o.returnFocus, onDone: o.onDone });
  }
  /* r10 (catalogue part 2): the one Add pop-up for one product and one or more orders that can take it. pops = r9.1-shaped
     offers ({when, freq, variants, first, title, currency, ppd, subId, sub}; the catalogue's also order (sizes with the
     ones already in that order), date, next, names, schedule, thumbs); o = {pick: {pid, title}, si (the order chosen
     first), src: 'home' | 'catalog', hidden (left-out note), returnFocus, onDone(A) before the success view's Done closes
     it}. The write is r9.1's, for the CHOSEN order only. -> true when it opened */
  function openAddDialog(opener, pops, o) {
    o = o || {};
    if (!M.dialog || typeof M.dialog.open !== 'function' || typeof M.addSubscriptionLine !== 'function') return false;
    pops = arr(pops).filter(function (p) { return obj(p) && UUID_RE.test(str(p.subId)) && arr(p.variants).length && p.when; });
    if (!pops.length) return false;
    var si = o.si >= 0 && o.si < pops.length ? o.si : 0;
    var offer = pops[si], v0 = offer.variants[offer.first] || offer.variants[0];
    var A = {
      pops: pops, si: si, offer: offer, pick: o.pick || {}, vi: offer.variants.indexOf(v0), phase: 'choose', els: {}, stale: false, closed: false,
      once: DECISION_ADD_POPUP.defaultOnce ? v0.once !== null : v0.every === null,
      baseline: addBaseline(offer), hidden: pops.length > 1 && o.hidden ? str(o.hidden) : '', lockSub: !!o.lockSub, sent: false,
      src: o.src || 'home', onDone: typeof o.onDone === 'function' ? o.onDone : null
    };
    var h = M.dialog.open({
      id: 'mk-add', className: 'mk-add', module: 'home', title: pops.length > 1 ? 'Add to an upcoming order' : 'Add to your ' + offer.when + ' order',
      body: addChooseBody(A), actions: addChooseActions(A), opener: opener,
      returnFocus: o.returnFocus,
      onClose: function (reason) {
        A.closed = true;
        if (add === A) add = null;
        /* r10: closed after a confirmed add (Done, X or Escape on the success view): the catalogue shows it */
        if (A.phase === 'done' && A.onDone) { try { A.onDone(A); } catch (e) { M.log('home: after add', e && e.message); } }
        M.log('home: Add pop-up closed (' + reason + ')');
        /* our data could not be refreshed after a change: start over (fails closed to Skio's list) */
        if (A.stale && st && status === 'ready') { M.invalidate('skio'); startHome(); }
        /* r10: something was sent but no success was shown (already there, unclear, refused): the list reads Skio again */
        if (A.src === 'catalog' && A.phase !== 'done' && (A.sent || A.phase === 'already' || A.phase === 'refused')) catAfterSend();
      }
    });
    if (!h) return false;
    A.h = h;
    add = A;
    addSummary(A);
    h.body.addEventListener('change', function (ev) { addOnChange(A, ev); });
    return true;
  }

  /* r10 review (1.3.1): the radios checked when Add is pressed must be the ones the pop-up's state says (a page script's
     change event cannot move the order, the size or how often without the radio the customer sees) */
  function addChecked(A, name) {
    var all = M.qa('input[name="' + name + '"]', A.h.body);
    return { n: all.length, on: all.filter(function (i) { return i.checked; }) };
  }
  function addChecksMatch(A) {
    var w = addChecked(A, 'mk-add-sub'), z = addChecked(A, 'mk-add-size'), f = addChecked(A, 'mk-add-often');
    if (w.n && (w.on.length !== 1 || w.on[0].disabled || parseInt(w.on[0].value, 10) !== A.si)) return false;
    if (z.n && (z.on.length !== 1 || z.on[0].disabled || z.on[0].hasAttribute('data-mk-off') || parseInt(z.on[0].value, 10) !== A.vi)) return false;
    if (f.n && (f.on.length !== 1 || (f.on[0].value === 'once') !== A.once)) return false;
    return true;
  }
  /* they did not match: nothing is sent; the pop-up follows the radios that are checked (else it puts the radios back to
     what it shows), so the next press adds exactly what the customer sees */
  function addFollowChecked(A) {
    var w = addChecked(A, 'mk-add-sub').on[0], z, f;
    var si = w ? parseInt(w.value, 10) : A.si;
    if (w && !w.disabled && !A.lockSub && si >= 0 && si < A.pops.length && si !== A.si) addSetPop(A, si);
    z = addChecked(A, 'mk-add-size').on[0];
    var vi = z && !z.disabled && !z.hasAttribute('data-mk-off') ? parseInt(z.value, 10) : -1;
    if (vi >= 0 && vi < A.offer.variants.length && vi !== A.vi) {
      A.vi = vi;
      var v = addVariant(A);
      if (A.once && v.once === null) A.once = false;
      else if (!A.once && v.every === null) A.once = true;
      addOften(A);
    }
    f = addChecked(A, 'mk-add-often').on[0];
    if (f) {
      var once = f.value === 'once', v2 = addVariant(A);
      if ((once ? v2.once : v2.every) !== null) A.once = once;
    }
    M.qa('input[name="mk-add-sub"]', A.h.body).forEach(function (i) { i.checked = parseInt(i.value, 10) === A.si; });
    M.qa('input[name="mk-add-size"]', A.h.body).forEach(function (i) { i.checked = !i.hasAttribute('data-mk-off') && parseInt(i.value, 10) === A.vi; });
    M.qa('input[name="mk-add-often"]', A.h.body).forEach(function (i) { i.checked = (i.value === 'once') === A.once; });
    addSummary(A);
    M.log('home: Add pressed while the checked choices differed from the pop-up; nothing sent, the pop-up follows the checked ones');
  }
  /* r10 review (1.3.1): right before the send (after the customer's own press), the chosen order read fresh from Skio:
     - the order can still take adds (catEligible: open, not on hold, not prepaid, gift or digital);
     - no line of that size in it, in any form (Jim's decision 4);
     - Skio's one-add-per-product rule (23403.y: limitOneTimeUpsellQuantity and a just-this-order line of the product);
     - the offer and the price shown still hold: the catalogue's catOffer() for that order, or r9.1's addOffer() for the
       start page's NEXT ORDER subscription; a tier DISCOUNT reward fails closed.
     -> Promise<null (send) | 'already' | 'held' | 'changed' | 'read' (the read failed)>; nothing is sent unless null */
  var ADD_RECHECK_MS = 6000;     /* under the token's 10 s, so the core still accepts the press after the read */
  function addProductOf(A) {
    if (A.src !== 'catalog') return obj(A.pick && A.pick.product) ? A.pick.product : null;
    var pid = str(A.pick && A.pick.pid), it = cat.model ? cat.model.items.filter(function (x) { return x.id === pid; })[0] : null;
    if (it && obj(it.product)) return it.product;
    var list = cat.res ? arr(cat.res.items) : [];
    return list.filter(function (p) { return obj(p) && sameId(p.id, pid); })[0] || null;
  }
  function addRecheck(A, off, v, once) {
    var read = M.storefrontUserId().then(function (uid) { return uid ? rawFor(uid, true) : null; });
    var wait = new Promise(function (r) { setTimeout(function () { r('timeout'); }, ADD_RECHECK_MS); });
    return Promise.race([read, wait]).then(function (raw) {
      if (raw === 'timeout' || !obj(raw) || raw.source !== 'mkHome') return 'read';
      var s = arr(raw.subs).filter(function (x) { return obj(x) && sameId(x.id, off.subId); })[0] || null;
      if (!s || !catEligible(s)) return 'held';
      var lines = arr(s.SubscriptionLines).filter(obj), p = addProductOf(A);
      if (lines.some(function (l) { return sameId(lineVid(l), v.id); })) return 'already';
      if (p && p.limitOneTimeUpsellQuantity && lines.some(function (l) { return isOneTime(l) && sameId(linePid(l), p.id); })) return 'already';
      var x = null, site = obj(raw.site) || {};
      if (A.src === 'catalog') {
        if (!p) return 'changed';
        var cs = cat.res && obj(cat.res.data) && obj(cat.res.data.SiteByPk) ? cat.res.data.SiteByPk : {};
        var cur = /^[A-Z]{3}$/.test(str(site.currencyCode)) ? site.currencyCode : (/^[A-Z]{3}$/.test(str(cs.currencyCode)) ? cs.currencyCode : null);
        var tier = currentTier(parseLadder(site.TierGroups), (obj(raw.user) || {}).StorefrontUserTiers);
        if (catTierDiscount(site.TierGroups, tier)) return 'changed';
        var o = catOffer(p, s, { siteCurrency: cur, byInterval: catByInterval(site) });
        if (!o) return lines.some(function (l) { return sameId(linePid(l), p.id); }) ? 'already' : 'changed';
        if (o.handoff) return 'changed';
        x = arr(o.variants).filter(function (y) { return sameId(y.id, v.id); })[0] || null;
      } else {
        var nm = null;
        try { nm = buildModel(raw, null); } catch (e) { nm = null; }
        if (!nm || !nm.main || !sameId(nm.main.id, off.subId)) return 'changed';
        var o2 = addOffer(A.pick, nm);
        if (!o2 || o2.why) return 'changed';
        x = arr(o2.variants).filter(function (y) { return sameId(y.id, v.id); })[0] || null;
      }
      var shown = once ? v.once : v.every, now = x ? (once ? x.once : x.every) : null;
      if (typeof shown !== 'number' || typeof now !== 'number' || Math.abs(shown - now) > 0.004) return 'changed';
      return null;
    }, function () { return 'read'; });
  }

  /* the customer's own press of the main button: token -> busy -> the fresh check -> the one write -> result */
  function addGo(A, ev) {
    if (A.phase === 'busy' || A.phase === 'done' || A.phase === 'already' || A.phase === 'refused') return;
    /* r10: the chosen order, one of the orders this pop-up offered (never another one) */
    var off = A.offer;
    if (!off || A.pops.indexOf(off) < 0 || !UUID_RE.test(str(off.subId))) return;
    if (!addChecksMatch(A)) { addFollowChecked(A); return; }
    var v = addVariant(A), once = A.once;
    var tok = A.h.confirm(ev, { kind: 'add-line', subscriptionId: off.subId, variantId: v.id, oneTime: once });
    if (!tok) return;     /* a double click, a busy dialog or not the customer's own click: nothing happens */
    A.h.busy(true);
    addBusy(A, true);
    addRecheck(A, off, v, once).then(function (why) {
      if (!why) return M.addSubscriptionLine({ subscriptionId: off.subId, variantId: v.id, oneTime: once, confirm: tok });
      M.log('home: Add not sent (fresh check: ' + why + ')');
      return { ok: false, reason: 'mk-recheck', recheck: why, sent: false, outcome: 'none' };
    }).then(function (r) {
      if (r && (r.sent || r.outcome === 'unknown')) A.sent = true;
      /* r10: Skio may still apply it: the order stays the chosen one (Try again never goes to another order) */
      if (r && !r.ok && (r.outcome === 'unknown' || (r.sent && r.outcome !== 'refused'))) A.lockSub = true;
      /* r10 review: ... and the same product's Add offers only that order while the core's hold lasts */
      if (A.lockSub && A.src === 'catalog' && A.pick.pid) cat.unclear[str(A.pick.pid)] = { subId: str(off.subId), at: Date.now() };
      if (A.h.isOpen()) A.h.busy(false);
      /* review fix: the pop-up went away while the write ran (route change, gate off): our card may be behind Skio's
         data whatever the outcome, so read it again and draw the home from it (fails closed to Skio's list) */
      if (A.closed || !A.h.isOpen()) {
        M.log('home: Add result after the pop-up closed (' + (r && (r.ok ? 'ok' : r.reason)) + '); reading the home again');
        if (r && (r.ok || r.sent || r.outcome === 'unknown')) {
          M.invalidate('skio');
          if (st && status === 'ready' && !(M.dialog && M.dialog.isOpen())) startHome();
          if (A.src === 'catalog') catAfterSend();     /* r10: the list reads Skio again too */
        }
        return;
      }
      /* success: the button keeps "Adding..." until the fresh data is in, then the success view */
      if (r && r.ok) return addSucceeded(A, v, once, r.line);
      addBusy(A, false);
      if (r && (r.reason === 'already_in_order' || r.recheck === 'already')) return addAlready(A);
      if (r && (r.recheck === 'held' || r.recheck === 'changed')) return addChanged(A, r.recheck);
      addFailed(A, v, once, r || {});
    }).then(null, function (e) { M.log('home: Add pop-up error', e && e.message); if (!A.closed) addFailed(A, v, once, {}); });
  }

  /* fresh reads (the core dropped its cache after the write) until our data shows the line in THE CHOSEN order, found by
     its id (r10: any order, not only the NEXT ORDER one); that order's money rows, total and points, and the start page
     (whichever order changed) are then drawn from this read, never from our estimate.
     -> {model (the fresh start-page model, or null), raw, sub, line, row, money, earn} | {..., line: null} | null */
  function addRefresh(A, match, max) {
    var tries = 0, limit = max || ADD_REFRESH_TRIES, subId = A.offer.subId;
    var once = function () {
      return M.storefrontUserId().then(function (uid) { return uid ? rawFor(uid, true) : null; }).then(function (raw) {
        if (!raw) return null;
        var nm = null;
        try { nm = buildModel(raw, null); } catch (e) { nm = null; }
        var s = arr(raw.subs).filter(function (x) { return obj(x) && sameId(x.id, subId); })[0] || null;
        if (!s) return { model: nm, raw: raw, sub: null, line: null };
        var site = obj(raw.site) || {}, user = obj(raw.user) || {};
        var cur = /^[A-Z]{3}$/.test(str(site.currencyCode)) ? site.currencyCode : null;
        var lines = nextLines(s), money = orderMoney(s, lines, cur);
        var tier = currentTier(parseLadder(site.TierGroups), user.StorefrontUserTiers);
        var earn = money && tier && tier.ppd ? M.earnPoints(money.subtotal - money.discount, tier.ppd) : null;
        var i = -1;
        lines.forEach(function (l, k) { if (i < 0 && match(l)) i = k; });
        return { model: nm, raw: raw, sub: s, line: i >= 0 ? lines[i] : null, row: i >= 0 && money ? money.rows[i] : null, money: money, earn: earn };
      }, function () { return null; });
    };
    return (function next() {
      return once().then(function (res) {
        if ((res && res.line) || ++tries >= limit) return res;
        return new Promise(function (r) { setTimeout(r, ADD_REFRESH_GAP_MS); }).then(next);
      });
    })();
  }
  /* put the fresh data on the home screen (same run): r10, for whichever order changed (the NEXT ORDER card, totals and
     points when it is that one; "Your subscriptions" for any); the start page's row says Added for the NEXT ORDER only */
  function addApply(A, res) {
    if (!st || status !== 'ready' || !st.model) return false;
    st.added = st.added || {};
    if (A.pick.pid && sameId(st.model.main.id, A.offer.subId)) st.added[A.pick.pid] = true;
    if (res && res.model && res.line) {
      res.model.since = st.model.since; res.model.sinceZone = st.model.sinceZone;
      st.model = res.model;
    } else {
      A.stale = true;     /* our numbers would be wrong: start over when the pop-up closes */
    }
    bump();
    return true;
  }
  function addSucceeded(A, v, once, line) {
    var lineId = line && line.id;
    var match = function (l) { return sameId(l.id, lineId); };
    var wait = new Promise(function (r) { setTimeout(function () { r(null); }, ADD_WAIT_MS); });
    return Promise.race([addRefresh(A, match), wait]).then(function (res) {
      addApply(A, res);
      addDone(A, v, once, line, res && res.line ? res : null);
    });
  }
  /* "Added to your <date> order": Skio's line as re-read, the new total and points from the fresh data */
  function addDone(A, v, once, line, res) {
    A.phase = 'done';
    if (A.closed || !A.h.isOpen()) return;
    var o = A.offer, q = 1, price = null;
    if (res && res.line) {
      q = parseInt(res.line.quantity, 10) || 1;
      price = res.row ? res.row.total : null;
    } else if (line) {
      q = n(line.quantity) || 1;
      price = n(line.priceWithoutDiscount) !== null ? round2(n(line.priceWithoutDiscount) * q) : null;
    }
    var meta = (v.title ? v.title + DOT : '') + 'Qty ' + q + DOT + (once ? 'Just this order' : 'With every order' + DOT + o.freq);
    var body = [addProdRow(A, meta, price !== null ? addMoney(price, A) : null)];
    /* r10: the chosen order's own total and points, from the re-read that found the line (else left out, never guessed) */
    var mon = res && res.line ? res.money : null;
    /* r10: what the catalogue's strip and card say afterwards (Skio's line as re-read; the fresh data when there is one) */
    A.result = { size: v.title || '', once: once, unit: price !== null ? price : null, raw: res && res.raw ? res.raw : null };
    if (mon) {
      body.push(el('div', { 'class': 'mka-sum' },
        el('div', { 'class': 'mka-sum-row' }, el('span', { 'class': 'mka-k' }, o.when + ' order total'), el('b', { 'class': 'mka-big' }, M.money(mon.total, mon.currency))),
        res.earn > 0 ? el('div', { 'class': 'mka-pts' }, addIcon('star'), el('span', null, 'This order now earns ', el('b', null, addPts(res.earn)))) : null));
    }
    var doneBtn = el('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--primary' }, 'Done');
    doneBtn.addEventListener('click', function () {
      /* r10: the catalogue redraws its card first, so focus can go to the card's "Added" line */
      if (A.onDone) { try { A.onDone(A); } catch (e) { M.log('home: after add', e && e.message); } }
      A.h.close('done');
    });
    var view = el('a', { 'class': 'mk-dlg-btn mk-dlg-btn--ghost', href: subUrl(o.subId) }, 'View order');
    A.els = {};
    A.h.set({ title: 'Added to your ' + o.when + ' order', icon: el('div', { 'class': 'mk-dlg-icon mk-dlg-icon--done' }, addIcon('check')),
      center: true, body: body, actions: [doneBtn, view] });
  }
  function addAlready(A) {
    A.phase = 'already';
    /* our home data was behind Skio's: read it again (no send) */
    addRefresh(A, function () { return false; }, 1).then(function (res) { if (res && res.model && st && status === 'ready' && st.model) { res.model.since = st.model.since; res.model.sinceZone = st.model.sinceZone; st.model = res.model; bump(); } });
    if (A.closed || !A.h.isOpen()) return;
    var close = el('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--ghost' }, 'Close');
    close.addEventListener('click', function () { A.h.close('close'); });
    if (A.els.alert) A.els.alert.remove();
    A.els.alert = el('div', { 'class': 'mk-dlg-alert mka-alert--info', id: 'mk-add-alert', role: 'alert' }, addIcon('alert'),
      el('div', null, el('b', null, 'Already in your order.'), el('span', null, 'Nothing new was added.')));
    A.h.body.appendChild(A.els.alert);
    M.qa('input', A.h.body).forEach(function (i) { i.disabled = true; });
    A.h.set({ actions: [el('a', { 'class': 'mk-dlg-btn mk-dlg-btn--primary', href: subUrl(A.offer.subId) }, 'View order'), close] });
    A.h.reveal(A.els.alert);
  }
  /* r10 review (1.3.1): the fresh check before the send found the order on hold (or gone, prepaid, gift, digital) or the
     offer / price changed: nothing was sent; Close (the list, or the start page, reads Skio again) */
  function addChanged(A, kind) {
    A.phase = 'refused';
    A.stale = true;       /* our data is behind Skio's: the start page starts over when the pop-up closes */
    if (A.closed || !A.h.isOpen()) return;
    var held = kind === 'held';
    var close = el('button', { type: 'button', 'class': 'mk-dlg-btn ' + (held ? 'mk-dlg-btn--ghost' : 'mk-dlg-btn--primary') }, 'Close');
    close.addEventListener('click', function () { A.h.close('close'); });
    if (A.els.alert) A.els.alert.remove();
    A.els.alert = el('div', { 'class': 'mk-dlg-alert mka-alert--info', id: 'mk-add-alert', role: 'alert' }, addIcon('alert'),
      el('div', null, el('b', null, held ? 'This order can\'t take new products right now.' : 'Prices or options changed.'),
        el('span', null, held ? 'Nothing was added. Open your subscription to see why.' : 'Nothing was added. Close this to see the latest.')));
    A.h.body.appendChild(A.els.alert);
    M.qa('input', A.h.body).forEach(function (i) { i.disabled = true; });
    A.h.set({ actions: held ? [el('a', { 'class': 'mk-dlg-btn mk-dlg-btn--primary', href: subUrl(A.offer.subId) }, 'View order'), close] : [close] });
    A.h.reveal(A.els.alert);
  }
  /* any failure: the choices stay, "We couldn't add this to your order. Please try again." and Try again
     (a new click, a new token; the core re-reads before sending again) */
  function addFailed(A, v, once, r) {
    if (A.closed || !A.h.isOpen()) return;
    A.phase = 'error';
    if (A.els.alert) A.els.alert.remove();
    A.els.alert = el('div', { 'class': 'mk-dlg-alert', id: 'mk-add-alert', role: 'alert' }, addIcon('alert'),
      el('div', null, el('b', null, 'We couldn\'t add this to your order.'), el('span', null, 'Please try again.')));
    A.h.body.appendChild(A.els.alert);
    A.els.go.setAttribute('aria-describedby', 'mk-add-alert mk-add-fine');
    M.text(A.els.go, 'Try again');
    A.h.reveal(A.els.alert);
    M.log('home: Add failed (' + (r.reason || 'error') + ', ' + (r.outcome || '?') + ')');
    /* Skio may still apply it (timeout, 5xx, accepted but not seen yet): look again later, without sending */
    if (r.outcome === 'unknown' || r.outcome === undefined) {
      var attempt = A.attempt = (A.attempt || 0) + 1;
      /* r10: the order and lines of THIS attempt (the order cannot change after it: A.lockSub) */
      var off = A.offer, base = A.baseline.slice();
      ADD_LATE_CHECKS_MS.forEach(function (ms) {
        setTimeout(function () {
          if (A.closed || A.phase !== 'error' || A.attempt !== attempt || A.late) return;
          addRefresh({ offer: off }, function (l) {
            return sameId(l.productVariantId || (l.ProductVariant && l.ProductVariant.id), v.id) && isOneTime(l) === once && base.indexOf(str(l.id)) < 0;
          }, 1).then(function (res) {
            if (!res || !res.line || A.late || A.closed || A.phase !== 'error' || A.attempt !== attempt || A.offer !== off) return;
            A.late = true;
            addApply(A, res);
            addDone(A, v, once, null, res);
          });
        }, ms);
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* "Change date" pop-up (r8, 1.2.0; approved design change-date-design  */
  /* DESIGN-NOTES sections 3-7, safety spec research/02 sections 4-5):    */
  /* "Change date" on the NEXT ORDER card and on each subscription's next */
  /* order in Upcoming orders opens "Move your <Oct 30> order" in place:  */
  /* what moves (the same lines and total as the card: nextLines +       */
  /* orderMoney), Currently -> New date, quick picks, a calendar of the   */
  /* days Skio allows (MKPortal.nextDateRange, the core's own range), the */
  /* charge line, and "Move to <Fri, Nov 6>", which saves with the core's */
  /* SECOND guarded write (MKPortal.changeNextOrderDate: Skio's own       */
  /* updateNextBillingDateAction, a single-use token from the customer's  */
  /* own click, a fresh read first, one send, success only when a re-read */
  /* shows the picked store day). Offered ONLY when the core says the     */
  /* write is on (MKPortal.writeEnabled('next-date'): the loader's        */
  /* MKPortalConfig.writes.nextDate === true) and Skio's own rules allow  */
  /* it (MKPortal.nextDateEligible, the same function the core re-runs on */
  /* its own read); anything else = r6's hand-off to Skio's own window.   */
  /* Every day is a store day ('YYYY-MM-DD', MKPortal.orderDay): never    */
  /* the browser's zone.                                                  */
  /* ------------------------------------------------------------------ */
  var NB = '\u00A0';
  var DATE_REFRESH_TRIES = 3;           /* fresh home reads after a move until our data shows the new day */
  var DATE_REFRESH_GAP_MS = 1200;
  var DATE_WAIT_MS = 8000;              /* the button keeps "Moving..." this long at most for the fresh read */
  var DATE_SETTLE_MS = [4000, 12000, 30000, 62000];   /* after an unclear outcome and Close: read-only looks */
  var DATE_HOLD_MS = typeof CFG.resendHoldMs === 'number' && CFG.resendHoldMs >= 2000 && CFG.resendHoldMs <= 600000 ? CFG.resendHoldMs : 60000;
  var dt = null;          /* the open pop-up: {h, subId, sub, tz, cur, range, pick, view, focus, tapped, phase, ...} */
  var dateNote = null;    /* after the pop-up: {kind: 'done' | 'already' | 'pending', subId, to, was, names, after} */
  var dateMoved = {};     /* this page view only: subscription id -> {from, to} (Upcoming's "Moved from" tag) */
  var dateHolds = {};     /* subscription id -> {until, to}: an unclear outcome; Move is not offered meanwhile */
  var dateRunning = {};   /* subscription id -> date changes of this page still running (r8 review: a 'busy' answer) */

  function cdIcon(name) {
    var P = { check: ['M20 6 9 17l-5-5'], alert: ['M12 2a10 10 0 1 0 0 20a10 10 0 1 0 0-20z', 'M12 7v6', 'M12 16.5v.5'],
      prev: ['M15 18l-6-6 6-6'], next: ['M9 18l6-6-6-6'], arrow: ['M5 12h14', 'M13 6l6 6-6 6'], x: ['M6 6l12 12', 'M18 6 6 18'],
      info: ['M12 2a10 10 0 1 0 0 20a10 10 0 1 0 0-20z', 'M12 11v6', 'M12 7.5v.5'] };
    return M.svg('0 0 24 24', P[name] || [], { 'class': 'mkc-ico mkc-ico--' + name });
  }
  /* store days ('YYYY-MM-DD') as text: 'weekday' Fri, Oct 30 / 'short' Oct 30 / 'long' Friday, October 30 (year when not
     this year) */
  function fmtDay(ymd, style) { return M.formatDate(ymd, style || 'weekday', { year: 'auto', timeZone: (dt && dt.tz) || lastTz, now: Date.now() }); }
  function nbsp(s) { return str(s).replace(/ /g, NB); }       /* a date never breaks across lines */
  function ymdPlus(ymd, k) { return S.addYmd(ymd, k); }
  function ymdDow(ymd) { return new Date(Date.UTC(+ymd.slice(0, 4), +ymd.slice(5, 7) - 1, +ymd.slice(8, 10))).getUTCDay(); }
  /* month steps for Page Up / Page Down: the same day, else the month's last day */
  function ymdMonths(ymd, k) {
    var y = +ymd.slice(0, 4), m = +ymd.slice(5, 7) - 1 + k, d = +ymd.slice(8, 10);
    var last = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
    return new Date(Date.UTC(y, m, Math.min(d, last))).toISOString().slice(0, 10);
  }
  var CAL_MONTH = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });
  function monthName(y, m) { return CAL_MONTH.format(new Date(Date.UTC(y, m - 1, 15))); }
  function quickLabel(k) {
    var w = Math.abs(k) % 7 === 0, n2 = w ? Math.abs(k) / 7 : Math.abs(k);
    return n2 + (w ? (n2 === 1 ? ' week ' : ' weeks ') : (n2 === 1 ? ' day ' : ' days ')) + (k < 0 ? 'sooner' : 'later');
  }

  /* everything the pop-up needs, from the model only (never the DOM): {ok: true, el, lines} or {why} (then the hand-off).
     el = MKPortal.nextDateEligible(sub, site): {day (the store day shown as "Currently"), tz, range {today, min, max}} */
  function dateGate(sub, site, opts) {
    if (!DECISION_DATE_POPUP.enabled) return { why: 'switched off (DECISION_DATE_POPUP)' };
    if (!M.dialog || typeof M.dialog.open !== 'function' || typeof M.changeNextOrderDate !== 'function' || typeof M.writeEnabled !== 'function' ||
        typeof M.nextDateEligible !== 'function' || typeof M.nextDateRange !== 'function' || typeof M.orderDay !== 'function' ||
        typeof M.nextDateInstant !== 'function' || typeof M.nextOrderDate !== 'function' || typeof S.addYmd !== 'function') return { why: 'core without the date pop-up' };
    /* the kill switch: exactly true (the core checks the loader's config and window.MKPortalConfig now) */
    if (M.writeEnabled('next-date') !== true) return { why: 'the date write is off (MKPortalConfig.writes.nextDate)' };
    if (!obj(sub)) return { why: 'no subscription' };
    var e = M.nextDateEligible(sub, obj(site) || {}, opts);
    if (!e || e.ok !== true || !e.range) return { why: 'not offered (' + (e && e.rule) + ')' };
    if (e.range.max !== null && e.range.max < e.range.min) return { why: 'no day Skio allows' };
    var lines = nextLines(sub);
    if (!lines.length) return { why: 'nothing ships in that order' };
    return { ok: true, el: e, lines: lines };
  }
  function dateOffered(sub, site) { try { var g = dateGate(sub, site); return !!(g && g.ok); } catch (e) { return false; } }
  function dateHeld(subId) {
    var h = dateHolds[subId];
    if (h && Date.now() >= h.until) { delete dateHolds[subId]; h = null; }
    return h || null;
  }
  function subById(raw, id) { return arr(raw && raw.subs).filter(function (s) { return obj(s) && s.id === id; })[0] || null; }
  function subOpenCount(raw) { return arr(raw && raw.subs).filter(function (s) { return obj(s) && isOpen(s); }).length; }
  function lineNames(lines) { return lines.map(function (l) { return lineTitle(l); }).join(', '); }

  /* "The order after that": only from the core's schedule (MKPortal.schedule.upcoming, the Upcoming orders rule; it
     stops at anchors, a skipped cycle, max cycles and where the month-end rules disagree), for the subscription as it
     would be after the move. INFERRED, not a Skio fact (live test L7). null = say "your usual schedule" instead. */
  function dateAfter(sub, ymd, tz) {
    try {
      var inst = M.nextDateInstant(sub.nextBillingDate, ymd, tz);
      if (!inst) return null;
      var n2 = S.normalize(Object.assign({}, sub, { nextBillingDate: inst }), true);
      var list = n2 ? S.upcoming(n2, tz, { max: 2 }) : [];
      return list.length > 1 && list[0].ymd === ymd ? list[1].ymd : null;
    } catch (e) { return null; }
  }
  function monthEnd(policy, ymd) {
    var u = str(obj(policy) && policy.interval).toUpperCase().replace(/S$/, '');
    return (u === 'MONTH' || u === 'YEAR') && +ymd.slice(8, 10) >= 29;
  }

  /* -------- the pop-up's parts -------- */
  function cdWhat(D) {
    var lines = D.lines, max = 3, shown = lines.length > max ? lines.slice(0, max - 1) : lines;
    var rows = shown.map(function (l) {
      var src = img(lineImage(l), 96), bits = [];
      if (l.ProductVariant.title && l.ProductVariant.title !== 'Default Title') bits.push(str(l.ProductVariant.title));
      bits.push('Qty ' + (parseInt(l.quantity, 10) || 1));
      return el('li', { 'class': 'mkc-line' },
        src ? el('img', { src: src, alt: '', width: '44', height: '44', decoding: 'async' }) : el('span', { 'class': 'mkc-ph', 'aria-hidden': 'true' }),
        el('span', { 'class': 'mkc-line-main' }, el('b', null, lineTitle(l) + (isOneTime(l) ? ' (this order only)' : '')), el('span', null, bits.join(DOT))));
    });
    if (shown.length < lines.length) rows.push(el('li', { 'class': 'mkc-more' }, '+ ' + (lines.length - shown.length) + ' more products'));
    return el('section', { 'class': 'mkc-what', 'aria-label': 'In this order' },
      el('span', { 'class': 'mkc-eyebrow', 'aria-hidden': 'true' }, 'In this order'),
      el('ul', { 'class': 'mkc-lines' }, rows),
      el('div', { 'class': 'mkc-what-foot' }, el('span', null, D.freq || 'Subscription'),
        D.money ? el('span', null, 'Total ', el('b', null, M.money(D.money.total, D.money.currency))) : null));
  }
  function cdMove(D) {
    var now = el('div', { 'class': 'mkc-day' }, el('small', null, 'Currently'), el('b', null, fmtDay(D.cur)));
    var nw = D.pick
      ? el('div', { 'class': 'mkc-day mkc-day--new' }, el('small', null, D.phase === 'unknown' ? 'You asked for' : 'New date'), el('b', null, fmtDay(D.pick)))
      : el('div', { 'class': 'mkc-day mkc-day--empty' }, el('small', null, 'New date'), el('b', null, 'Pick a day'));
    return el('div', { 'class': 'mkc-move', id: 'mkc-move', role: 'group', 'aria-label': 'Order date' }, now, cdIcon('arrow'), nw);
  }
  function inRange(D, ymd) { return !!ymd && ymd >= D.range.min && (D.range.max === null || ymd <= D.range.max); }
  function cdQuick(D) {
    var opts = arr(DECISION_DATE_POPUP.quickPicks).filter(function (k) { return typeof k === 'number' && k && Math.floor(k) === k; })
      .map(function (k) { return { k: k, ymd: ymdPlus(D.cur, k) }; })
      .filter(function (q) { return q.ymd && q.ymd !== D.cur && inRange(D, q.ymd); });
    if (!opts.length) return null;
    return el('fieldset', { 'class': 'mkc-quick' }, el('legend', null, 'Quick picks'),
      el('div', { 'class': 'mka-chips', style: { '--mkc-n': String(opts.length) } }, opts.map(function (q) {
        var i = el('input', { type: 'radio', name: 'mkc-quick', value: q.ymd });
        i.checked = D.pick === q.ymd;
        return el('label', { 'class': 'mka-chip mk-dlg-choice' }, i, el('span', null, quickLabel(q.k), el('small', null, fmtDay(q.ymd))));
      })));
  }
  function cdCalendar(D, quickShown) {
    var y = D.view.y, m = D.view.m, thisM = y + '-' + (m < 10 ? '0' : '') + m;
    var first = thisM + '-01', days = new Date(Date.UTC(y, m, 0)).getUTCDate();
    var prev = el('button', { type: 'button', 'class': 'mkc-nav', 'data-mkc-nav': '-1', 'aria-label': 'Previous month' }, cdIcon('prev'));
    var next = el('button', { type: 'button', 'class': 'mkc-nav', 'data-mkc-nav': '1', 'aria-label': 'Next month' }, cdIcon('next'));
    if (thisM <= D.range.min.slice(0, 7)) prev.setAttribute('aria-disabled', 'true');
    if (D.range.max !== null && thisM >= D.range.max.slice(0, 7)) next.setAttribute('aria-disabled', 'true');
    var cells = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(function (d) { return el('span', { 'class': 'mkc-dow', 'aria-hidden': 'true' }, d); });
    for (var b = 0; b < ymdDow(first); b++) cells.push(el('span', { 'class': 'mkc-cell', 'aria-hidden': 'true' }));
    var focusDay = D.focus && D.focus.slice(0, 7) === thisM ? D.focus : (D.pick && D.pick.slice(0, 7) === thisM ? D.pick : (D.cur.slice(0, 7) === thisM ? D.cur : null));
    /* r8 review: the days are store days; "today" / "tomorrow" are said only when the customer's own day (this browser's
       zone, the core's clock) is the store's day, so a customer elsewhere is never told a day is her today */
    var ownDay = S.ymd(new Date(Date.now())), sameDay = ownDay === D.range.today;
    for (var d = 1; d <= days; d++) {
      var ymd = thisM + '-' + (d < 10 ? '0' : '') + d, off = !inRange(D, ymd), isToday = sameDay && ymd === D.range.today;
      if (!focusDay && !off) focusDay = ymd;
      var label = fmtDay(ymd, 'long') + (ymd === D.cur ? ', your order\'s current date' : '') + (isToday ? ', today' : '') + (off ? ', not available' : '');
      var btn = el('button', { type: 'button', 'class': 'mkc-d' + (ymd === D.cur ? ' is-now' : '') + (isToday ? ' is-today' : '') + (ymd === D.tapped ? ' is-tapped' : ''),
        'data-mkc-day': ymd, 'aria-label': label, 'aria-pressed': D.pick === ymd ? 'true' : 'false', tabindex: '-1' }, String(d));
      if (off) btn.setAttribute('aria-disabled', 'true');
      cells.push(el('span', { 'class': 'mkc-cell' }, btn));
    }
    var grid = el('div', { 'class': 'mkc-grid' }, cells);
    var fb = focusDay ? grid.querySelector('[data-mkc-day="' + focusDay + '"]') : null;
    if (fb) fb.setAttribute('tabindex', '0');
    var hint = null, limit = null;
    if (D.tapped) {
      /* a tap on a day Skio does not allow: one information note; the range line hides while it shows */
      hint = el('p', { 'class': 'mkc-hint', id: 'mkc-hint', role: 'status' }, cdIcon('info'),
        el('span', null, D.tapped < D.range.min
          ? [el('b', null, fmtDay(D.tapped, 'short') + ' can\'t be picked.'), sameDay ? ' The earliest day is tomorrow, ' + nbsp(fmtDay(D.range.min)) + '.'
            : ' The earliest day you can pick is ' + nbsp(fmtDay(D.range.min)) + '.']
          : [el('b', null, fmtDay(D.tapped, 'short') + ' is too far ahead.'), ' The latest day you can pick is ' + nbsp(fmtDay(D.range.max)) + '.']));
    } else {
      limit = el('p', { 'class': 'mkc-limit' }, D.range.max !== null
        ? 'You can pick any day from ' + nbsp(fmtDay(D.range.min)) + ' to ' + nbsp(fmtDay(D.range.max)) + '.'
        : (sameDay ? 'You can pick any day from tomorrow, ' : 'You can pick any day from ') + nbsp(fmtDay(D.range.min)) + '.');
    }
    /* "Or pick a day" where the quick picks sit right above it; the two-column desktop layout hides "Or" (CSS .mkc-or) */
    var legend = el('legend', null, quickShown ? [el('span', { 'class': 'mkc-or' }, 'Or '), 'pick a day'] : 'Pick a day');
    return el('fieldset', { 'class': 'mkc-cal-wrap', id: 'mkc-cal-wrap' }, legend,
      el('div', { 'class': 'mkc-cal', role: 'group', 'aria-label': monthName(y, m) },
        el('div', { 'class': 'mkc-cal-head' }, prev, el('b', { 'aria-live': 'polite' }, monthName(y, m)), next), grid),
      el('div', { 'class': 'mkc-key', 'aria-hidden': 'true' },
        el('span', null, el('i', { 'class': 'k-now' }), 'Current date (' + nbsp(fmtDay(D.cur, 'short')) + ')'),
        el('span', null, el('i', { 'class': 'k-new' }), 'New date'), el('span', null, el('i', { 'class': 'k-off' }), 'Not available')),
      hint, limit);
  }
  /* the charge line (pinned above the buttons, read with the main button) */
  function cdFine(D) {
    var f = el('p', { 'class': 'mk-dlg-fine', id: 'mkc-fine' });
    if (!D.pick) { f.appendChild(document.createTextNode('Your order stays on ' + fmtDay(D.cur) + ' until you pick a new date and press Move.')); return f; }
    /* "arrives about": r6's rule (this customer's own medians, >= 2 deliveries each), added to the picked day; left out
       until the delivery data is in, never guessed */
    var days = st && st.arrives && typeof st.arrives.days === 'number' ? st.arrives.days : null;
    var arrive = days !== null ? ymdPlus(D.pick, days) : null;
    var after = dateAfter(D.sub, D.pick, D.tz);
    f.appendChild(el('b', null, 'Charged on ' + fmtDay(D.pick) + (arrive ? DOT + 'arrives about ' + fmtDay(arrive, 'short') : '') + '.'));
    f.appendChild(document.createTextNode(after
      ? ' The order after that: ' + fmtDay(after) + ', then ' + (monthEnd(D.sub.BillingPolicy, D.pick) ? 'on your usual schedule' : (D.freq ? D.freq.toLowerCase() : 'your usual schedule')) + '.'
      : ' Orders after this one follow your usual schedule from the new date.'));
    return f;
  }
  /* the "orders in a row" note (DECISION_STREAK_NOTE, default off): compares INSTANTS, the one the core would send for
     the picked day (MKPortal.nextDateInstant) with streakExpiresAt; the deadline shown is the last day whose instant
     is still before it. Only for a customer with exactly one open subscription; information, never a block. */
  function cdStreak(D) {
    if (!DECISION_STREAK_NOTE.enabled || !D.pick || !D.oneOpen) return null;
    var count = Math.floor(n(D.sub.streakCount) || 0), exp = Date.parse(str(D.sub.streakExpiresAt));
    if (!(count >= 1) || !isFinite(exp)) return null;
    var inst = M.nextDateInstant(D.sub.nextBillingDate, D.pick, D.tz);
    if (!inst || Date.parse(inst) < exp) return null;
    var last = M.orderDay(new Date(exp).toISOString(), D.tz);
    for (var i = 0; i < 4 && last; i++) {
      var t = M.nextDateInstant(D.sub.nextBillingDate, last, D.tz);
      if (t && Date.parse(t) < exp) break;
      last = ymdPlus(last, -1);
    }
    if (!last || last < D.range.min) return null;
    return el('div', { 'class': 'mk-dlg-alert mka-alert--info', id: 'mkc-streak', role: 'status' }, cdIcon('info'),
      el('span', null, el('b', null, 'You have ' + count + (count === 1 ? ' order in a row.' : ' orders in a row.')),
        ' To keep your streak, this order needs to be charged by ' + nbsp(fmtDay(last)) + '. Moving it to ' + nbsp(fmtDay(D.pick, 'short')) + ' may reset your streak.'));
  }
  function cdAlert(kind, head, text) {
    return el('div', { 'class': 'mk-dlg-alert' + (kind === 'info' ? ' mka-alert--info' : ''), id: 'mkc-alert', role: kind === 'info' ? 'status' : 'alert' },
      cdIcon(kind === 'info' ? 'info' : 'alert'), el('span', null, el('b', null, head), text ? ' ' + text : null));
  }
  function cdTitle(D) { return 'Move your ' + fmtDay(D.cur, 'short') + ' order'; }
  function cdChooseActions(D) {
    var busy = D.phase === 'busy';
    var go = el('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--primary', id: 'mkc-go',
      'aria-describedby': D.alert && D.alert.getAttribute('role') === 'alert' ? 'mkc-alert mkc-fine' : 'mkc-fine' },
      busy ? [el('span', { 'class': 'mkc-spin', 'aria-hidden': 'true' }), 'Moving to ' + fmtDay(D.pick, 'short') + '\u2026']
        : D.pick ? (D.phase === 'refused' ? 'Try again' : 'Move to ' + fmtDay(D.pick)) : 'Pick a new date');
    if (!D.pick || busy) go.setAttribute('aria-disabled', 'true');
    if (busy) go.setAttribute('aria-busy', 'true');
    var cancel = el('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--ghost', id: 'mkc-cancel' }, 'Cancel');
    if (busy) cancel.setAttribute('aria-disabled', 'true');
    cancel.addEventListener('click', function () { if (D.phase !== 'busy') D.h.close('cancel'); });
    go.addEventListener('click', function (ev) { dateGo(D, ev); });
    return [cdFine(D), go, cancel];
  }
  /* the unclear outcome: nothing claims the date did or did not change; Check again only reads */
  function cdUnknownView(D, text) {
    D.phase = 'unknown';
    D.alert = cdAlert('info', 'We\'re still checking.', text || ('Your order shows ' + nbsp(fmtDay(D.cur)) + ' for now. You don\'t need to ask again. Check again in a moment.'));
    var check = el('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--primary', id: 'mkc-check' }, 'Check again');
    var close = el('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--ghost', id: 'mkc-close' }, 'Close');
    check.addEventListener('click', function () { dateCheck(D, check); });
    close.addEventListener('click', function () { D.h.close('close'); });
    D.h.set({ title: cdTitle(D), icon: null, body: [cdWhat(D), D.alert, cdMove(D)],
      actions: [el('p', { 'class': 'mk-dlg-fine', id: 'mkc-fine' }, 'Check again only looks at your order. It doesn\'t change anything.'), check, close], focus: false });
    cdKeepFocus(D, check);
    D.h.root.classList.remove('mkc-busy');
    D.h.reveal(D.alert);
  }
  /* r8 review: a view that replaces the focused button (Move) puts focus on its own main control, so focus never falls
     out of the pop-up to the page (DESIGN-NOTES sec. 3); focus already inside (the title on open) stays */
  function cdKeepFocus(D, node) {
    if (!node || !D.h.isOpen() || D.h.root.contains(document.activeElement)) return;
    try { node.focus({ preventScroll: true }); } catch (e) { node.focus(); }
  }
  /* (re)draw the choose / busy / refused views; the focused control keeps focus across the redraw */
  function cdDraw(D, opts) {
    if (!D || !D.h.isOpen()) return;
    opts = opts || {};
    var a = document.activeElement, keep = null;
    if (a && D.h.root.contains(a)) {
      if (a.getAttribute('data-mkc-day')) keep = '[data-mkc-day="' + a.getAttribute('data-mkc-day') + '"]';
      else if (a.getAttribute('data-mkc-nav')) keep = '[data-mkc-nav="' + a.getAttribute('data-mkc-nav') + '"]';
      else if (a.name === 'mkc-quick') keep = 'input[name="mkc-quick"][value="' + a.value + '"]';
      else if (a.id === 'mkc-go' || a.id === 'mkc-cancel') keep = '#' + a.id;
    }
    if (opts.focus) keep = opts.focus;
    var body = D.h.body, top = body.scrollTop;
    var q = cdQuick(D);
    /* r10 review: a redraw while choosing (a day picked, the month changed) is the same step: no new arm time (core 1.5.1);
       after a send (busy, an alert) the buttons count only once seen again */
    D.h.set({ title: cdTitle(D), icon: null, body: [cdWhat(D), D.alert, cdMove(D), cdStreak(D), q, cdCalendar(D, !!q)], actions: cdChooseActions(D), focus: false,
      arm: D.phase !== 'choose' || !!opts.reveal });
    body.scrollTop = top;
    D.h.root.classList.toggle('mkc-busy', D.phase === 'busy');
    if (D.phase === 'busy') M.qa('button, input', body).forEach(function (b) { b.setAttribute('aria-disabled', 'true'); if (b.tagName === 'INPUT') b.disabled = true; });
    if (keep) { var f = D.h.root.querySelector(keep); if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } } }
    if (opts.reveal) D.h.reveal(opts.reveal === 'alert' ? D.alert : document.getElementById(opts.reveal));
  }
  function setView(D, ymd) { D.view = { y: +ymd.slice(0, 4), m: +ymd.slice(5, 7) }; }
  function datePick(D, ymd) {
    if (!D || D.phase === 'busy' || D.phase === 'unknown' || !inRange(D, ymd)) return;
    D.pick = ymd === D.cur ? null : ymd;        /* picking the current day clears the pick */
    D.tapped = null; D.focus = null;
    if (D.phase === 'refused' || D.alert) { D.phase = 'choose'; D.alert = null; }
    setView(D, ymd);
    cdDraw(D);
  }
  function dateTapOff(D, ymd) {
    D.tapped = ymd; D.focus = ymd; setView(D, ymd);
    cdDraw(D, { focus: '[data-mkc-day="' + ymd + '"]', reveal: 'mkc-hint' });
  }
  function dateOnBody(D, ev) {
    var t = ev.target;
    if (!D || D.phase === 'busy' || D.phase === 'unknown' || !t || !t.closest) return;
    var nav = t.closest('[data-mkc-nav]'), day = t.closest('[data-mkc-day]');
    if (nav) {
      if (nav.getAttribute('aria-disabled') === 'true') return;
      var k = +nav.getAttribute('data-mkc-nav'), m = D.view.m + k, y = D.view.y;
      if (m < 1) { m = 12; y--; } if (m > 12) { m = 1; y++; }
      D.view = { y: y, m: m }; D.tapped = null; D.focus = null;
      cdDraw(D, { focus: '[data-mkc-nav="' + k + '"]' });
      return;
    }
    if (day) {
      var ymd = day.getAttribute('data-mkc-day');
      if (day.getAttribute('aria-disabled') === 'true') dateTapOff(D, ymd);
      else datePick(D, ymd);
    }
  }
  /* roving focus in the day grid: arrows +-1 / +-7 days, Page Up / Page Down a month, Home / End the week's ends;
     Enter / Space pick (native buttons). Days Skio does not allow take focus too (a screen reader hears why). */
  function dateOnKey(D, ev) {
    var d = ev.target && ev.target.closest && ev.target.closest('[data-mkc-day]');
    if (!d || !D || D.phase === 'busy' || ev.altKey || ev.ctrlKey || ev.metaKey) return;
    var ymd = d.getAttribute('data-mkc-day'), to = null;
    switch (ev.key) {
      case 'ArrowLeft': to = ymdPlus(ymd, -1); break;
      case 'ArrowRight': to = ymdPlus(ymd, 1); break;
      case 'ArrowUp': to = ymdPlus(ymd, -7); break;
      case 'ArrowDown': to = ymdPlus(ymd, 7); break;
      case 'PageUp': to = ymdMonths(ymd, -1); break;
      case 'PageDown': to = ymdMonths(ymd, 1); break;
      case 'Home': to = ymdPlus(ymd, -ymdDow(ymd)); break;
      case 'End': to = ymdPlus(ymd, 6 - ymdDow(ymd)); break;
      default: return;
    }
    ev.preventDefault();
    /* the calendar shows the months from today's to the latest day's */
    if (!to || to.slice(0, 7) < D.range.today.slice(0, 7) || (D.range.max !== null && to.slice(0, 7) > D.range.max.slice(0, 7))) return;
    D.focus = to; D.tapped = null; setView(D, to);
    cdDraw(D, { focus: '[data-mkc-day="' + to + '"]' });
  }

  /* opens the pop-up for the subscription of a "Change date" control; false = not offered (the caller hands off) */
  function openDate(opener) {
    var subId = opener.getAttribute('data-mk-sub');
    var inUp = !!(opener.closest && opener.closest('#mk-upcoming'));
    if (!validId(subId)) return false;
    var raw = null;
    if (inUp) {
      /* Upcoming: only a subscription's NEXT order (Skio keeps one date per subscription) */
      if (!up.raw || !up.model || !up.model.rows.some(function (r) { return r.id === subId && r.next && r.changeDate; })) return false;
      raw = up.raw;
    } else {
      if (!st || status !== 'ready' || !st.model || st.model.main.id !== subId) return false;
      raw = st.model.raw;
    }
    if (!raw || raw.source !== 'mkHome') return false;
    var sub = subById(raw, subId);          /* the subscription from the model, by id */
    var g = dateGate(sub, raw.site);
    if (!g.ok) { M.log('home: date pop-up not offered (' + g.why + '); hand-off to Skio\'s page'); return false; }
    var site = obj(raw.site) || {}, siteCurrency = /^[A-Z]{3}$/.test(str(site.currencyCode)) ? site.currencyCode : null;
    var key = opener.getAttribute('data-mk-key');
    var D = {
      subId: subId, sub: sub, tz: g.el.tz, cur: g.el.day, range: g.el.range, lines: g.lines, money: orderMoney(sub, g.lines, siteCurrency),
      freq: schedule(sub.BillingPolicy), oneOpen: subOpenCount(raw) === 1, pick: null, view: null, focus: null, tapped: null,
      phase: 'choose', alert: null, where: inUp ? 'upcoming' : 'home', closed: false
    };
    setView(D, D.cur);
    var held = dateHeld(subId);
    if (held && held.to !== D.cur) D.pick = held.to;
    var q = cdQuick(D);
    var h = M.dialog.open({
      id: 'mk-cdd', className: 'mk-add mk-cdd', module: 'home', title: cdTitle(D),
      body: [cdWhat(D), cdMove(D), q, cdCalendar(D, !!q)], actions: cdChooseActions(D), opener: opener,
      /* the opener may have been redrawn (a fresh read): focus goes back to the same control */
      returnFocus: function () {
        var root = document.getElementById(inUp ? 'mk-upcoming' : 'mk-home');
        return root && key ? root.querySelector('[data-mk-key="' + key + '"]') : null;
      },
      onClose: function (reason) {
        D.closed = true;
        if (dt === D) dt = null;
        M.log('home: date pop-up closed (' + reason + ')');
        /* closed while the answer was unclear: the card says it is still checking, until a later read settles it */
        if (D.phase === 'unknown' && D.pick) datePending(D);
      }
    });
    if (!h) return false;
    D.h = h;
    dt = D;
    h.body.addEventListener('click', function (ev) { dateOnBody(D, ev); });
    h.body.addEventListener('change', function (ev) { if (ev.target && ev.target.name === 'mkc-quick') datePick(D, ev.target.value); });
    h.body.addEventListener('keydown', function (ev) { dateOnKey(D, ev); });
    /* an earlier attempt with an unclear outcome is still held (the core would not send again): only Check again */
    if (held) cdUnknownView(D, 'Your order shows ' + nbsp(fmtDay(D.cur)) + ' for now. You don\'t need to ask again. Check again in a moment.');
    return true;
  }

  /* the customer's own press of "Move to <day>": token -> busy -> the one write -> result */
  function dateGo(D, ev) {
    if (D.phase === 'busy' || D.phase === 'unknown' || !D.pick || dateHeld(D.subId)) return;
    var date = D.pick, from = D.cur;
    var tok = D.h.confirm(ev, { kind: 'next-date', subscriptionId: D.subId, date: date, from: from });
    if (!tok) return;     /* a double click, a busy dialog or not the customer's own click: nothing happens */
    D.h.busy(true);
    D.phase = 'busy'; D.alert = null; D.tapped = null;
    cdDraw(D, { focus: '#mkc-go' });
    dateRunning[D.subId] = (dateRunning[D.subId] || 0) + 1;
    var done = function () { if (dateRunning[D.subId] > 0) dateRunning[D.subId]--; };
    M.changeNextOrderDate({ subscriptionId: D.subId, date: date, from: from, confirm: tok }).then(function (r) {
      done();
      r = r || {};
      M.log('home: date change ' + (r.ok ? 'ok via ' + r.via : r.reason + ' (' + r.outcome + ')'));
      /* the pop-up went away while the write ran (route change, gate off): our data may be behind Skio's whatever the
         outcome: read the home again (fails closed to Skio's list) */
      if (D.closed || !D.h.isOpen()) {
        if (r.ok || r.sent || r.outcome === 'unknown') { M.invalidate('skio'); if (st && status === 'ready' && !(M.dialog && M.dialog.isOpen())) startHome(); }
        return;
      }
      if (r.ok) return dateSaved(D, r, date, from);
      D.h.busy(false);
      dateFailed(D, r, date, from);
    }).then(null, function (e) {
      done();
      M.log('home: date pop-up error', e && e.message);
      if (!D.closed && D.h.isOpen()) { D.h.busy(false); dateFailed(D, { reason: 'error', outcome: 'unknown' }, date, from); }
    });
  }

  /* a result that is not a success, mapped to the approved views (DESIGN-NOTES section 4) */
  function dateFailed(D, r, date, from) {
    var cur = typeof r.current === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(r.current) ? r.current : null;
    var now = function (day, head, text) {
      /* the order shows another day than the pop-up did: the title, Currently and the ring follow it; nothing claims
         the picked day */
      D.cur = day; D.pick = null; D.phase = 'choose'; setView(D, day);
      D.alert = cdAlert('info', head, text);
      cdDraw(D, { reveal: 'alert' });
      dateRefresh(D);
    };
    if (r.outcome === 'unknown' && r.reason === 'mismatch' && cur && cur !== from && cur !== date) {
      return now(cur, 'Your order now shows ' + nbsp(fmtDay(cur)) + '.', 'Pick a new date if you still want to move it.');
    }
    if (r.outcome === 'unknown' || (r.reason === 'error' && r.sent)) {
      /* Skio may still apply it: no second send for 60 s (for the rest of the page view after Skio's ok); Check again reads */
      if (cur && cur !== from && cur !== date) return now(cur, 'Your order now shows ' + nbsp(fmtDay(cur)) + '.', 'Pick a new date if you still want to move it.');
      dateHolds[D.subId] = { until: r.accepted ? Infinity : Date.now() + DATE_HOLD_MS, to: date };
      return cdUnknownView(D, cur === from ? null : 'You don\'t need to ask again. Check again in a moment.');
    }
    if (r.reason === 'changed' && cur) {
      return now(cur, 'This order\'s date changed.', 'This order was changed to ' + nbsp(fmtDay(cur)) + ' while this was open, so we didn\'t make your change. Pick a new date if you still want to move it.');
    }
    if (r.reason === 'unauthorized') {
      D.phase = 'refused';
      D.alert = cdAlert('error', 'Please sign in again to change your order.', null);
      var signIn = el('a', { 'class': 'mk-dlg-btn mk-dlg-btn--primary', href: base() + '/login' }, 'Sign in');
      var close = el('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--ghost', id: 'mkc-close' }, 'Close');
      close.addEventListener('click', function () { D.h.close('close'); });
      var q = cdQuick(D);
      D.h.set({ title: cdTitle(D), body: [cdWhat(D), D.alert, cdMove(D), q, cdCalendar(D, !!q)], actions: [cdFine(D), signIn, close], focus: false });
      cdKeepFocus(D, signIn);
      D.h.root.classList.remove('mkc-busy');
      D.h.reveal(D.alert);
      return;
    }
    if (r.reason === 'refused' && cur && cur !== from && cur !== date) {
      return now(cur, 'Your order now shows ' + nbsp(fmtDay(cur)) + '.', 'Pick a new date if you still want to move it.');
    }
    if (r.reason === 'not_allowed' || r.reason === 'off') {
      /* Skio's rules no longer allow it here (or the switch went off): Skio's own page */
      D.phase = 'refused';
      D.alert = cdAlert('error', 'This order can\'t be moved here.', 'You can change its date on your subscription page.');
      var page = el('a', { 'class': 'mk-dlg-btn mk-dlg-btn--primary', href: subUrl(D.subId), 'data-mk-key': 'cd-page' }, 'Open subscription page');
      page.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault(); D.h.close('handoff', { returnFocus: false }); handoff(D.subId, 'change-date');
      });
      var close2 = el('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--ghost', id: 'mkc-close' }, 'Close');
      close2.addEventListener('click', function () { D.h.close('close'); });
      D.h.set({ title: cdTitle(D), body: [cdWhat(D), D.alert, cdMove(D)], actions: [page, close2], focus: false });
      cdKeepFocus(D, page);
      D.h.root.classList.remove('mkc-busy');
      D.h.reveal(D.alert);
      return;
    }
    if (r.reason === 'busy' && dateRunning[D.subId] > 0) {
      /* r8 review: an earlier date change of this page for this order is still running (started before the pop-up was
         closed and opened again): it may still land, so nothing claims "Nothing was changed"; Check again only reads */
      return cdUnknownView(D, null);
    }
    if (r.reason === 'out_of_range') {
      /* the day changed under the pop-up (midnight passed): the range is worked out again */
      var e2 = M.nextDateEligible(D.sub, (st && st.model && st.model.raw.site) || (up.raw && up.raw.site) || {});
      if (e2 && e2.ok) D.range = e2.range;
      D.phase = 'refused'; D.pick = inRange(D, date) ? date : null;
      D.alert = cdAlert('error', 'That date isn\'t available for this order.', 'Please pick another date.');
      return cdDraw(D, { reveal: 'alert' });
    }
    D.phase = 'refused';
    if (r.reason === 'refused' && cur === from) {
      D.alert = cdAlert('error', 'We couldn\'t move your order.', 'It\'s still on ' + nbsp(fmtDay(from)) + '. Please try again, or pick another date.');
    } else if (r.outcome === 'none' || !r.sent) {
      D.alert = cdAlert('error', 'We couldn\'t move your order.', 'Nothing was changed. Please try again.');
    } else {
      D.alert = cdAlert('error', 'We couldn\'t move your order.', 'Please try again, or pick another date.');
    }
    cdDraw(D, { reveal: 'alert' });
  }

  /* fresh home reads (the core dropped its cache after the write) until our data shows `day` for the subscription;
     -> {raw, model} | {raw, model: null} | null */
  function dateRead(subId, day, tries) {
    var k = 0, limit = tries || DATE_REFRESH_TRIES;
    var once = function () {
      return M.storefrontUserId().then(function (uid) { return uid ? rawFor(uid, true) : null; }).then(function (raw) {
        if (!raw) return null;
        var s = subById(raw, subId), tz = validTz(obj(raw.site) && raw.site.ianaTimezone);
        return { raw: raw, shows: !!s && !!day && orderYmd(s.nextBillingDate, tz) === day };
      }, function () { return null; });
    };
    return (function next() {
      return once().then(function (res) {
        if ((res && res.shows) || ++k >= limit || !day) return res;
        return new Promise(function (r) { setTimeout(r, DATE_REFRESH_GAP_MS); }).then(next);
      });
    })();
  }
  /* put a fresh read on the home screen (and on Upcoming orders when it is open); false = could not */
  function dateApply(raw) {
    var done = false;
    if (raw && st && status === 'ready' && st.model) {
      var nm = buildModel(raw, null);
      if (nm) {
        nm.since = st.model.since; nm.sinceZone = st.model.sinceZone;
        nm.combineDone = st.model.combineDone; nm.combineRes = st.model.combineRes;
        if (st.arrives && typeof st.arrives.days === 'number') st.arrives = arrivesFor(st.arrives.days, nm);
        /* another subscription is now the next order: its own suggestions (the old ones excluded the old order) */
        var same = nm.main.id === st.model.main.id, mine = st;
        st.model = nm;
        if (!same) {
          st.picks = null;
          loadPicks(nm).then(function (picks) { if (st === mine && st.model === nm && picks && picks.length) { st.picks = picks; bump(); } }, function () { /* no card */ });
        }
        bump();
        done = true;
      }
    }
    if (raw && up.state !== 'closed' && up.state !== 'loading') {
      up.raw = raw;
      var um = upcomingModel(raw);
      up.model = um;
      up.state = um.rows.length ? 'list' : 'empty';
      drawUpcoming();
      done = true;
    }
    return done;
  }
  /* the order changed elsewhere (or Skio stored another day): read again, so the card and the pop-up follow it */
  function dateRefresh(D) {
    dateRead(D.subId, D.cur, 2).then(function (res) {
      if (!res || !res.raw) return;
      var s = subById(res.raw, D.subId);
      if (s && dt === D && res.shows) D.sub = s;
      dateApply(res.raw);
    });
  }
  /* success: the core saw the picked day in Skio's data. The button keeps "Moving..." until our fresh read is in, then
     the pop-up closes, the home (and Upcoming) are drawn from that read and the confirmation takes focus */
  function dateSaved(D, r, date, from) {
    var to = r.date || date;
    delete dateHolds[D.subId];
    var wait = new Promise(function (res) { setTimeout(function () { res(null); }, DATE_WAIT_MS); });
    return Promise.race([dateRead(D.subId, to), wait]).then(function (res) {
      var s = res && res.raw ? subById(res.raw, D.subId) : null;
      var tz = res && res.raw ? validTz(obj(res.raw.site) && res.raw.site.ianaTimezone) : D.tz;
      var after = s && res.shows ? dateAfter(s, to, tz) : dateAfter(D.sub, to, D.tz);
      dateNote = { kind: r.via === 'already' ? 'already' : 'done', subId: D.subId, to: to, was: from, names: lineNames(D.lines), after: after };
      if (r.via !== 'already') dateMoved[D.subId] = { from: from, to: to };
      D.phase = 'done';
      if (D.h.isOpen()) { D.h.busy(false); D.h.close('saved', { returnFocus: false }); }
      var shown = res && res.shows ? dateApply(res.raw) : false;
      if (!shown) {
        /* our data could not be refreshed: start over (fails closed to Skio's list); the confirmation shows once the
           card has the new day */
        M.invalidate('skio');
        if (st && status === 'ready') startHome();
        if (up.state !== 'closed') loadUpcoming(up.run);
      }
      dateFocusNote(D.where);
    });
  }
  /* the confirmation takes focus (role=status announces it) once it is on the page */
  function dateFocusNote(where) {
    var t0 = Date.now();
    (function look() {
      var n2 = document.getElementById(where === 'upcoming' && up.state !== 'closed' ? 'mkc-done-up' : 'mkc-done');
      if (n2) { try { n2.focus({ preventScroll: false }); } catch (e) { n2.focus(); } return; }
      if (Date.now() - t0 < 10000 && dateNote) setTimeout(look, 150);
    })();
  }
  /* "Check again": a read only (MKPortal.nextOrderDate), never a write */
  function dateCheck(D, btn) {
    if (D.checking) return;
    D.checking = true;
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-disabled', 'true');
    M.nextOrderDate(D.subId).then(function (res) {
      D.checking = false;
      if (D.closed || !D.h.isOpen()) return;
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('aria-disabled');
      if (res && res.date === D.pick) {
        D.h.busy(true);
        return dateSaved(D, { ok: true, date: res.date, via: 'reread' }, D.pick, D.cur);
      }
      if (res && res.date && res.date !== D.cur) {
        delete dateHolds[D.subId];
        D.cur = res.date; D.pick = null; D.phase = 'choose'; setView(D, res.date);
        D.alert = cdAlert('info', 'Your order now shows ' + nbsp(fmtDay(res.date)) + '.', 'Pick a new date if you still want to move it.');
        cdDraw(D, { reveal: 'alert' });
        dateRefresh(D);
        return;
      }
      M.text(D.alert.lastChild, '');
      D.alert.lastChild.appendChild(el('b', null, 'We\'re still checking.'));
      D.alert.lastChild.appendChild(document.createTextNode(res ? ' Your order still shows ' + nbsp(fmtDay(res.date)) + '. Check again in a moment.'
        : ' We couldn\'t look just now. Check again in a moment.'));
      D.h.reveal(D.alert);
    }, function () { D.checking = false; });
  }
  /* closed with an unclear outcome: the card keeps the last read's day with a "checking" line; read-only looks settle
     it (the new day: the confirmation; still the old day after the hold: the line goes; another day: the card follows) */
  function datePending(D) {
    var note = dateNote = { kind: 'pending', subId: D.subId, to: D.pick, was: D.cur, names: lineNames(D.lines), after: null, where: D.where };
    if (st && status === 'ready') bump();
    DATE_SETTLE_MS.forEach(function (ms, i) {
      setTimeout(function () {
        if (dateNote !== note) return;
        M.nextOrderDate(note.subId).then(function (res) {
          if (dateNote !== note || !res || !res.date) return;
          if (res.date === note.to) {
            delete dateHolds[note.subId];
            dateMoved[note.subId] = { from: note.was, to: note.to };
            dateRead(note.subId, note.to).then(function (fr) {
              if (dateNote !== note) return;
              var s = fr && fr.raw ? subById(fr.raw, note.subId) : null;
              var tz = fr && fr.raw ? validTz(obj(fr.raw.site) && fr.raw.site.ianaTimezone) : null;
              dateNote = { kind: 'done', subId: note.subId, to: note.to, was: note.was, names: note.names, after: s && tz ? dateAfter(s, note.to, tz) : null };
              if (!(fr && fr.shows && dateApply(fr.raw))) { M.invalidate('skio'); if (st && status === 'ready') startHome(); }
            });
          } else if (res.date !== note.was) {
            dateNote = null;
            dateRead(note.subId, res.date, 1).then(function (fr) { if (fr && fr.raw) dateApply(fr.raw); else bump(); });
          } else if (i === DATE_SETTLE_MS.length - 1 || !dateHeld(note.subId)) {
            dateNote = null;
            bump();
          }
        });
      }, ms);
    });
  }
  /* the confirmation after a move ("Moved to Fri, Nov 6." / the products / "Was Fri, Oct 30 . Next after that: ..."),
     or the "checking" line; null when the data on screen does not show what it would say */
  function dateNoteFor(m, where) {
    var nt = dateNote;
    if (!nt || !m) return null;
    var s = subById(m.raw || m, nt.subId), tz = validTz(obj((m.raw || m).site) && (m.raw || m).site.ianaTimezone);
    var day = s ? orderYmd(s.nextBillingDate, tz) : null;
    if (nt.kind === 'pending') {
      if (where !== 'home' || !day || day !== nt.was || !m.main || m.main.id !== nt.subId) return null;
      return el('div', { 'class': 'mkc-pending', id: 'mkc-pending', role: 'status' }, el('span', { 'class': 'mkc-pend-dot', 'aria-hidden': 'true' }),
        el('span', null, el('b', null, 'Checking your date change to ' + nbsp(fmtDay(nt.to)) + '\u2026'), ' This card shows ' + nbsp(fmtDay(nt.was)) + ' until we can confirm it.'));
    }
    if (!day || day !== nt.to) return null;
    var x = el('button', { type: 'button', 'class': 'mkc-done-x', 'aria-label': 'Dismiss' }, cdIcon('x'));
    x.addEventListener('click', function () {
      dateNote = null;
      if (where === 'upcoming') drawUpcoming(); else bump();
      var root = document.getElementById(where === 'upcoming' ? 'mk-upcoming' : 'mk-home');
      var f = root && (root.querySelector('[data-mk-action="change-date"][data-mk-sub="' + nt.subId + '"]') || root.querySelector('h1, h2'));
      if (f) { if (!f.hasAttribute('tabindex') && !/^(A|BUTTON)$/.test(f.tagName)) f.setAttribute('tabindex', '-1'); try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
    });
    var lines = nt.kind === 'already'
      ? [el('b', null, 'Your order is already on ' + nbsp(fmtDay(nt.to)) + '.'), el('span', { 'class': 'mkc-done-what' }, nt.names),
        el('span', { 'class': 'mkc-done-when' }, 'Nothing needed changing.')]
      : [el('b', null, 'Moved to ' + nbsp(fmtDay(nt.to)) + '.'), el('span', { 'class': 'mkc-done-what' }, nt.names),
        el('span', { 'class': 'mkc-done-when' }, 'Was ' + nbsp(fmtDay(nt.was)) + (nt.after ? NB + DOT.slice(1) + 'Next after that: ' + nbsp(fmtDay(nt.after)) : ''))];
    return el('div', { 'class': 'mkc-done', id: where === 'upcoming' ? 'mkc-done-up' : 'mkc-done', role: 'status', tabindex: '-1' },
      el('span', { 'class': 'mkc-done-ico', 'aria-hidden': 'true' }, cdIcon('check')), el('span', { 'class': 'mkc-done-main' }, lines), x);
  }
  /* the delivery data arrived while the pop-up is open: "arrives about" joins the charge line */
  function dateArrives() {
    var D = dt;
    if (!D || !D.h.isOpen() || !D.pick || D.phase !== 'choose' && D.phase !== 'refused') return;
    var f = document.getElementById('mkc-fine'), nf = cdFine(D);
    if (f && f.parentNode) f.parentNode.replaceChild(nf, f);
  }
  /* for tests: the gate for one subscription of an mkHome answer ({ok, day, min, max} or {why}) and the pop-up state */
  function dateGateFor(raw, subId, opts) {
    try {
      var g = dateGate(subById(raw, subId), obj(raw && raw.site) || {}, opts);
      return g.ok ? { ok: true, day: g.el.day, min: g.el.range.min, max: g.el.range.max, lines: g.lines.length } : { ok: false, why: g.why };
    } catch (e) { return { ok: false, why: 'error: ' + (e && e.message) }; }
  }

  /* ------------------------------------------------------------------ */
  /* actions: hand off to Skio's own UI                                    */
  /* ------------------------------------------------------------------ */
  var ACTIONS = {
    'order-now': { names: ['generic-action-button-order-now'], menu: ['get now', 'get it now', 'order now'] },
    'skip': { names: ['generic-action-button-skip'], menu: ['skip', 'skip next order', 'skip order'] },
    'change-date': { names: ['subscription-header-next-date-button'], menu: ['next order date', 'change date'] },
    'frequency': { names: ['subscription-header-edit-frequency-button'], menu: ['edit frequency'] },
    'add-product': { names: ['products-card-add-product-button'], scrollTo: 'products-card' },
    'address': { names: ['shipping-card-edit-button'], scrollTo: 'shipping-card' },
    'card': { names: ['billing-card-edit-button'], scrollTo: 'billing-card' },
    'edit-products': { scrollTo: 'products-card', flash: true },
    'upsell': { upsell: true }
  };

  function writeIntent(intent) {
    try { window.sessionStorage.setItem(INTENT_KEY, JSON.stringify(intent)); return true; } catch (e) { return false; }
  }
  function takeIntent(page, subId) {
    var raw = null;
    try { raw = window.sessionStorage.getItem(INTENT_KEY); } catch (e) { return null; }
    if (!raw) return null;
    var it = null;
    try { it = JSON.parse(raw); } catch (e) { it = null; }
    var age = it && typeof it.t === 'number' ? Date.now() - it.t : Infinity;
    var mine = it && it.v === 1 && it.page === page && (page !== 'subscription' || it.sub === subId);
    if (mine || !it || !(age >= 0 && age < INTENT_MAX_AGE_MS) || (it.page === page)) {
      try { window.sessionStorage.removeItem(INTENT_KEY); } catch (e) { /* ignore */ }
    }
    return mine && age >= 0 && age < INTENT_MAX_AGE_MS ? it : null;
  }

  function clickable(x) {
    return !!x && x.isConnected && !x.disabled && x.getAttribute('aria-disabled') !== 'true';
  }
  function modalOpen() { return !!M.q('[data-skio-name="skio-modal-dialog"]'); }
  function flash(x) {
    if (!x) return;
    try {
      x.setAttribute('data-mk-flash', '');
      setTimeout(function () { try { x.removeAttribute('data-mk-flash'); } catch (e) { /* ignore */ } }, 2600);
    } catch (e) { /* ignore */ }
  }
  function scrollTo(x, block) {
    try { x.scrollIntoView({ block: block || 'center', behavior: 'smooth' }); } catch (e) { try { x.scrollIntoView(); } catch (e2) { /* ignore */ } }
  }
  function norm(t) { return str(t).replace(/\s+/g, ' ').trim().toLowerCase(); }
  function viaMenu(texts) {
    var trigger = M.byName('more-actions-dropdown-trigger-button');
    if (!clickable(trigger) || modalOpen()) return Promise.resolve(false);
    trigger.click();
    return M.waitFor('[data-skio-name="more-actions-dropdown-item"]', { timeout: 2500 }).then(function () {
      var items = M.qa('[data-skio-name="more-actions-dropdown-item"]');
      var hit = items.filter(function (i) { return texts.indexOf(norm(i.textContent)) >= 0; })[0];
      if (hit && clickable(hit)) { hit.click(); return true; }
      var menu = M.byName('more-actions-dropdown-menu') || document.activeElement;
      try { if (menu) menu.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', code: 'Escape', bubbles: true })); } catch (e) { /* ignore */ }
      return false;
    });
  }
  /* runs on the subscription page: press Skio's own control ONCE, never confirm */
  function perform(it) {
    var spec = ACTIONS[it.action];
    if (!spec) return Promise.resolve(false);
    return M.waitFor('[data-skio-name="products-card"]', { timeout: 15000 }).then(function (pc) {
      if (!pc || modalOpen()) return false;
      if (spec.upsell) return focusUpsell(norm(it.title));
      if (!spec.names) {
        var t2 = M.byName(spec.scrollTo) || pc;
        scrollTo(t2, 'start');
        if (spec.flash) flash(t2);
        return true;
      }
      var sel = spec.names.map(function (x) { return '[data-skio-name="' + x + '"]'; }).join(', ');
      return M.waitFor(sel, { timeout: 2500 }).then(function (b) {
        if (modalOpen()) return false;
        if (clickable(b)) { scrollTo(b); b.click(); return true; }
        if (spec.menu) return viaMenu(spec.menu);
        var t3 = spec.scrollTo ? M.byName(spec.scrollTo) : null;
        if (t3) scrollTo(t3, 'start');
        return false;
      });
    }).then(null, function () { return false; });
  }
  /* "Add" (Add to your <date> order, F-1 batch 2): land on that product in Skio's "You might also like" and
     highlight it briefly. Read-only: nothing in the card is pressed (never Add or its menu, which add at once).
     Two things only move Skio's own carousel: a click on the product's slide itself (Skio's carousel selects the
     slide a customer clicks; a product on another slide is otherwise hidden by the carousel) and focus on the
     product's name (focus inside the carousel pauses Skio's 5 s autoplay, so the product stays in view while the
     customer looks; it runs again when focus leaves). Waits up to UPSELL_WAIT_MS for the product to be shown in
     the visible copy of the strip (desktop or phone); not found (or it cannot be brought into the strip's view):
     nothing moves, the page stays at the top. After the first scroll it follows the card while content above it
     settles (the delivery timeline mounts later) and stops at once when the customer scrolls, clicks or types.
     prefers-reduced-motion: no smooth scrolling. */
  var UPSELL_WAIT_MS = 6000;       /* wait this long for the product's card */
  var UPSELL_SLIDE_MS = 1500;      /* and this long for the carousel to show its slide */
  var UPSELL_SETTLE_MS = 2500;     /* keep following it until this long after the last correction ... */
  var UPSELL_FOLLOW_MS = 8000;     /* ... but never longer than this after the first scroll */
  var UPSELL_FLASH_MS = 2600;
  var UPSELL_DRIFT_PX = 24;
  var STRIPS = '[data-skio-name="subscription-details-upsell-container"], [data-skio-name="products-card-suggestions-mobile-container"]';
  function motionOk() {
    try { return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return true; }
  }
  function upsellCard(title) {
    return M.qa('[data-skio-name="upsell-product"]').filter(function (c) {
      var strip = c.closest(STRIPS), h = M.byName('product-name', c);
      return !!strip && strip.getClientRects().length > 0 && c.getClientRects().length > 0 && !!h && norm(h.textContent) === title;
    })[0] || null;
  }
  /* the card lies inside the carousel's visible window (a product on another slide is clipped away) */
  function inStrip(card) {
    var content = card.closest('[data-skio-name="upsell-card-carousel-content"]'), win = content && content.parentElement;
    if (!win) return true;
    var a = card.getBoundingClientRect(), b = win.getBoundingClientRect();
    return a.width > 0 && a.left >= b.left - 2 && a.right <= b.right + 2;
  }
  /* -> a function that gives the focus back (fail-closed path: nothing may stay moved) */
  function holdFocus(card) {
    var h = M.byName('product-name', card), added = false;
    if (!h) return function () {};
    try {
      if (!h.hasAttribute('tabindex')) {
        added = true;
        h.setAttribute('tabindex', '-1');
        h.addEventListener('blur', function once() { h.removeEventListener('blur', once); try { h.removeAttribute('tabindex'); } catch (e) { /* ignore */ } });
      }
      h.focus({ preventScroll: true });
      /* a window without focus (tab in the background while the page loads) moves focus but fires no focus
         event, and Skio's carousel pauses on that event: announce it the way the browser would */
      if (document.activeElement === h && typeof document.hasFocus === 'function' && !document.hasFocus()) {
        h.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
      }
    } catch (e) { /* ignore */ }
    return function release() {
      try {
        if (document.activeElement === h) {
          h.blur();
          /* the same announcement in a window without focus: Skio's autoplay runs again */
          if (typeof document.hasFocus === 'function' && !document.hasFocus()) h.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
        }
        if (added) h.removeAttribute('tabindex');
      } catch (e) { /* ignore */ }
    };
  }
  function selectSlide(card) {
    var item = card.closest('[data-skio-name="upsell-card-carousel-item"]');
    try { if (item) item.click(); } catch (e) { /* ignore */ }
  }
  function focusUpsell(title) {
    var r0 = M.route(), t0 = Date.now(), used = false, flashed = null, flashTimer = null;
    var EV = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    function onUse() { used = true; }
    EV.forEach(function (t) { try { window.addEventListener(t, onUse, { capture: true, passive: true }); } catch (e) { /* ignore */ } });
    function unlisten() { EV.forEach(function (t) { try { window.removeEventListener(t, onUse, { capture: true }); } catch (e) { /* ignore */ } }); }
    function here() { var r = M.route(); return r.seq === r0.seq && r.page === 'subscription'; }
    function docTop(n) { return n.getBoundingClientRect().top + (window.pageYOffset || 0); }
    function scrollToCard(card) {
      var rc = card.getBoundingClientRect(), top = rc.top + (window.pageYOffset || 0);
      var y = Math.max(0, Math.round(top - Math.max(16, (window.innerHeight - rc.height) / 2)));
      try { window.scrollTo({ top: y, behavior: motionOk() ? 'smooth' : 'auto' }); } catch (e) { window.scrollTo(0, y); }
      return top;
    }
    function highlight(card) {
      if (flashed && flashed !== card) { try { flashed.removeAttribute('data-mk-flash'); } catch (e) { /* ignore */ } }
      flashed = card;
      try { card.setAttribute('data-mk-flash', ''); } catch (e) { /* ignore */ }
      if (flashTimer) clearTimeout(flashTimer);
      flashTimer = setTimeout(function () { try { card.removeAttribute('data-mk-flash'); } catch (e) { /* ignore */ } }, UPSELL_FLASH_MS);
    }
    return new Promise(function (resolve) {
      function done(v) { unlisten(); resolve(v); }
      function follow(top, tFirst) {
        var tFix = tFirst, rebring = 2;
        (function watch() {
          try {
            var t = Date.now();
            if (used || !here() || t - tFix >= UPSELL_SETTLE_MS || t - tFirst >= UPSELL_FOLLOW_MS) return unlisten();
            var card = upsellCard(title);     /* React may have re-created it */
            /* the carousel moved on before its pause took hold: bring the slide back (at most twice) */
            if (card && !inStrip(card) && rebring > 0) { rebring--; holdFocus(card); selectSlide(card); tFix = t; }
            if (card) {
              var now = docTop(card);
              if (Math.abs(now - top) > UPSELL_DRIFT_PX) { top = scrollToCard(card); highlight(card); tFix = t; }
              else if (card !== flashed && flashed && flashed.hasAttribute('data-mk-flash')) highlight(card);
            }
            setTimeout(watch, 120);
          } catch (e) { unlisten(); }
        })();
      }
      function show(card) {
        var top = scrollToCard(card);
        highlight(card);
        resolve(true);
        follow(top, Date.now());
      }
      function bring(card) {
        var release = holdFocus(card);
        if (!inStrip(card)) selectSlide(card);
        var t1 = Date.now();
        /* the slide did not come into view (or the customer took over): give the focus back, so nothing stays
           moved (no paused autoplay, no focus on an off-screen name for the next Tab) */
        function fail() { release(); done(false); }
        (function slide() {
          try {
            if (used || !here()) return fail();
            var c = upsellCard(title);
            if (c && inStrip(c)) return show(c);
            if (Date.now() - t1 >= UPSELL_SLIDE_MS) return fail();
            setTimeout(slide, 80);
          } catch (e) { fail(); }
        })();
      }
      (function find() {
        try {
          if (used || !here()) return done(false);
          var card = upsellCard(title);
          if (card) return bring(card);
          if (Date.now() - t0 >= UPSELL_WAIT_MS) return done(false);
          setTimeout(find, 120);
        } catch (e) { done(false); }
      })();
    });
  }

  var performing = false;
  function consumeIntent(r) {
    if (!r || (r.page !== 'subscription' && r.page !== 'loyalty')) return;
    var it = takeIntent(r.page, r.subscriptionId);
    if (!it || performing) return;
    performing = true;
    var done = function () { performing = false; };
    if (r.page === 'loyalty') {
      M.waitFor('[data-skio-name="redeem-card"]', { timeout: 15000 }).then(function (x) {
        if (x && it.action === 'redeem') scrollTo(x, 'start');
      }).then(done, done);
      return;
    }
    perform(it).then(done, done);
  }

  function handoff(subId, act, extra) {
    try {
      if (!M.on() || !validId(subId) || !ACTIONS[act]) return false;
      var it = { v: 1, page: 'subscription', sub: subId, action: act, t: Date.now() };
      if (extra && extra.title) it.title = str(extra.title).slice(0, 200);
      var r = M.route();
      if (r.page === 'subscription' && r.subscriptionId === subId) { perform(it); return true; }
      writeIntent(it);
      api.navigate(subUrl(subId));
      return true;
    } catch (e) { return false; }
  }
  /* client-side navigation through Skio's own controls when one exists (no reload),
     else a full page load */
  function spaGo(nativeName, path) {
    var x = nativeName ? M.byName(nativeName) : null;
    if (!x) { api.navigate(path); return; }
    var target = path.split('?')[0];
    try { x.click(); } catch (e) { api.navigate(path); return; }
    setTimeout(function () { if (location.pathname.replace(/\/+$/, '') !== target) api.navigate(path); }, 1500);
  }
  function onPanelClick(ev) {
    try {
      var a = ev.target && ev.target.closest ? ev.target.closest('[data-mk-action], [data-mk-nav]') : null;
      if (!a) return;
      if (ev.defaultPrevented || ev.button > 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;  /* new tab etc.: plain link */
      var act = a.getAttribute('data-mk-action'), nav = a.getAttribute('data-mk-nav');
      if (act) {
        ev.preventDefault();
        /* batch 3: the Add pop-up when it can be offered; otherwise (or on any error) the hand-off below */
        if (act === 'upsell' && a.hasAttribute('data-mk-pick')) {
          var opened = false;
          try { opened = openAdd(a); } catch (e2) { M.log('home: Add pop-up error', e2 && e2.message); opened = false; }
          if (opened) return;
        }
        /* r8: the date pop-up when it can be offered; otherwise (or on any error) the hand-off below, unchanged */
        if (act === 'change-date') {
          var dOpened = false;
          try { dOpened = openDate(a); } catch (e3) { M.log('home: date pop-up error', e3 && e3.message); dOpened = false; }
          if (dOpened) return;
        }
        var t = a.getAttribute('data-mk-title');
        handoff(a.getAttribute('data-mk-sub'), act, t ? { title: t } : null);
        return;
      }
      if (nav === 'native') {
        ev.preventDefault();
        nativeMode = true;
        startHome();
        var h = M.byName('subscriptions-active-header');
        if (h) scrollTo(h, 'start');
        return;
      }
      if (nav === 'overview') {
        ev.preventDefault();
        nativeMode = false;
        if (wantsNative()) { api.navigate(base() + '/subscriptions'); return; }
        startHome();
        return;
      }
      if (nav === 'upcoming') {
        /* same as the menu's "Upcoming orders": a #upcoming entry on this page (no reload, Back closes it) */
        ev.preventDefault();
        openUpcoming();
        return;
      }
      if (nav === 'catalog') {
        /* r10: "See all products", same as the menu's "Add products"; if the screen cannot open, r9.1's hand-off */
        ev.preventDefault();
        if (!openCatalog() && st && st.model) handoff(st.model.main.id, 'add-product');
        return;
      }
      if (nav === 'combine') {
        /* full page load to the NEXT ORDER subscription; the core scrolls to the Combine card there */
        ev.preventDefault();
        var href = a.getAttribute('href');
        if (href) api.navigate(href);
        return;
      }
      if (nav === 'redeem' || nav === 'loyalty') {
        ev.preventDefault();
        if (nav === 'redeem') writeIntent({ v: 1, page: 'loyalty', action: 'redeem', t: Date.now() });
        spaGo('loyalty-link-banner', base() + '/loyalty');
        return;
      }
      if (nav === 'orders') {
        ev.preventDefault();
        spaGo('navbar-orders-button', base() + '/orders');
      }
    } catch (e) { /* the plain link still works */ }
  }

  /* ------------------------------------------------------------------ */
  /* Upcoming orders screen: lifecycle (round 2 spec BC 5.1-5.6)           */
  /* Opened only by #upcoming on the subscriptions page. Mounted first in  */
  /* Skio's authed-layout; html.mk-upcoming-open (CSS) hides the layout's  */
  /* other children, and only after the mount succeeded. Skio's nodes are  */
  /* never removed or moved; the home panel stays mounted underneath.      */
  /* Any error: the class goes first, then our node, Skio's page is back.  */
  /* ------------------------------------------------------------------ */
  var up = { state: 'closed', run: 0, pending: false, openedHere: false, opener: null, model: null, raw: null, observer: null, timer: null, failedAt: null };
  function upcomingOn() { return !!DECISION_UPCOMING.enabled && !(CFG.modules && CFG.modules.upcoming === false); }
  function wantUpcoming() { return upcomingOn() && M.on() && location.hash === UPCOMING_HASH && M.route().page === 'subscriptions'; }
  function setUpClass(on) { try { document.documentElement.classList.toggle('mk-upcoming-open', !!on); } catch (e) { /* ignore */ } }
  function syncUpcoming() {
    if (wantUpcoming()) {
      /* after a failure the stale #upcoming stays harmless: no new attempt until the address changes */
      if (up.failedAt === location.href) return;
      if (up.state === 'closed' && !up.pending) showUpcoming();
    } else {
      up.failedAt = null;
      if (up.state !== 'closed' || up.pending) teardownUpcoming('hash');
    }
  }
  function upFail(why) {
    M.log('home: upcoming: showing the page underneath (' + why + ')');
    teardownUpcoming('error');
    up.failedAt = location.href;
  }
  function mountUpcoming() {
    var layout = M.q(LAYOUT_SEL);
    if (!layout) return null;
    var node = M.mount({
      id: 'mk-upcoming', anchor: layout, where: 'prepend', module: 'home', sig: 'up:' + up.run,
      build: function () { var n2 = upShell(); upFill(n2); n2.addEventListener('click', onUpClick); return n2; }
    });
    if (!node) return null;
    setUpClass(true);
    M.screen.set('upcoming');
    return node;
  }
  /* (re)draw the body; re-mounts when React dropped or moved the screen */
  function drawUpcoming() {
    try {
      if (up.state === 'closed') return;
      var layout = M.q(LAYOUT_SEL), node = document.getElementById('mk-upcoming');
      if (node && layout && node.parentNode === layout && layout.firstElementChild === node) { upFill(node); return; }
      if (!mountUpcoming()) upFail('mount');
    } catch (e) { upFail('render error: ' + (e && e.message)); }
  }
  function focusUpTitle() {
    try { window.scrollTo(0, 0); } catch (e) { /* ignore */ }
    var h = document.getElementById('mku-title');
    try { if (h) h.focus({ preventScroll: true }); } catch (e) { try { h.focus(); } catch (e2) { /* ignore */ } }
  }
  function showUpcoming() {
    var run = ++up.run;
    up.pending = true;
    var a = document.activeElement;
    up.opener = a && a !== document.body && a !== document.documentElement ? a : null;
    M.waitFor('[data-skio-name="authed-layout"]', { timeout: UPCOMING_WAIT_MS }).then(function (layout) {
      if (run !== up.run) return;
      up.pending = false;
      if (!layout || !wantUpcoming()) return;
      up.state = 'loading'; up.model = null;
      try {
        if (!mountUpcoming()) return upFail('mount');
        focusUpTitle();
        watchUpcoming();
      } catch (e) { return upFail('open error: ' + (e && e.message)); }
      loadUpcoming(run);
    }, function () { if (run === up.run) { up.pending = false; } });
  }
  function loadUpcoming(run) {
    loadRaw().then(function (raw) {
      if (run !== up.run || up.state === 'closed') return;
      if (!raw) { up.state = 'error'; up.model = null; up.raw = null; drawUpcoming(); return; }
      var m = upcomingModel(raw);
      up.raw = raw;           /* r8: the date pop-up takes its subscription from here, by id */
      up.model = m;
      up.state = m.rows.length ? 'list' : 'empty';
      drawUpcoming();
    }).then(null, function (e) {
      if (run !== up.run || up.state === 'closed') return;
      M.log('home: upcoming: load failed', e && e.message);
      up.state = 'error'; up.model = null; drawUpcoming();
    });
  }
  function watchUpcoming() {
    if (up.observer) return;
    var root = document.getElementById('skio-root');
    if (!root || typeof MutationObserver !== 'function') return;
    up.observer = new MutationObserver(function () {
      if (up.timer) return;
      up.timer = setTimeout(function () {
        up.timer = null;
        if (up.state === 'closed') return;
        var layout = M.q(LAYOUT_SEL), node = document.getElementById('mk-upcoming');
        if (!layout) return;       /* the page is changing; the route watcher decides */
        if (!node || node.parentNode !== layout || layout.firstElementChild !== node) drawUpcoming();
      }, 60);
    });
    up.observer.observe(root, { childList: true, subtree: true });
  }
  function restoreFocus(opener) {
    try {
      var t = opener && opener.isConnected && opener.getClientRects().length ? opener : document.querySelector('#mk-home .mkh-hello');
      if (!t) return;
      if (!t.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(t.tagName)) t.setAttribute('tabindex', '-1');
      t.focus({ preventScroll: false });
    } catch (e) { /* ignore */ }
  }
  /* close: the class first (Skio's page or the home panel shows at once), then our node and the screen
     value (only while it is still ours) */
  function teardownUpcoming(why) {
    var wasOpen = up.state !== 'closed', opener = up.opener;
    up.run++;
    up.pending = false; up.state = 'closed'; up.model = null; up.raw = null; up.opener = null;
    if (up.observer) { try { up.observer.disconnect(); } catch (e) { /* ignore */ } up.observer = null; }
    if (up.timer) { clearTimeout(up.timer); up.timer = null; }
    setUpClass(false);
    M.unmount('mk-upcoming');
    M.screen.clear('upcoming');
    /* closed from the menu: the menu keeps focus on the item that was chosen */
    var inMenu = false;
    try { var ae = document.activeElement; inMenu = !!(ae && ae.closest && ae.closest('#mk-nav')); } catch (e) { /* ignore */ }
    if (wasOpen && why !== 'route' && !inMenu) restoreFocus(opener);
  }
  /* in-screen "Subscriptions", "See your subscriptions", the menu's "Subscriptions" */
  function closeUpcoming() {
    try {
      if (location.hash === UPCOMING_HASH) {
        if (up.openedHere && M.screen.ownEntry('upcoming')) {
          /* this page added the #upcoming entry: going back closes it (hashchange) and keeps history tidy */
          up.openedHere = false;
          window.history.back();
          return true;
        }
        M.screen.dropHash('upcoming');
      }
      teardownUpcoming('closed');
      return true;
    } catch (e) { teardownUpcoming('error'); return false; }
  }
  function onUpClick(ev) {
    try {
      var a = ev.target && ev.target.closest ? ev.target.closest('[data-mk-up], [data-mk-action]') : null;
      if (!a) return;
      if (ev.defaultPrevented || ev.button > 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;   /* new tab etc.: plain link */
      var what = a.getAttribute('data-mk-up');
      if (what === 'close') { ev.preventDefault(); closeUpcoming(); return; }
      if (what === 'retry') {
        ev.preventDefault();
        M.invalidate('skio');
        up.state = 'loading'; up.model = null;
        drawUpcoming();
        focusUpTitle();
        loadUpcoming(up.run);
        return;
      }
      onPanelClick(ev);          /* Skip / Change date: the same hand-off as the home panel */
    } catch (e) { /* the plain link still works */ }
  }
  /* open: a new #upcoming entry carrying Next's router state (MKPortal.screen.pushHash), so Back from
     another page shows this page again (round 2 review R2-R1); location.hash only if that fails. An
     explicit request is a new attempt even after a failed one. */
  function openUpcoming() {
    if (!upcomingOn() || M.route().page !== 'subscriptions') return false;
    up.failedAt = null;
    /* r10: one screen at a time: an open "Add products" screen is closed (its entry replaced) first */
    return openScreen('upcoming');
  }
  window.addEventListener('hashchange', function () {
    try {
      /* a plain hash change in this document (whatever the old hash was) added this entry */
      up.openedHere = location.hash === UPCOMING_HASH;
      cat.openedHere = location.hash === CAT_HASH;
      if (screenAfterBack()) return;
      syncScreens();
    } catch (x) { teardownUpcoming('error'); teardownCatalog('error'); }
  });
  window.addEventListener('popstate', function () {
    try { if (!screenAfterBack()) syncScreens(); } catch (x) { teardownUpcoming('error'); teardownCatalog('error'); }
  });

  /* ------------------------------------------------------------------ */
  /* "Add products" catalogue (r10, 1.3.0; approved design               */
  /* catalog-design/DESIGN-NOTES.md sections 3-11, Jim's 9 defaults of   */
  /* 2026-10-18). Read only: Skio's own picker query (mkCatalog) through */
  /* MKPortal.skioPages (the core refuses mutations, caches per customer */
  /* and shares requests in flight). The only write is the Add pop-up's  */
  /* (r9.1, MKPortal.addSubscriptionLine), unchanged. Mounted first in   */
  /* Skio's authed-layout like Upcoming orders; html.mk-catalog-open     */
  /* (CSS) hides the layout's other children only after the mount. Any   */
  /* error: the class goes first, then our node, Skio's page is back.    */
  /* ------------------------------------------------------------------ */
  var CAT_HASH = '#add-products';
  var CAT_WAIT_MS = 15000;            /* wait this long for Skio's layout before the screen gives up */
  var CAT_LIVE_MS = 400;              /* the search count is read out this long after the last key */
  var CAT_WARM_MIN_MS = 1000;         /* at most one read ahead a second */
  var CAT_DESC_CAP = 150;             /* the card's one line of description, at most this long */
  var CAT_ENT = { amp: '&', lt: '<', gt: '>', quot: '"', apos: '\'', nbsp: ' ' };
  var QL = '\u201C', QR = '\u201D', ELL = '\u2026';

  function catalogOn() {
    try {
      return !!DECISION_CATALOG.enabled && typeof M.catalogEnabled === 'function' && M.catalogEnabled() === true && typeof M.skioPages === 'function';
    } catch (e) { return false; }
  }

  /* ---- pure helpers ---- */
  /* Skio's Product.description as plain text (text nodes only; tags dropped, entities decoded, never parsed as HTML) */
  function plainText(v) {
    var s = str(v).replace(/<[^>]*>/g, ' ');
    s = s.replace(/&(#x[0-9a-f]{1,6}|#\d{1,7}|[a-z]{2,8});/gi, function (m0, e) {
      if (e.charAt(0) === '#') {
        var c = /^#x/i.test(e) ? parseInt(e.slice(2), 16) : parseInt(e.slice(1), 10);
        try { return c > 31 && c < 0x110000 ? String.fromCodePoint(c) : ' '; } catch (x) { return ' '; }
      }
      var k = e.toLowerCase();
      return Object.prototype.hasOwnProperty.call(CAT_ENT, k) ? CAT_ENT[k] : m0;
    });
    return s.replace(/\s+/g, ' ').replace(/\s+([,.:;!?])/g, '$1').trim();
  }
  /* the card's line: cut at the first sentence end or the first ':' (a list follows), whichever comes first; the
     2-line clamp (CSS) stays as a fallback */
  function shortDesc(t) {
    var m = /^([\s\S]{30,}?)([.!?:])(\s|$)/.exec(t);
    var s = m ? m[1] + (m[2] === ':' ? '.' : m[2]) : t;
    if (s.length > CAT_DESC_CAP) {
      s = s.slice(0, CAT_DESC_CAP);
      var k = s.lastIndexOf(' ');
      s = (k > 40 ? s.slice(0, k) : s).replace(/[,;:\s]+$/, '') + ELL;
    }
    return s;
  }
  function catWords(q) { return str(q).trim().toLowerCase().split(/\s+/).filter(Boolean).slice(0, 12); }
  /* "30-, 60- or 90-Day Supply", "1 Bag, 2 Bags or 3 Bags" (Skio's order) */
  function sizesText(titles) {
    var t = titles.filter(function (x) { return x && x !== 'Default Title'; });
    if (!t.length) return '';
    if (t.length === 1) return t[0];
    var days = t.map(function (x) { var m = /^(\d+)-Day Supply$/.exec(x); return m ? m[1] : null; });
    if (days.every(Boolean)) return days.slice(0, -1).join('-, ') + '- or ' + days[days.length - 1] + '-Day Supply';
    return t.slice(0, -1).join(', ') + ' or ' + t[t.length - 1];
  }
  /* the orders the catalogue adds to: r9.1 isOpen && !needsAttention, and not prepaid (Jim's decision 6) */
  function catEligible(s) { return !!obj(s) && validId(s.id) && isOpen(s) && !needsAttention(s) && !isPrepaidSub(s) && !s.PrepaidDeliveryPolicy; }
  function lineVid(l) { return str(l && (l.productVariantId || (l.ProductVariant && l.ProductVariant.id))); }
  function linePid(l) { var v = l && l.ProductVariant; return str(v && (v.productId || (v.Product && v.Product.id))); }
  /* Skio's picker fragment already leaves out deleted variants and the ones hidden on the edit-products page */
  function catVariants(p) {
    return arr(p && p.ProductVariants).filter(function (v) { return obj(v) && validId(str(v.id)) && !v.deletedAt && v.hideOnEditProduct !== true; });
  }
  function hasSubscribePlan(v) {
    return arr(v.SellingPlanGroupResources).some(function (r) {
      var g = obj(r) && obj(r.SellingPlanGroup);
      return !!g && g.name === SUBSCRIBE_GROUP && arr(g.SellingPlans).some(obj);
    });
  }
  /* Skio 23403.l: no tags set, or the customer has one of them */
  function catTagOk(p, tags) {
    var t = arr(p.showProductForCustomerTags).map(str).filter(Boolean);
    return !t.length || t.some(function (x) { return tags.indexOf(x) >= 0; });
  }
  function catPct(p) { var off = n(p.oneTimeUpsellPercentageOff); return off !== null && off > 0 && off < 1 ? off : 0; }
  function catByInterval(site) {
    var s = obj(site && site.settings);
    return !!(s && s.restrictProductsByInterval === true && !s.autoSplitOnIntervalMismatch);
  }
  /* Skio's offer rules for ONE product and ONE subscription (Skio 23403.y + 72586.N, r9.1 addOffer's prices), with the
     design's stricter rule: a size that has any line in that order is not offered (returned in inOrder, for the
     pop-up's disabled chip). ctx = {siteCurrency, byInterval}.
     -> null (nothing to add here) | {variants: [{id, title, image, regular, once, every}], inOrder: [{id, title}],
        handoff: null | 'box' | 'currency' | 'price' | 'names'} (handoff: Skio's own picker on that subscription's page) */
  function catOffer(p, sub, ctx) {
    if (!obj(p) || !obj(sub)) return null;
    ctx = ctx || {};
    var lines = arr(sub.SubscriptionLines).filter(obj);
    /* Skio 23403.y: "one add per product" on and a just-this-order line of the product here: nothing, every order included */
    if (p.limitOneTimeUpsellQuantity && lines.some(function (l) { return isOneTime(l) && sameId(linePid(l), p.id); })) return null;
    var vs = catVariants(p);
    if (p.DynamicBox || vs.some(function (v) { return obj(v.ClassicBoxV2) && v.ClassicBoxV2.id; })) return { variants: [], inOrder: [], handoff: 'box' };
    var cur = ctx.siteCurrency;
    if (!cur || sub.currencyCode !== cur) return { variants: [], inOrder: [], handoff: 'currency' };
    var onceOk = p.canUpsell === true && !p.hideOn1TimeUpsells, pct = catPct(p);
    var everyOk = !ctx.byInterval && !isPrepaidSub(sub) && !sub.PrepaidDeliveryPolicy && !!schedule(sub.BillingPolicy);
    var out = [], inOrder = [], unpriced = false;
    vs.forEach(function (v) {
      if (v.outOfStockAt) return;                       /* sold-out sizes are never offered */
      var title = v.title && v.title !== 'Default Title' ? str(v.title).trim().slice(0, 80) : '';
      if (lines.some(function (l) { return sameId(lineVid(l), v.id); })) { inOrder.push({ id: str(v.id), title: title }); return; }
      var reg = regularPrice(v, sub, cur), bp = basePrice(v, sub, cur);
      if (reg === null || bp === null) { unpriced = true; return; }
      var once = onceOk && v.enableOneTimeUpsell === true ? round2(bp * (100 - pct * 100) / 100) : null;
      var every = null;
      if (everyOk && closestPlan(v, sub)) {
        every = recurringPrice(v, sub, cur);
        if (every === null) { unpriced = true; return; }    /* a later-cycle or fixed price we cannot work out */
      }
      if (once === null && every === null) return;
      out.push({ id: str(v.id), title: title, image: v.image || p.imageSrc || null, regular: reg, once: once, every: every });
    });
    if (unpriced) return { variants: [], inOrder: inOrder, handoff: 'price' };
    if (!out.length) return null;
    if (out.length > 1 && out.some(function (v) { return !v.title; })) return { variants: [], inOrder: inOrder, handoff: 'names' };
    return { variants: out, inOrder: inOrder, handoff: null };
  }
  /* the customer's tier gives a DISCOUNT reward (changes prices): fail closed */
  function catTierDiscount(groups, tier) {
    if (!tier || !tier.name) return false;
    var hit = false, want = str(tier.name).toLowerCase();
    arr(groups).forEach(function (g) {
      arr(g && g.TierLevels).forEach(function (t) {
        if (!obj(t) || M.tierName(t.name).toLowerCase() !== want) return;
        arr(t.TierRewards).forEach(function (r) {
          var d = obj(r) ? cxJson(r.rewardData) : null;
          if (obj(d) && str(d.type).toUpperCase() === 'DISCOUNT') hit = true;
        });
      });
    });
    return hit;
  }
  /* the category chips: Skio collections flagged "Display on edit product", in Skio's order (cpEditProductCollectionOrder) */
  function catCollections(site) {
    var list = arr(site && site.Collections).filter(function (c) { return obj(c) && validId(str(c.id)) && str(c.title).trim(); })
      .map(function (c) { return { id: str(c.id), title: str(c.title).trim().slice(0, 40) }; });
    var cs = cxJson(site && site.collectionSettings), order = obj(cs) ? arr(cs.cpEditProductCollectionOrder).map(str) : [];
    var byId = {};
    list.forEach(function (c) { byId[c.id] = c; });
    return order.map(function (id) { return byId[id]; }).filter(Boolean).concat(list.filter(function (c) { return order.indexOf(c.id) < 0; }));
  }
  function catHeld(s) { return s.status === 'PAUSED' || (s.status === 'ACTIVE' && s.statusContext === 'TEMPORARILY_PAUSED'); }
  function catSubInfo(s, tz) {
    return { id: str(s.id), sub: s, ymd: orderYmd(s.nextBillingDate, tz), date: dayText(s.nextBillingDate, tz, 'weekday'), short: dayText(s.nextBillingDate, tz, 'short') };
  }
  /* raw (one mkHome answer) + Skio's product list -> the screen's model (pure).
     opts = {data: the first page's answer (SiteByPk settings, collections; StorefrontUserByPk tags), capped, added, showOutOfStock} */
  function catalogModel(raw, products, opts) {
    opts = opts || {};
    var data = obj(opts.data) || {}, cs = obj(data.SiteByPk) || {};
    var site = obj(raw && raw.site) || {}, user = obj(raw && raw.user) || {};
    var tz = validTz(site.ianaTimezone);
    var siteCurrency = /^[A-Z]{3}$/.test(str(site.currencyCode)) ? site.currencyCode : (/^[A-Z]{3}$/.test(str(cs.currencyCode)) ? cs.currencyCode : null);
    var subs = arr(raw && raw.subs).filter(function (s) { return obj(s) && validId(s.id); });
    var eligible = subs.filter(catEligible).sort(soonest);
    /* r10 review: the start page's NEXT ORDER subscription (buildModel's main: the soonest open one, prepaid included) */
    var mainSub = subs.filter(isOpen).sort(soonest)[0] || null;
    var ctx = { siteCurrency: siteCurrency, byInterval: catByInterval(site) };
    var su = obj(data.StorefrontUserByPk);
    var tags = su ? arr(su.Tags).map(function (t) { return obj(t) && obj(t.Tag) ? str(t.Tag.name) : ''; }).filter(Boolean) : [];
    var tier = currentTier(parseLadder(site.TierGroups), user.StorefrontUserTiers);
    var tierDiscount = catTierDiscount(site.TierGroups, tier);
    var scs = cxJson(cs.smartCarouselSettings);
    var showOOS = typeof opts.showOutOfStock === 'boolean' ? opts.showOutOfStock : !!DECISION_CATALOG.showOutOfStock;
    var added = obj(opts.added) || {};
    var items = [], seen = {};
    arr(products).forEach(function (p) {
      if (!obj(p) || !validId(str(p.id)) || seen[p.id]) return;
      seen[p.id] = true;
      if (p.deletedAt || p.hideOnEditProductsPage === true) return;
      if (p.status && p.status !== 'ACTIVE' && p.status !== 'UNLISTED') return;
      if (!catTagOk(p, tags)) return;
      var title = str(p.title).trim().slice(0, 200), vs = catVariants(p);
      if (!title || !vs.length) return;
      /* Skio 23403.y: a box, a variant with a "Subscription" plan, or one-time add-ons on */
      if (!p.DynamicBox && !vs.some(hasSubscribePlan) && !(p.canUpsell === true && vs.some(function (v) { return v.enableOneTimeUpsell === true; }))) return;
      var inStock = vs.filter(function (v) { return !v.outOfStockAt; });
      var desc = plainText(p.description).slice(0, 2000);
      var item = {
        id: str(p.id), title: title, product: p, image: (inStock[0] || vs[0]).image || p.imageSrc || null,
        desc: desc, short: desc ? shortDesc(desc) : '', oos: !inStock.length,
        sizes: inStock.length ? sizesText(inStock.map(function (v) { return str(v.title).trim().slice(0, 80); })) : '',
        visible: [title].concat(inStock.map(function (v) { return str(v.title); })).join('\n').toLowerCase(),
        hay: [title, desc].concat(vs.map(function (v) { return str(v.title); })).join('\n').toLowerCase(),
        collections: arr(p.Collection_Products).map(function (c) { return obj(c) ? str(c.collectionId) : ''; }).filter(Boolean),
        offers: [], inOrders: [], card: null, handoff: null, handoffSub: null, added: obj(added[str(p.id)]) || null
      };
      if (item.oos) { if (showOOS) items.push(item); return; }
      eligible.forEach(function (s) {
        var o = catOffer(p, s, ctx);
        if (o) item.offers.push({ subId: str(s.id), sub: s, offer: o });
        if (nextLines(s).some(function (l) { return sameId(linePid(l), p.id); })) item.inOrders.push(s);
      });
      if (!item.offers.length && !item.inOrders.length && !item.added) return;
      /* the card prices the soonest eligible order that can take it */
      var pick = item.offers.filter(function (x) { return eligible[0] && x.subId === str(eligible[0].id); })[0] || item.offers[0] || null;
      if (pick) {
        if (pick.offer.handoff || tierDiscount) { item.handoff = pick.offer.handoff || 'tier'; item.handoffSub = pick.subId; }
        else {
          var v0 = pick.offer.variants[0];
          item.card = { subId: pick.subId, variant: v0, which: inStock[0] && !sameId(inStock[0].id, v0.id) ? v0.title : '' };
        }
      }
      items.push(item);
    });
    items.sort(function (a, b) {
      return (a.oos ? 1 : 0) - (b.oos ? 1 : 0) || a.title.localeCompare(b.title, 'en', { sensitivity: 'base' }) || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
    });
    var proves = { once: false, every: false };
    items.forEach(function (it) {
      it.offers.forEach(function (x) { x.offer.variants.forEach(function (v) { if (v.once !== null) proves.once = true; if (v.every !== null) proves.every = true; }); });
    });
    var lo = { paused: 0, prepaid: 0, gift: 0 };
    subs.forEach(function (s) {
      if (catEligible(s)) return;
      if (catHeld(s)) lo.paused++;
      else if (s.status === 'ACTIVE' && s.prepaidGiftRecipientId) lo.gift++;
      else if (s.status === 'ACTIVE' && (isPrepaidSub(s) || s.PrepaidDeliveryPolicy)) lo.prepaid++;
    });
    var noneKind = null, noneSub = null;
    if (!eligible.length) {
      var held = subs.filter(catHeld), pre = subs.filter(function (s) { return s.status === 'ACTIVE' && !s.prepaidGiftRecipientId && (isPrepaidSub(s) || s.PrepaidDeliveryPolicy); });
      /* r10 review: a gift they receive, or a digital subscription, is an active subscription: never "you don't have one" */
      var gift = subs.filter(function (s) { return s.status === 'ACTIVE' && s.prepaidGiftRecipientId; });
      var digital = subs.filter(function (s) { return s.status === 'ACTIVE' && s.isDigital && !s.prepaidGiftRecipientId; });
      if (held.length) noneKind = 'paused';
      else if (pre.length) { noneKind = 'prepaid'; noneSub = str(pre[0].id); }
      else if (gift.length) { noneKind = 'gift'; noneSub = str(gift[0].id); }
      else if (digital.length) noneKind = 'digital';
      else noneKind = 'none';
    }
    var addable = items.some(function (it) { return !it.oos && it.offers.length; });
    return {
      state: !eligible.length ? 'none' : addable ? 'list' : 'empty',
      items: items, eligible: eligible.map(function (s) { return catSubInfo(s, tz); }), attention: subs.some(needsAttention),
      proves: proves, ppd: tier && tier.ppd && !tierDiscount ? tier.ppd : null, tierName: tier ? tier.name : null, tierDiscount: tierDiscount,
      leftOut: lo, noneKind: noneKind, noneSub: noneSub, collections: catCollections(cs), capped: !!opts.capped,
      mainId: mainSub ? str(mainSub.id) : null,
      hideOOS: !!(obj(scs) && scs.hideOOSProducts), tz: tz, currency: siteCurrency || 'USD', tags: tags.length
    };
  }
  /* search (Skio 8461 N(): every word, as a substring, in the name, the description or a size name) and the chip */
  function catShown(m, q, chip) {
    var w = catWords(q);
    var keep = function (it) {
      if (chip && chip !== 'all' && it.collections.indexOf(chip) < 0) return false;
      return w.every(function (x) { return it.hay.indexOf(x) >= 0; });
    };
    var all = m.items.filter(keep);
    return { list: all.filter(function (it) { return !it.oos; }), oos: all.filter(function (it) { return it.oos; }), words: w };
  }
  /* the words the card does not show: a one-line excerpt of the description with the word in bold (phones: also when the
     word is in the description line phones hide). Where the word starts a word, else where Skio's substring matched. */
  function catHit(it, words) {
    if (!words.length || !it.desc) return null;
    var miss = words.filter(function (w) { return it.visible.indexOf(w) < 0; });
    if (!miss.length) return null;
    var full = it.desc, lowF = full.toLowerCase(), lowS = it.short.toLowerCase();
    var at = function (low, w) {
      var mm = new RegExp('(^|[^a-z0-9])' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).exec(low);
      return mm ? mm.index + mm[1].length : -1;
    };
    var phone = miss.every(function (w) { return at(lowS, w) >= 0 || (at(lowF, w) < 0 && lowS.indexOf(w) >= 0); });
    var w0 = miss[0], i = at(lowF, w0);
    if (i < 0) i = lowF.indexOf(w0);
    if (i < 0) return null;
    var a = i > 30 ? full.lastIndexOf(' ', i - 26) + 1 : 0, b = full.indexOf(' ', i + w0.length + 26);
    if (b < 0) b = full.length;
    return { phone: phone, pre: (a > 0 ? ELL : '') + full.slice(a, i), word: full.slice(i, i + w0.length), post: full.slice(i + w0.length, b) + (b < full.length ? ELL : '') };
  }

  /* ---- view ---- */
  function storeUrl() { return base().replace(/\/a\/account$/, '') + '/collections/all'; }
  function catClose(label, key, kind) {
    return el('a', { 'class': 'mkh-btn mkh-btn--' + (kind || 'ghost'), href: base() + '/subscriptions', 'data-mk-cat': 'close', 'data-mk-key': key }, label);
  }
  function catShell() {
    var input = el('input', {
      type: 'search', id: 'mkp-q', name: 'mkp-q', placeholder: 'Search products', autocomplete: 'off', enterkeyhint: 'search',
      inputmode: 'search', spellcheck: 'false', autocapitalize: 'off', maxlength: '80', 'aria-describedby': 'mkp-count', 'data-mk-key': 'cp-q'
    });
    input.value = cat.q;
    var clear = el('button', { type: 'button', 'class': 'mkp-clear', 'aria-label': 'Clear search', 'data-mk-cat': 'clear', 'data-mk-key': 'cp-clear' }, icon('x'));
    clear.hidden = !cat.q;
    input.addEventListener('input', onCatInput);
    input.addEventListener('keydown', onCatKey);
    return el('section', { 'class': 'mku mkp', 'aria-labelledby': 'mkp-title' },
      el('a', { 'class': 'mku-back', href: base() + '/subscriptions', 'data-mk-key': 'cp-back', 'data-mk-cat': 'close', 'aria-label': 'Back to your subscriptions' },
        icon('back'), 'Subscriptions'),
      el('div', { 'class': 'mku-head' }, el('h1', { 'class': 'mku-title', id: 'mkp-title', tabindex: '-1' }, 'Add products')),
      el('p', { 'class': 'mku-intro' }),
      el('div', { 'class': 'mkp-tools' },
        el('label', { 'class': 'mkp-search', 'for': 'mkp-q' }, el('span', { 'class': 'mkh-sr' }, 'Search products'), icon('search'), input, clear),
        el('p', { 'class': 'mkp-count', id: 'mkp-count' }),
        el('p', { 'class': 'mkh-sr', id: 'mkp-live', role: 'status', 'aria-live': 'polite' })),
      el('div', { 'class': 'mkp-stripslot' }),
      el('div', { 'class': 'mku-body' }));
  }
  /* the eligible orders while the list loads: the home's own data when it has it (the intro's short form) */
  function catEligibleNow() {
    if (cat.model) return cat.model.eligible;
    var raw = cat.raw || (st && st.model ? st.model.raw : null);
    if (!raw || raw.source !== 'mkHome') return [];
    var tz = validTz(raw.site && raw.site.ianaTimezone);
    return arr(raw.subs).filter(catEligible).sort(soonest).map(function (s) { return catSubInfo(s, tz); });
  }
  /* ", just once or with every order" only once the offers prove both (never while loading) */
  function catIntro() {
    var subs = catEligibleNow(), m = cat.model;
    if (!subs.length) return '';
    if (subs.length > 1) return 'Add to any of your upcoming orders. You\'ll choose which one when you add.';
    var both = cat.state === 'list' && m && m.proves.once && m.proves.every;
    return 'Add to your ' + nbsp(subs[0].date) + ' order' + (both ? ', just once or with every order.' : '.');
  }
  function catPrice(it, m) {
    var c = it.card;
    if (!c || m.tierDiscount) return null;
    var x = c.variant, cur = m.currency;
    var main = x.once !== null ? x.once : x.every, what = x.once !== null ? ' just this order' : ' with every order';
    var lower = main < x.regular - 0.004;
    var pts = m.ppd ? M.earnPoints(main, m.ppd) : 0;
    /* r10 review: with two or more orders, a card priced for a later order (the soonest cannot take it) says which */
    var later = m.eligible.length > 1 && m.eligible[0] && !sameId(c.subId, m.eligible[0].id)
      ? (m.eligible.filter(function (e) { return sameId(e.id, c.subId); })[0] || {}).short : '';
    var which = c.which && later ? 'Prices for ' + c.which + ' in your ' + nbsp(later) + ' order' : later ? 'Prices for your ' + nbsp(later) + ' order'
      : c.which ? 'Prices for ' + c.which : '';
    return el('div', { 'class': 'mkp-price' },
      which ? el('p', { 'class': 'mkp-which' }, which) : null,
      el('p', { 'class': 'mkp-p1' },
        lower ? el('s', null, el('span', { 'class': 'mkh-sr' }, 'Regular price '), M.money(x.regular, cur)) : null, lower ? ' ' : null,
        el('b', null, M.money(main, cur)), what),
      x.once !== null && x.every !== null && Math.abs(x.once - x.every) > 0.004
        ? el('p', { 'class': 'mkp-p2' }, 'or ', el('b', null, M.money(x.every, cur)), ' with every order') : null,
      pts > 0 ? el('p', { 'class': 'mkp-pts' }, icon('star'), 'Earns ' + M.pointsText(pts)) : null);
  }
  function catTagText(subs, tz) {
    var d = subs.map(function (s) { return nbsp(dayText(s.nextBillingDate, tz, 'short')); });
    return 'In your ' + (d.length > 1 ? d.slice(0, -1).join(', ') + ' and ' + d[d.length - 1] + ' orders' : d[0] + ' order');
  }
  function catCard(it, i, m, words) {
    var key = 'pc-' + i, ad = it.added, src = img(it.image, 200), hit = catHit(it, words);
    var main = el('div', { 'class': 'mkp-main' },
      el('h2', { 'class': 'mkp-name', id: 'mkp-n-' + i }, it.title),
      it.sizes ? el('p', { 'class': 'mkp-sizes' }, it.sizes) : null,
      it.short ? el('p', { 'class': 'mkp-desc' }, it.short) : null,
      hit ? el('p', { 'class': 'mkp-hit' + (hit.phone ? ' mkp-hit--phone' : '') }, el('span', { 'class': 'mkh-sr' }, 'Matches the description: '),
        hit.pre, el('b', null, hit.word), hit.post) : null,
      /* while "Added" shows, it replaces the tag (one line, not two saying the same) */
      it.inOrders.length && !ad ? el('span', { 'class': 'mkp-tag' }, icon('calendar'), catTagText(it.inOrders, m.tz)) : null,
      ad ? el('p', { 'class': 'mkp-done', tabindex: '-1', 'data-mkp-added': it.id }, icon('check'), 'Added to your ' + (ad.short ? nbsp(ad.short) + ' ' : '') + 'order') : null);
    var foot;
    if (it.oos) {
      foot = el('div', { 'class': 'mkp-foot' }, el('p', { 'class': 'mkp-oos' }, 'Out of stock right now'));
    } else if (!it.offers.length) {
      /* nothing left to add here (Skio's one-add-per-product rule after an add, or every size already in the orders) */
      var mid = ad ? ad.subId : (it.inOrders[0] && it.inOrders[0].id);
      foot = el('div', { 'class': 'mkp-foot' },
        el('p', { 'class': 'mkp-p1 mkp-none' }, ad ? 'To change it, open your subscription.' : 'Already in your orders'),
        mid ? el('a', { 'class': 'mkh-link mkp-manage', href: subUrl(mid), 'data-mk-key': key + '-m', 'aria-label': 'Manage subscription: ' + it.title }, 'Manage') : null);
    } else {
      var hand = !!it.handoff || !it.card;
      foot = el('div', { 'class': 'mkp-foot' }, catPrice(it, m) || el('span', { 'class': 'mkp-price' }),
        el('button', { type: 'button', 'class': 'mkh-btn mkh-btn--small mkp-add', 'data-mk-key': key, 'data-mk-cat': 'add', 'data-mkp-id': it.id,
          'aria-haspopup': hand ? null : 'dialog', 'aria-label': hand ? 'Add ' + it.title + ' on your subscription\'s page' : 'Add ' + it.title }, 'Add'));
    }
    return el('li', null, el('article', { 'class': 'mkh-card mkp-card' + (it.oos ? ' mkp-card--oos' : ''), 'aria-labelledby': 'mkp-n-' + i, 'data-mkp-id': it.id },
      src ? el('img', { src: src, alt: '', width: '80', height: '80', loading: 'lazy', decoding: 'async' }) : el('span', { 'class': 'mkp-ph', 'aria-hidden': 'true' }),
      main, foot));
  }
  function catState(ico, title, text, acts, more, role) {
    return el('div', { 'class': 'mkh-card mku-card mku-state', role: role || null },
      el('span', { 'class': 'mku-state-ico' }, icon(ico)),
      el('h2', { 'class': 'mku-state-title' }, title),
      text ? el('p', { 'class': 'mku-state-text' }, text) : null,
      more ? el('p', { 'class': 'mkp-state-more' }, more) : null,
      acts ? el('div', { 'class': 'mkh-actions mku-state-acts' }, acts) : null);
  }
  function catNotes(m) {
    var subs = m.eligible, parts = [];
    var second = m.proves.once && m.proves.every ? 'You choose the size, and just this order or every order, when you add.' : 'You choose the size when you add.';
    if (m.tierDiscount) parts.push(el('p', null, 'Add opens your subscription\'s page, where you choose the size and see the price.'));
    else {
      var first = subs.length > 1
        ? 'Prices are for your ' + nbsp(subs[0].short) + ' order and the first size you can add; you\'ll see the price for the order you choose when you add.'
        : 'Prices are for the first size you can add.';
      parts.push(el('p', null, first + ' ' + second));
    }
    if (m.ppd && m.tierName) parts.push(el('p', null, 'The points shown are for your ' + m.tierName + ' tier: ' + ppdText(m.ppd) + ' per $1.'));
    if (m.leftOut.paused) parts.push(el('p', null, 'Paused subscriptions aren\'t listed. Resume one to add to it.'));
    if (m.leftOut.prepaid) parts.push(el('p', null, 'Prepaid subscriptions aren\'t listed. Add to them on their own page.'));
    if (m.leftOut.gift) parts.push(el('p', null, 'Gift subscriptions aren\'t listed.'));
    return el('div', { 'class': 'mkh-card mku-card mkp-notes' }, parts);
  }
  function catAttention() {
    return el('div', { 'class': 'mku-alert', role: 'alert' }, icon('alert'), el('p', null, el('b', null, 'A subscription needs your attention.')),
      catClose('Go to your subscriptions', 'cp-attn', 'brown'));
  }
  function catOpenSubUrl() {
    var e = catEligibleNow();
    return e.length ? subUrl(e[0].id) : base() + '/subscriptions?mk_native=1';
  }
  function catBody() {
    var m = cat.model;
    if (cat.state === 'loading') {
      return el('div', { 'class': 'mku-stack', 'aria-busy': 'true' }, el('p', { 'class': 'mkh-sr', role: 'status' }, 'Loading products'),
        el('ul', { 'class': 'mkp-grid', role: 'list' }, [0, 1, 2, 3].map(function () {
          return el('li', { 'aria-hidden': 'true' }, el('div', { 'class': 'mkh-card mkp-card mkp-skel' }, el('span', { 'class': 'mkp-sk-img' }),
            el('div', { 'class': 'mkp-main' }, el('span', { 'class': 'mkp-sk-l' }), el('span', { 'class': 'mkp-sk-l' }), el('span', { 'class': 'mkp-sk-l' })),
            el('div', { 'class': 'mkp-foot' }, el('span', { 'class': 'mkp-sk-l mkp-sk-price' }), el('span', { 'class': 'mkp-sk-btn' }))));
        })));
    }
    if (cat.state === 'error' || !m) {
      return catState('alert', 'We couldn\'t load the products.', null,
        [el('button', { 'class': 'mkh-btn mkh-btn--brown', type: 'button', 'data-mk-cat': 'retry', 'data-mk-key': 'cp-retry' }, 'Try again'), catClose('See your subscriptions', 'cp-see')],
        ['You can also add products on your subscription\'s own page. ', el('a', { 'class': 'mkh-link', href: catOpenSubUrl(), 'data-mk-key': 'cp-err-sub' }, 'Open your subscription')], 'alert');
    }
    var attention = m.attention ? catAttention() : null;
    if (cat.state === 'none') {
      var card;
      if (m.noneKind === 'paused') card = catState('pause', 'You need an active subscription to add products.', 'Your subscription is paused. Resume it to add products to an order.',
        [catClose('Go to your subscriptions', 'cp-see', 'brown')]);
      else if (m.noneKind === 'prepaid') card = catState('bag', 'You need an active subscription to add products.', 'Your subscription is prepaid. Add products on its own page.',
        [el('a', { 'class': 'mkh-btn mkh-btn--brown', href: subUrl(m.noneSub), 'data-mk-key': 'cp-prepaid' }, 'Open your subscription')]);
      else if (m.noneKind === 'gift') card = catState('bag', 'Products can\'t be added here.', 'Gift subscriptions aren\'t listed.',
        [el('a', { 'class': 'mkh-btn mkh-btn--brown', href: subUrl(m.noneSub), 'data-mk-key': 'cp-gift' }, 'Open your subscription'), catClose('See your subscriptions', 'cp-see')]);
      else if (m.noneKind === 'digital') card = catState('bag', 'Products can\'t be added here.', 'Your subscription can\'t take products from this list.',
        [catClose('See your subscriptions', 'cp-see', 'brown')]);
      else card = catState('bag', 'You need an active subscription to add products.', m.attention ? null : 'You don\'t have an active subscription right now.',
        m.attention ? [catClose('See your subscriptions', 'cp-see')]
          : [el('a', { 'class': 'mkh-btn mkh-btn--brown', href: storeUrl(), 'data-mk-key': 'cp-shop' }, 'Shop on mksupps.com'), catClose('See your subscriptions', 'cp-see')]);
      return el('div', { 'class': 'mku-stack' }, attention, card);
    }
    if (cat.state === 'empty') {
      return el('div', { 'class': 'mku-stack' }, attention,
        catState('bag', 'There\'s nothing new to add right now.', 'Everything you can add is already in your orders.', [catClose('See your subscriptions', 'cp-see')]));
    }
    var sh = catShown(m, cat.q, cat.chip), shown = sh.list.concat(sh.oos);
    if (!shown.length) {
      return el('div', { 'class': 'mku-stack' }, attention,
        catState('search', 'No products match ' + QL + cat.q.trim() + QR + '.', 'Try another word, or clear the search to see everything.',
          [el('button', { 'class': 'mkh-btn mkh-btn--brown', type: 'button', 'data-mk-cat': 'clear', 'data-mk-key': 'cp-clear2' }, 'Clear search')],
          ['Not everything on mksupps.com can be added to a subscription here. ', el('a', { 'class': 'mkh-link', href: storeUrl(), 'data-mk-key': 'cp-shop2' }, 'Shop mksupps.com')]));
    }
    return el('div', { 'class': 'mku-stack' }, attention,
      el('ul', { 'class': 'mkp-grid', role: 'list' }, shown.map(function (it, i) { return catCard(it, i, m, sh.words); })),
      m.capped && m.eligible.length ? el('p', { 'class': 'mkp-cap' }, 'Some products aren\'t listed here. ',
        el('a', { 'class': 'mkh-link', href: subUrl(m.eligible[0].id), 'data-mk-key': 'cp-cap' }, 'Open your subscription')) : null,
      catNotes(m));
  }
  /* "12 products (+ 2 out of stock) . A to Z" / "4 products match "liver" (+ 1 out of stock)" */
  function catCountParts() {
    var m = cat.model;
    if (cat.state !== 'list' || !m) return null;
    var sh = catShown(m, cat.q, cat.chip), k = sh.list.length, o = sh.oos.length;
    var oos = o ? ' (+ ' + o + ' out of stock)' : '';
    if (sh.words.length) {
      if (!k && !o) return { hide: true, text: 'No products match ' + QL + cat.q.trim() + QR + '.' };
      return { b: String(k), rest: (k === 1 ? ' product matches ' : ' products match ') + QL + cat.q.trim() + QR + oos };
    }
    return { b: String(k), rest: (k === 1 ? ' product' : ' products') + oos + DOT + 'A to Z' };
  }
  function catCountText() { var c = catCountParts(); return c ? (c.text || c.b + c.rest) : ''; }
  function catStrip() {
    var s = cat.strip;
    if (!s) return null;
    var what = [s.title, s.size, s.once ? 'just this order' : 'with every order', typeof s.unit === 'number' ? M.money(s.unit, s.currency) : ''].filter(Boolean).join(DOT);
    return el('div', { 'class': 'mkp-strip', role: 'status' },
      el('span', { 'class': 'mkp-strip-ico', 'aria-hidden': 'true' }, icon('check')),
      el('span', { 'class': 'mkp-strip-main' },
        el('b', null, 'Added to your ' + (s.date ? nbsp(s.date) + ' ' : '') + 'order.'),
        el('span', null, what),
        s.next ? el('a', { 'class': 'mkh-link', href: base() + '/subscriptions', 'data-mk-cat': 'close', 'data-mk-key': 'cp-strip' }, 'See your next order')
          : el('a', { 'class': 'mkh-link', href: subUrl(s.subId), 'data-mk-key': 'cp-strip' }, 'View your ' + (s.short ? nbsp(s.short) + ' ' : '') + 'order')),
      el('button', { type: 'button', 'class': 'mkp-strip-x', 'aria-label': 'Dismiss', 'data-mk-cat': 'strip-x', 'data-mk-key': 'cp-strip-x' }, icon('x')));
  }
  function catFill(node) {
    var body = node.querySelector('.mku-body');
    if (!body) throw new Error('no body');
    var m = cat.model;
    body.setAttribute('data-state', cat.state);
    var intro = node.querySelector('.mku-intro');
    if (intro) M.text(intro, catIntro());
    var input = node.querySelector('#mkp-q');
    if (input) { input.disabled = cat.state === 'loading'; if (input.value !== cat.q) input.value = cat.q; }
    var clear = node.querySelector('.mkp-clear');
    if (clear) clear.hidden = !cat.q;
    var tools = node.querySelector('.mkp-tools'), old = tools && tools.querySelector('.mkp-chips');
    if (old) old.remove();
    if (tools && cat.state === 'list' && m && m.collections.length) {
      tools.appendChild(el('div', { 'class': 'mkp-chips', role: 'group', 'aria-label': 'Show' }, [{ id: 'all', title: 'All' }].concat(m.collections).map(function (c) {
        return el('button', { type: 'button', 'class': 'mkp-chip', 'data-mk-cat': 'chip', 'data-mk-chip': c.id, 'data-mk-key': 'cp-chip-' + c.id, 'aria-pressed': String(cat.chip === c.id) }, c.title);
      })));
    }
    var cnt = node.querySelector('.mkp-count');
    if (cnt) {
      cnt.textContent = '';
      var c = catCountParts();
      cnt.className = 'mkp-count' + (c && c.hide ? ' mkh-sr' : '');
      if (c) { if (c.text) M.text(cnt, c.text); else { cnt.appendChild(el('b', null, c.b)); cnt.appendChild(document.createTextNode(c.rest)); } }
    }
    var slot = node.querySelector('.mkp-stripslot');
    if (slot) { slot.textContent = ''; var sp = catStrip(); if (sp) slot.appendChild(sp); slot.hidden = !sp; }
    body.textContent = '';
    body.appendChild(catBody());
  }

  /* ---- lifecycle (the same rules as Upcoming orders) ---- */
  var cat = { state: 'closed', run: 0, pending: false, openedHere: false, opener: null, model: null, raw: null, res: null, observer: null,
    timer: null, failedAt: null, q: '', chip: 'all', added: {}, strip: null, liveTimer: null, warmAt: 0, idleTimer: null, focusAdded: null,
    unclear: {} };
  var screenAfter = null;     /* the screen to open once Back has closed the other one (one screen at a time) */
  function wantCatalog() { return catalogOn() && M.on() && location.hash === CAT_HASH && M.route().page === 'subscriptions'; }
  function setCatClass(on) { try { document.documentElement.classList.toggle('mk-catalog-open', !!on); } catch (e) { /* ignore */ } }
  function syncCatalog() {
    if (wantCatalog()) {
      if (cat.failedAt === location.href) return;
      if (cat.state === 'closed' && !cat.pending) showCatalog();
    } else {
      cat.failedAt = null;
      if (cat.state !== 'closed' || cat.pending) teardownCatalog('hash');
    }
  }
  /* the screen that closes goes first */
  function syncScreens() {
    if (location.hash === CAT_HASH) { syncUpcoming(); syncCatalog(); } else { syncCatalog(); syncUpcoming(); }
  }
  function catFail(why) {
    M.log('home: catalogue: showing the page underneath (' + why + ')');
    teardownCatalog('error');
    cat.failedAt = location.href;
  }
  function mountCatalog() {
    var layout = M.q(LAYOUT_SEL);
    if (!layout) return null;
    var node = M.mount({
      id: 'mk-catalog', anchor: layout, where: 'prepend', module: 'home', sig: 'cat:' + cat.run,
      build: function () { var n2 = catShell(); catFill(n2); n2.addEventListener('click', onCatClick); return n2; }
    });
    if (!node) return null;
    setCatClass(true);
    M.screen.set('add-products');
    return node;
  }
  function drawCatalog() {
    try {
      if (cat.state === 'closed') return;
      var layout = M.q(LAYOUT_SEL), node = document.getElementById('mk-catalog');
      if (node && layout && node.parentNode === layout && layout.firstElementChild === node) {
        /* r10 (part 2): a redraw (a fresh read after an add) keeps focus on the same control when it is still there */
        /* (not while the card's "Added" line is waiting for focus: catRefocus() puts it there) */
        var ae = document.activeElement, key = null, body = node.querySelector('.mku-body');
        if (ae && body && body.contains(ae) && !cat.focusAdded) key = ae.getAttribute('data-mk-key');
        catFill(node);
        if (key && !(document.activeElement && node.contains(document.activeElement))) {
          var again = node.querySelector('.mku-body [data-mk-key="' + catEsc(key) + '"]');
          try { if (again) again.focus({ preventScroll: true }); } catch (e2) { /* ignore */ }
        }
        return;
      }
      if (!mountCatalog()) catFail('mount');
    } catch (e) { catFail('render error: ' + (e && e.message)); }
  }
  function focusCatTitle() {
    try { window.scrollTo(0, 0); } catch (e) { /* ignore */ }
    var h = document.getElementById('mkp-title');
    try { if (h) h.focus({ preventScroll: true }); } catch (e) { try { h.focus(); } catch (e2) { /* ignore */ } }
  }
  function showCatalog() {
    var run = ++cat.run;
    cat.pending = true;
    var a = document.activeElement;
    cat.opener = a && a !== document.body && a !== document.documentElement ? a : null;
    M.waitFor('[data-skio-name="authed-layout"]', { timeout: CAT_WAIT_MS }).then(function (layout) {
      if (run !== cat.run) return;
      cat.pending = false;
      if (!layout || !wantCatalog()) return;
      cat.state = 'loading'; cat.model = null;
      try {
        if (!mountCatalog()) return catFail('mount');
        focusCatTitle();
        watchCatalog();
      } catch (e) { return catFail('open error: ' + (e && e.message)); }
      loadCatalog(run);
    }, function () { if (run === cat.run) cat.pending = false; });
  }
  /* Skio's product list, read only (core 1.5.0 skioPages: 24 a page, at most 5, cached cacheMs per customer) */
  function catRead(fresh) {
    if (typeof M.skioPages !== 'function') return Promise.resolve(null);
    return M.storefrontUserId().then(function (uid) {
      if (!uid) return null;
      return M.skioPages(Q_CATALOG, { siteId: SITE_ID, storefrontUserId: uid, where: CAT_WHERE }, {
        pick: function (d) { return d && d.SiteByPk ? d.SiteByPk.Products : null; },
        pageSize: DECISION_CATALOG.pageSize, maxPages: DECISION_CATALOG.maxPages, ttl: DECISION_CATALOG.cacheMs, fresh: !!fresh
      });
    }).then(null, function () { return null; });
  }
  function catRebuild() {
    cat.model = catalogModel(cat.raw, cat.res.items, { data: cat.res.data, capped: cat.res.capped, added: cat.added });
    cat.state = cat.model.state;
  }
  function loadCatalog(run, fresh) {
    var rawP = M.storefrontUserId().then(function (uid) { return uid ? rawFor(uid, !!fresh) : null; }).then(null, function () { return null; });
    Promise.all([rawP, catRead(fresh)]).then(function (rs) {
      if (run !== cat.run || cat.state === 'closed') return;
      var raw = rs[0], res = rs[1];
      if (raw && raw.source === 'mkHome') cat.raw = raw;
      /* Skio's own fallback documents lack what the rules need (prepaid policy, site settings): fail closed */
      if (!raw || raw.source !== 'mkHome' || !res || !res.ok) {
        M.log('home: catalogue: load failed (' + (!raw ? 'no data' : raw.source !== 'mkHome' ? 'fallback data' : 'products') + ')');
        cat.state = 'error'; cat.model = null; cat.res = null; drawCatalog();
        return;
      }
      cat.res = res;
      catRebuild();
      drawCatalog();
      catRefocus();
    }).then(null, function (e) {
      if (run !== cat.run || cat.state === 'closed') return;
      M.log('home: catalogue: load failed', e && e.message);
      cat.state = 'error'; cat.model = null; drawCatalog();
    });
  }
  function watchCatalog() {
    if (cat.observer) return;
    var root = document.getElementById('skio-root');
    if (!root || typeof MutationObserver !== 'function') return;
    cat.observer = new MutationObserver(function () {
      if (cat.timer) return;
      cat.timer = setTimeout(function () {
        cat.timer = null;
        if (cat.state === 'closed') return;
        var layout = M.q(LAYOUT_SEL), node = document.getElementById('mk-catalog');
        if (!layout) return;       /* the page is changing; the route watcher decides */
        if (!node || node.parentNode !== layout || layout.firstElementChild !== node) drawCatalog();
      }, 60);
    });
    cat.observer.observe(root, { childList: true, subtree: true });
  }
  /* close: the class first, then our node and the screen value (only while it is still ours) */
  function teardownCatalog(why) {
    var wasOpen = cat.state !== 'closed', opener = cat.opener;
    cat.run++;
    cat.pending = false; cat.state = 'closed'; cat.model = null; cat.opener = null;
    cat.q = ''; cat.chip = 'all'; cat.strip = null; cat.focusAdded = null;
    if (cat.observer) { try { cat.observer.disconnect(); } catch (e) { /* ignore */ } cat.observer = null; }
    if (cat.timer) { clearTimeout(cat.timer); cat.timer = null; }
    if (cat.liveTimer) { clearTimeout(cat.liveTimer); cat.liveTimer = null; }
    setCatClass(false);
    M.unmount('mk-catalog');
    M.screen.clear('add-products');
    /* closed from the menu: the menu keeps focus on the item that was chosen (r4) */
    var inMenu = false;
    try { var ae = document.activeElement; inMenu = !!(ae && ae.closest && ae.closest('#mk-nav')); } catch (e) { /* ignore */ }
    if (wasOpen && why !== 'route' && !inMenu && !(location.hash === UPCOMING_HASH)) catRestoreFocus(opener);
  }
  /* focus back on the opener ("See all products" is redrawn with the home panel: found again by its key) */
  function catRestoreFocus(opener) {
    var t = opener;
    try {
      if ((!t || !t.isConnected) && opener && opener.getAttribute && opener.getAttribute('data-mk-key')) {
        t = document.querySelector('#mk-home [data-mk-key="' + opener.getAttribute('data-mk-key') + '"]');
      }
    } catch (e) { t = null; }
    restoreFocus(t);
  }
  function closeCatalog() {
    try {
      if (location.hash === CAT_HASH) {
        if (cat.openedHere && M.screen.ownEntry('add-products')) {
          /* this page added the #add-products entry: going back closes it (hashchange) and keeps history tidy */
          cat.openedHere = false;
          window.history.back();
          return true;
        }
        M.screen.dropHash('add-products');
      }
      teardownCatalog('closed');
      return true;
    } catch (e) { teardownCatalog('error'); return false; }
  }
  function openCatalog() {
    if (!catalogOn() || M.route().page !== 'subscriptions') return false;
    cat.failedAt = null;
    return openScreen('add-products');
  }
  /* one screen of ours at a time (core contract): the other one's own history entry is gone back over first (its entry
     is replaced, so Back from the new screen goes to the start page), a hash that is not ours is dropped (URL only) */
  function openScreen(name) {
    var mine = name === 'upcoming' ? UPCOMING_HASH : CAT_HASH;
    var otherName = name === 'upcoming' ? 'add-products' : 'upcoming', other = '#' + otherName;
    if (location.hash === other) {
      var ownOther = name === 'upcoming' ? cat.openedHere : up.openedHere;
      if (ownOther && M.screen.ownEntry(otherName)) {
        screenAfter = name;
        if (name === 'upcoming') cat.openedHere = false; else up.openedHere = false;
        window.history.back();
        setTimeout(function () {
          if (screenAfter !== name) return;
          screenAfter = null;
          if (location.hash === other) M.screen.dropHash(otherName);
          openScreen(name);
        }, 1000);
        return true;
      }
      M.screen.dropHash(otherName);
    }
    if (location.hash !== mine) {
      if (M.screen.pushHash(name)) { if (name === 'upcoming') up.openedHere = true; else cat.openedHere = true; }
      else if (name === 'upcoming') location.hash = 'upcoming';
      else location.hash = 'add-products';
    }
    syncScreens();
    return true;
  }
  function screenAfterBack() {
    if (!screenAfter) return false;
    var name = screenAfter, other = name === 'upcoming' ? CAT_HASH : UPCOMING_HASH;
    if (location.hash === other) return false;    /* not back yet */
    screenAfter = null;
    if (M.route().page !== 'subscriptions' || (name === 'upcoming' ? !upcomingOn() : !catalogOn())) { syncScreens(); return true; }
    openScreen(name);
    return true;
  }
  /* read ahead on intent (the menu, "See all products") or idle on the start page; the core caches the answers */
  function catWarm() {
    if (!catalogOn() || !M.on()) return false;
    var t = Date.now();
    if (t - cat.warmAt < CAT_WARM_MIN_MS) return false;
    cat.warmAt = t;
    catRead(false);          /* the products only: the start page's own read (mkHome) is already there or on its way */
    return true;
  }
  function catIdle(id) {
    if (!catalogOn() || !(DECISION_CATALOG.idleMs > 0)) return;
    if (cat.idleTimer) clearTimeout(cat.idleTimer);
    cat.idleTimer = setTimeout(function () {
      cat.idleTimer = null;
      if (id === runId && status === 'ready' && M.route().page === 'subscriptions') catWarm();
    }, DECISION_CATALOG.idleMs);
  }
  function onCatIntent(ev) {
    try { var a = ev.target && ev.target.closest ? ev.target.closest('[data-mk-nav="catalog"]') : null; if (a) catWarm(); } catch (e) { /* ignore */ }
  }
  /* ---- search ---- */
  function catAnnounce() {
    if (cat.liveTimer) clearTimeout(cat.liveTimer);
    cat.liveTimer = setTimeout(function () {
      cat.liveTimer = null;
      var l = document.getElementById('mkp-live');
      if (l && cat.state !== 'closed') M.text(l, catCountText());
    }, CAT_LIVE_MS);
  }
  function catSetQuery(q, focus) {
    cat.q = str(q).slice(0, 80);
    drawCatalog();
    var input = document.getElementById('mkp-q');
    if (focus && input) { try { input.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    catAnnounce();
  }
  function onCatInput(ev) {
    try {
      if (cat.state !== 'list') return;
      cat.q = str(ev.target.value).slice(0, 80);
      drawCatalog();              /* the field itself stays (focus never moves while typing) */
      catAnnounce();
    } catch (e) { /* ignore */ }
  }
  function onCatKey(ev) {
    try {
      if (ev.key === 'Escape' && ev.target.value) { ev.preventDefault(); ev.stopPropagation(); catSetQuery('', true); }
      else if (ev.key === 'Enter') ev.preventDefault();
    } catch (e) { /* ignore */ }
  }
  function catFind(sel) { var nd = document.getElementById('mk-catalog'); return nd ? nd.querySelector(sel) : null; }
  function catEsc(v) { return window.CSS && CSS.escape ? CSS.escape(v) : str(v).replace(/["\\]/g, '\\$&'); }
  function onCatClick(ev) {
    try {
      var a = ev.target && ev.target.closest ? ev.target.closest('[data-mk-cat], [data-mk-action]') : null;
      if (!a) return;
      if (ev.defaultPrevented || ev.button > 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;   /* new tab etc.: plain link */
      var what = a.getAttribute('data-mk-cat');
      if (what === 'close') { ev.preventDefault(); closeCatalog(); return; }
      if (what === 'retry') {
        ev.preventDefault();
        cat.state = 'loading'; cat.model = null;
        drawCatalog();
        focusCatTitle();
        loadCatalog(cat.run, true);
        return;
      }
      if (what === 'clear') { ev.preventDefault(); catSetQuery('', true); return; }
      if (what === 'chip') {
        ev.preventDefault();
        cat.chip = a.getAttribute('data-mk-chip') || 'all';
        drawCatalog();
        var c = catFind('[data-mk-chip="' + catEsc(cat.chip) + '"]');
        try { if (c) c.focus({ preventScroll: true }); } catch (e2) { /* ignore */ }
        catAnnounce();
        return;
      }
      if (what === 'strip-x') {
        ev.preventDefault();
        cat.strip = null;
        drawCatalog();
        var t = catFind('#mkp-q') || document.getElementById('mkp-title');
        try { if (t) t.focus({ preventScroll: true }); } catch (e3) { /* ignore */ }
        return;
      }
      if (what === 'add') { ev.preventDefault(); catAdd(a); return; }
      onPanelClick(ev);
    } catch (e) { /* the plain link still works */ }
  }
  /* ---- Add ---- */
  function catAdd(btn) {
    var m = cat.model, id = btn.getAttribute('data-mkp-id');
    var it = m ? m.items.filter(function (x) { return x.id === id; })[0] : null;
    if (!it || it.oos || !it.offers.length) return;
    /* r10 review: after an unclear outcome for this product, only that order while the core's hold lasts */
    var u = catUnclear(it.id);
    var subId = u ? u.subId : it.card ? it.card.subId : (it.handoffSub || (m.eligible[0] && m.eligible[0].id));
    if (!subId) return;
    var opened = false;
    if (it.card && !it.handoff) {
      try { opened = catAddPopup(btn, it, u); } catch (e) { M.log('home: catalogue Add error', e && e.message); opened = false; }
    }
    /* anything the pop-up cannot do here: Skio's own "Add product" picker on that subscription's page */
    if (!opened) handoff(subId, 'add-product');
  }
  /* r10 (part 2): the orders the pop-up offers for one card, soonest first: every eligible order whose offer Skio's rules
     allow and this file can price (no hand-off), in r9.1's offer shape plus the "Which order" facts and the sizes in Skio's
     order with the ones already in that order (disabled chips). Pure. -> [pop] */
  function catPops(it, m) {
    if (!obj(it) || !obj(m) || m.tierDiscount || !obj(it.product)) return [];
    var soon = m.mainId || null;
    var all = catVariants(it.product).filter(function (v) { return !v.outOfStockAt; });
    return arr(it.offers).map(function (x) {
      var s = x && x.sub, o = x && x.offer;
      if (!obj(s) || !obj(o) || o.handoff || !UUID_RE.test(str(x.subId))) return null;
      var variants = arr(o.variants).filter(function (v) { return UUID_RE.test(str(v.id)); });
      if (!variants.length) return null;
      var when = dayText(s.nextBillingDate, m.tz, 'short'), date = dayText(s.nextBillingDate, m.tz, 'weekday');
      if (!when || !date) return null;
      var inOrder = arr(o.inOrder), order = [], nl = nextLines(s);
      all.forEach(function (v) {
        var k = -1;
        variants.forEach(function (y, i) { if (sameId(y.id, v.id)) k = i; });
        var title = v.title && v.title !== 'Default Title' ? str(v.title).trim().slice(0, 80) : '';
        if (k >= 0) order.push({ title: variants[k].title, k: k });
        else if (inOrder.some(function (y) { return sameId(y.id, v.id); })) {
          order.push({ title: title, k: -1, later: !nl.some(function (l) { return sameId(lineVid(l), v.id); }) });
        }
      });
      /* a size without a name next to others cannot be told apart: hand off (as catOffer does) */
      if (order.length > 1 && order.some(function (z) { return !z.title; })) return null;
      var lines = nl, freq = schedule(s.BillingPolicy);
      return {
        when: when, freq: freq.toLowerCase(), variants: variants, first: 0, title: it.title, currency: m.currency, ppd: m.ppd,
        subId: str(x.subId), sub: s, order: order, inOrder: inOrder, date: date, next: !!soon && sameId(soon, x.subId),
        names: namesText(lines, 3), schedule: freq, thumbs: thumbUrls(lines, 3)
      };
    }).filter(Boolean);
  }
  /* the left-out note under "Which order" (the notes card's sentences) */
  function catLeftOutText(m) {
    var lo = (m && m.leftOut) || {}, t = [];
    if (lo.paused) t.push('Paused subscriptions aren\'t listed. Resume one to add to it.');
    if (lo.prepaid) t.push('Prepaid subscriptions aren\'t listed. Add to them on their own page.');
    if (lo.gift) t.push('Gift subscriptions aren\'t listed.');
    return t.join(' ');
  }
  /* PART 2 (r10): Add opens the approved pop-up for any order that can take the product: "Which order" first when two or
     more can (the card's order, the soonest, chosen), a size already in the chosen order shown disabled, everything worked
     out again for the order chosen; the write is r9.1's, for the chosen order. -> true when it opened (false: hand-off) */
  function catUnclear(pid) {
    var u = cat.unclear[str(pid)];
    if (u && Date.now() - u.at < DATE_HOLD_MS) return u;
    delete cat.unclear[str(pid)];
    return null;
  }
  function catAddPopup(opener, it, u) {
    var m = cat.model;
    if (!m || !DECISION_ADD_POPUP.enabled || !it || it.handoff || !it.card) return false;
    var pops = catPops(it, m);
    if (u) pops = pops.filter(function (p) { return sameId(p.subId, u.subId); });
    if (!pops.length) return false;
    var si = 0;
    pops.forEach(function (p, i) { if (sameId(p.subId, it.card.subId)) si = i; });
    var pid = it.id;
    return openAddDialog(opener, pops, {
      pick: { pid: pid, title: it.title }, si: si, src: 'catalog', hidden: catLeftOutText(m), lockSub: !!u,
      returnFocus: function () { return catFocusTarget(pid); },
      onDone: catAddedFrom
    });
  }
  /* something was sent from the list but no success was shown: read the list again (the core already dropped its cache) */
  function catAfterSend() {
    if (cat.state === 'closed' || cat.pending) return;
    loadCatalog(cat.run, true);
  }
  function catFocusTarget(pid) {
    cat.focusAdded = null;
    return catFind('[data-mkp-added="' + catEsc(pid) + '"]') || catFind('[data-mk-cat="add"][data-mkp-id="' + catEsc(pid) + '"]') ||
      document.getElementById('mkp-title');
  }
  function catAddedFrom(A) {
    if (!A || A.catDone) return;
    A.catDone = true;
    delete cat.unclear[str(A.pick.pid)];
    var r = A.result || {};
    catAdded({ productId: A.pick.pid, subId: A.offer.subId, title: A.offer.title, size: r.size || '', once: !!r.once,
      unit: typeof r.unit === 'number' ? r.unit : null, currency: A.offer.currency, raw: r.raw || null });
  }
  /* after any confirmed add (PART 2 calls this too): info = {productId, subId, title, size, once, unit (Skio's re-read line
     total, or null), currency, raw (a fresh mkHome answer, or null)}. The card says "Added to your <date> order" (this page
     view), the strip says what was added; offers are recomputed from the fresh data (Skio 23403.y afterwards). */
  function catAdded(info) {
    if (!info || !info.productId || !info.subId) return;
    var raw = info.raw && info.raw.source === 'mkHome' ? info.raw : cat.raw;
    var tz = validTz(raw && raw.site && raw.site.ianaTimezone);
    var sub = raw ? subById(raw, info.subId) : null;
    var date = sub && sub.nextBillingDate ? dayText(sub.nextBillingDate, tz, 'weekday') : '';
    var short = sub && sub.nextBillingDate ? dayText(sub.nextBillingDate, tz, 'short') : '';
    var soon = raw ? arr(raw.subs).filter(function (s) { return obj(s) && validId(s.id) && isOpen(s); }).sort(soonest)[0] : null;
    cat.added[str(info.productId)] = { subId: str(info.subId), date: date, short: short };
    cat.strip = { title: str(info.title).slice(0, 200), size: str(info.size), once: !!info.once, unit: typeof info.unit === 'number' ? info.unit : null,
      currency: info.currency || 'USD', date: date, short: short, subId: str(info.subId), next: !!(soon && sameId(soon.id, info.subId)) };
    cat.focusAdded = str(info.productId);
    if (info.raw && info.raw.source === 'mkHome') cat.raw = info.raw;
    if (cat.state === 'closed' || cat.pending) return;
    if (info.raw && cat.res) { catRebuild(); drawCatalog(); catRefocus(); }
    else loadCatalog(cat.run, true);      /* no fresh data in time: read again (the core already dropped its cache) */
  }
  /* focus goes to the card's "Added" line when nothing else holds it (the pop-up gives it back itself) */
  function catRefocus() {
    var pid = cat.focusAdded;
    if (!pid) return;
    var ae = document.activeElement;
    if (ae && ae !== document.body && ae !== document.documentElement && ae.isConnected) return;
    var t = catFind('[data-mkp-added="' + catEsc(pid) + '"]');
    if (!t) return;
    cat.focusAdded = null;
    try { t.focus({ preventScroll: false }); } catch (e) { /* ignore */ }
  }

  /* ------------------------------------------------------------------ */
  /* wiring                                                                */
  /* ------------------------------------------------------------------ */
  var api = {
    version: VERSION,
    handoff: handoff,
    navigate: function (url) { window.location.assign(url); },
    state: function () {
      return { status: status, subscriptionId: st && st.model ? st.model.main.id : null, hasPanel: !!document.getElementById('mk-home'),
        combinePrompt: !!(st && st.combine), upcoming: up.state, date: dt ? dt.phase : 'closed', dateNote: dateNote ? dateNote.kind : null,
        catalog: cat.state };
    },
    openUpcoming: function () {
      try { return openUpcoming(); } catch (e) { return false; }
    },
    /* false when DECISION_UPCOMING.enabled is off: the menu then hides its "Upcoming orders" item */
    upcomingEnabled: upcomingOn(),
    closeUpcoming: closeUpcoming,
    /* r10, "Add products" (nav 1.2.0 calls these; all optional for it) */
    openCatalog: function () {
      try { return openCatalog(); } catch (e) { return false; }
    },
    closeCatalog: function () {
      try { return closeCatalog(); } catch (e) { return false; }
    },
    /* false when the loader's mk_portal_catalog is not exactly true or DECISION_CATALOG.enabled is off: no menu item */
    catalogEnabled: catalogOn(),
    prefetchCatalog: function () {
      try { return catWarm(); } catch (e) { return false; }
    },
    /* pure builders for tests: "Your subscriptions" rows and the Upcoming orders model */
    models: Object.freeze({
      subsList: function (raw, mainId, opts) { return subsList(raw, mainId, opts); },
      upcoming: function (raw, opts) { return upcomingModel(raw, opts); },
      dateGate: function (raw, subId, opts) { return dateGateFor(raw, subId, opts); },
      /* r10: the catalogue model of one mkHome answer and Skio's product list, and Skio's offer rules for one product and
         one subscription (ctx = {siteCurrency, byInterval, now?}) */
      catalog: function (raw, products, opts) { return catalogModel(raw, products, opts); },
      catOffer: function (product, sub, ctx) { return catOffer(product, sub, ctx || {}); },
      /* r10 part 2: the orders the Add pop-up offers for one item of models.catalog() (soonest first) */
      catPops: function (item, model) { return catPops(item, model); }
    }),
    /* the Combine card's decision for one query answer (pure, for tests): {ids, key} | null */
    combineCheck: function (res, mainId, cfg) { try { return combineCheck(res, mainId, cfg); } catch (e) { return null; } }
  };
  window.MKPortalHome = api;

  M.onRoute(M.guard(function (r) {
    if (r.page !== 'subscriptions') { nativeMode = false; if (status !== 'idle') stopHome('idle'); }
    consumeIntent(r);
    if (r.page === 'subscriptions') startHome();
    /* Upcoming orders: only on this page; a back/forward-cache restore re-announces the route
       (the core dropped its cache): an open screen reloads its data */
    if (r.page !== 'subscriptions') { if (up.state !== 'closed' || up.pending) teardownUpcoming('route'); }
    else if (up.state !== 'closed' && up.state !== 'loading') loadUpcoming(up.run);
    else syncUpcoming();
    /* r10: "Add products", the same rules (one screen at a time: the hash decides which) */
    if (r.page !== 'subscriptions') { if (cat.state !== 'closed' || cat.pending) teardownCatalog('route'); }
    else if (cat.state !== 'closed' && cat.state !== 'loading') loadCatalog(cat.run);
    else syncCatalog();
  }));
})();
